webpackJsonp([1],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArticleCard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArticleCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ArticleCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthorCard__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthorCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AuthorCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChapterSelect__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChapterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChapterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphView__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__GraphView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MapsView__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MapsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MapsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Timeline__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChapterPicker__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChapterPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChapterPicker__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ArticleCard___default.a; });
/* unused harmony reexport AuthorCard */
/* unused harmony reexport ChapterSelect */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__CoverImage___default.a; });
/* unused harmony reexport Footer */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__GraphView___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__MapsView___default.a; });
/* unused harmony reexport Timeline */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__ChapterPicker___default.a; });












/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  "data-v-7864214d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(441)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  "data-v-1572e0ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_social_sharing__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_social_sharing__);













__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.lang = 'sr';
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */]).forEach(function (lang) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].locale(lang, __WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */][lang]);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.root = 'https://api.mons.rs';

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_social_sharing___default.a);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  "title": "Europe", "version": "1.1.2", "type": "FeatureCollection", "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth", "copyrightShort": "Natural Earth", "copyrightUrl": "http://www.naturalearthdata.com", "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG:102014" } }, "hc-transform": { "default": { "crs": "+proj=lcc +lat_1=43 +lat_2=62 +lat_0=30 +lon_0=10 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs", "scale": 0.000169255094964, "jsonres": 15.5, "jsonmarginX": -999, "jsonmarginY": 9851.0, "xoffset": -1706316.2597, "yoffset": 4824494.18154 } },
  "features": [{ "type": "Feature", "id": "DK", "properties": { "hc-group": "admin0", "hc-middle-x": 0.19, "hc-middle-y": 0.44, "hc-key": "dk", "hc-a2": "DK", "name": "Denmark", "labelrank": "4", "country-abbrev": "Den.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "DNK", "iso-a2": "DK", "woe-id": "23424796", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[3686, 4530], [3743, 4490], [3764, 4508], [3787, 4471], [3773, 4443], [3724, 4436], [3644, 4481], [3658, 4526], [3686, 4530]]], [[[3536, 4512], [3564, 4499], [3541, 4493], [3513, 4524], [3536, 4512]]], [[[3898, 4549], [3847, 4516], [3831, 4533], [3864, 4557], [3898, 4549]]], [[[3443, 4565], [3482, 4530], [3472, 4501], [3447, 4513], [3443, 4565]]], [[[3616, 4524], [3599, 4467], [3584, 4496], [3635, 4587], [3616, 4524]]], [[[4282, 4636], [4328, 4610], [4317, 4568], [4251, 4596], [4260, 4656], [4282, 4636]]], [[[3217, 4671], [3225, 4667], [3223, 4642], [3210, 4667], [3217, 4671]]], [[[3533, 4717], [3608, 4645], [3599, 4563], [3567, 4550], [3511, 4568], [3458, 4614], [3459, 4642], [3424, 4684], [3533, 4717]]], [[[3899, 4708], [3889, 4727], [3902, 4751], [3914, 4724], [3899, 4708]]], [[[3578, 4795], [3579, 4771], [3562, 4769], [3572, 4800], [3578, 4795]]], [[[3306, 5107], [3300, 5063], [3263, 5028], [3247, 5060], [3264, 5089], [3306, 5107]]], [[[3664, 5214], [3644, 5204], [3639, 5178], [3611, 5196], [3664, 5214]]], [[[3282, 4516], [3255, 4513], [3260, 4582], [3227, 4563], [3225, 4595], [3261, 4584], [3251, 4670], [3201, 4707], [3166, 4708], [3184, 4779], [3216, 4802], [3200, 4855], [3172, 4868], [3178, 4993], [3188, 5027], [3208, 5000], [3249, 4999], [3274, 4971], [3277, 5015], [3312, 5063], [3347, 5035], [3326, 5010], [3362, 5013], [3345, 5088], [3389, 5126], [3417, 5111], [3444, 5148], [3362, 5120], [3338, 5136], [3269, 5107], [3237, 5058], [3245, 5003], [3199, 5057], [3260, 5156], [3385, 5166], [3411, 5189], [3472, 5289], [3508, 5292], [3570, 5336], [3544, 5283], [3563, 5244], [3562, 5187], [3548, 5172], [3519, 5092], [3535, 4992], [3603, 4985], [3632, 4960], [3598, 4893], [3578, 4899], [3563, 4859], [3558, 4910], [3542, 4916], [3513, 4872], [3517, 4805], [3460, 4782], [3487, 4757], [3444, 4736], [3454, 4722], [3395, 4683], [3430, 4613], [3394, 4588], [3434, 4536], [3435, 4494], [3409, 4521], [3384, 4487], [3384, 4487], [3282, 4516]]], [[[3717, 4815], [3747, 4806], [3772, 4741], [3805, 4817], [3779, 4826], [3839, 4872], [3901, 4850], [3884, 4814], [3901, 4753], [3845, 4704], [3842, 4672], [3879, 4649], [3871, 4621], [3837, 4612], [3834, 4545], [3818, 4538], [3838, 4500], [3805, 4457], [3768, 4508], [3790, 4538], [3750, 4596], [3685, 4601], [3656, 4648], [3675, 4656], [3665, 4703], [3634, 4751], [3681, 4753], [3717, 4786], [3717, 4815]]]] } }, { "type": "Feature", "id": "FO", "properties": { "hc-group": "admin0", "hc-middle-x": 0.56, "hc-middle-y": 0.16, "hc-key": "fo", "hc-a2": "FO", "name": "Faroe Islands", "labelrank": "6", "country-abbrev": "Faeroe Is.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "FRO", "iso-a2": "FO", "woe-id": "23424816", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[1151, 6735], [1169, 6717], [1165, 6663], [1146, 6700], [1151, 6735]]], [[[1176, 6812], [1202, 6782], [1190, 6763], [1169, 6796], [1176, 6812]]], [[[1150, 6888], [1163, 6872], [1139, 6859], [1115, 6902], [1150, 6888]]], [[[1158, 6940], [1202, 6846], [1193, 6819], [1166, 6880], [1143, 6903], [1158, 6940]]], [[[1199, 6933], [1230, 6870], [1208, 6857], [1181, 6898], [1172, 6936], [1199, 6933]]], [[[1236, 6908], [1230, 6914], [1227, 6927], [1232, 6941], [1236, 6908]]], [[[1226, 6902], [1222, 6904], [1215, 6942], [1217, 6946], [1226, 6902]]], [[[1254, 6915], [1248, 6943], [1254, 6940], [1257, 6921], [1255, 6914], [1263, 6903], [1246, 6901], [1239, 6895], [1243, 6931], [1254, 6915]]]] } }, { "type": "Feature", "id": "HR", "properties": { "hc-group": "admin0", "hc-middle-x": 0.09, "hc-middle-y": 0.39, "hc-key": "hr", "hc-a2": "HR", "name": "Croatia", "labelrank": "6", "country-abbrev": "Cro.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "HRV", "iso-a2": "HR", "woe-id": "23424843", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[4965, 1080], [4964, 1071], [4945, 1066], [4938, 1078], [4965, 1080]]], [[[5060, 1097], [5137, 1081], [5142, 1075], [5062, 1089], [5060, 1097]]], [[[4924, 1135], [4980, 1143], [5017, 1129], [4944, 1116], [4924, 1135]]], [[[4799, 1153], [4804, 1142], [4785, 1134], [4768, 1148], [4799, 1153]]], [[[4873, 1205], [4915, 1189], [5010, 1189], [4904, 1178], [4834, 1192], [4873, 1205]]], [[[4922, 1243], [4925, 1221], [4841, 1228], [4840, 1250], [4922, 1243]]], [[[4813, 1251], [4834, 1236], [4825, 1233], [4794, 1244], [4813, 1251]]], [[[4621, 1380], [4603, 1384], [4580, 1409], [4607, 1399], [4621, 1380]]], [[[4572, 1425], [4565, 1419], [4550, 1431], [4536, 1450], [4572, 1425]]], [[[4496, 1441], [4573, 1380], [4557, 1376], [4526, 1418], [4496, 1441]]], [[[4482, 1574], [4494, 1578], [4572, 1505], [4495, 1543], [4482, 1574]]], [[[4392, 1569], [4391, 1562], [4374, 1601], [4388, 1593], [4392, 1569]]], [[[4458, 1644], [4474, 1623], [4481, 1604], [4444, 1643], [4458, 1644]]], [[[4398, 1672], [4394, 1585], [4363, 1666], [4381, 1672], [4355, 1720], [4372, 1729], [4398, 1672]]], [[[4412, 1758], [4435, 1713], [4468, 1683], [4386, 1710], [4412, 1758]]], [[[5311, 1013], [5150, 1111], [5070, 1120], [5023, 1159], [5115, 1130], [5161, 1114], [5293, 1053], [5298, 1030], [5311, 1013]]], [[[5272, 2037], [5265, 2001], [5308, 1936], [5313, 1878], [5390, 1853], [5399, 1831], [5332, 1816], [5333, 1734], [5308, 1729], [5259, 1787], [5229, 1777], [5164, 1799], [5120, 1791], [5085, 1763], [5051, 1788], [5030, 1773], [4966, 1787], [4950, 1773], [4893, 1807], [4867, 1774], [4805, 1774], [4781, 1716], [4754, 1721], [4705, 1771], [4662, 1750], [4668, 1659], [4747, 1571], [4775, 1482], [4881, 1385], [4890, 1365], [4976, 1298], [5010, 1291], [5019, 1256], [5062, 1201], [5095, 1184], [5098, 1143], [4981, 1218], [4936, 1263], [4860, 1282], [4742, 1274], [4729, 1323], [4625, 1387], [4544, 1481], [4583, 1510], [4492, 1601], [4491, 1679], [4468, 1723], [4415, 1769], [4362, 1786], [4296, 1624], [4219, 1709], [4192, 1822], [4209, 1816], [4271, 1801], [4286, 1828], [4369, 1822], [4403, 1876], [4428, 1842], [4525, 1818], [4570, 1837], [4542, 1900], [4581, 1934], [4624, 1943], [4625, 2002], [4602, 2023], [4614, 2053], [4734, 2110], [4722, 2143], [4777, 2150], [4851, 2116], [4877, 2075], [4924, 2054], [4959, 2009], [5008, 2009], [5070, 1968], [5138, 1979], [5180, 1971], [5227, 2026], [5272, 2037]]]] } }, { "type": "Feature", "id": "NL", "properties": { "hc-group": "admin0", "hc-middle-x": 0.34, "hc-middle-y": 0.59, "hc-key": "nl", "hc-a2": "NL", "name": "Netherlands", "labelrank": "5", "country-abbrev": "Neth.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "NLD", "iso-a2": "NL", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[2408, 3636], [2399, 3614], [2350, 3647], [2395, 3648], [2408, 3636]]], [[[2593, 4028], [2574, 3998], [2561, 4015], [2588, 4051], [2593, 4028]]], [[[2603, 4061], [2593, 4060], [2613, 4079], [2625, 4085], [2603, 4061]]], [[[2691, 4107], [2652, 4094], [2648, 4104], [2719, 4119], [2691, 4107]]], [[[2776, 4121], [2783, 4117], [2735, 4111], [2734, 4122], [2776, 4121]]], [[[2817, 4118], [2812, 4122], [2827, 4129], [2847, 4126], [2817, 4118]]], [[[2280, 3553], [2316, 3561], [2371, 3536], [2395, 3553], [2437, 3537], [2380, 3495], [2330, 3523], [2285, 3515], [2280, 3553]]], [[[2444, 3537], [2389, 3565], [2367, 3550], [2316, 3574], [2305, 3602], [2372, 3613], [2422, 3559], [2444, 3580], [2400, 3604], [2436, 3629], [2402, 3678], [2414, 3716], [2438, 3721], [2510, 3811], [2565, 3989], [2593, 3969], [2677, 4019], [2717, 4076], [2786, 4101], [2916, 4110], [2993, 4045], [2988, 3965], [2969, 3933], [2959, 3874], [2912, 3874], [2897, 3827], [2945, 3818], [2952, 3754], [2887, 3701], [2910, 3678], [2832, 3644], [2788, 3666], [2751, 3642], [2779, 3594], [2794, 3519], [2766, 3475], [2780, 3452], [2737, 3419], [2761, 3382], [2746, 3338], [2690, 3344], [2723, 3456], [2660, 3498], [2614, 3492], [2581, 3557], [2561, 3534], [2537, 3566], [2511, 3546], [2486, 3564], [2467, 3530], [2444, 3537]], [[2720, 3812], [2735, 3822], [2736, 3825], [2736, 3825], [2736, 3825], [2750, 3836], [2750, 3869], [2717, 3876], [2748, 3862], [2736, 3825], [2736, 3825], [2736, 3825], [2720, 3812], [2720, 3812], [2720, 3812], [2720, 3812], [2670, 3782], [2621, 3817], [2717, 3877], [2712, 3924], [2732, 3940], [2678, 3949], [2676, 4013], [2616, 3976], [2626, 3929], [2657, 3907], [2608, 3887], [2614, 3833], [2591, 3815], [2674, 3776], [2720, 3812], [2720, 3812], [2720, 3812], [2720, 3812]]]] } }, { "type": "Feature", "id": "EE", "properties": { "hc-group": "admin0", "hc-middle-x": 0.60, "hc-middle-y": 0.53, "hc-key": "ee", "hc-a2": "EE", "name": "Estonia", "labelrank": "6", "country-abbrev": "Est.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "EST", "iso-a2": "EE", "woe-id": "23424805", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[5483, 5775], [5469, 5746], [5441, 5761], [5452, 5784], [5483, 5775]]], [[[5440, 5891], [5460, 5893], [5468, 5876], [5435, 5869], [5440, 5891]]], [[[5370, 5868], [5403, 5866], [5426, 5828], [5383, 5810], [5362, 5771], [5337, 5813], [5275, 5835], [5334, 5850], [5348, 5887], [5370, 5868]]], [[[6143, 6139], [6134, 6134], [6119, 6126], [6130, 6125], [6130, 6125], [6131, 6125], [6133, 6126], [6124, 6119], [6106, 6106], [6108, 6072], [6106, 6046], [6102, 6021], [6074, 6020], [6012, 5988], [6005, 5937], [6044, 5907], [6076, 5839], [6106, 5812], [6161, 5739], [6194, 5705], [6159, 5682], [6151, 5595], [6071, 5605], [6022, 5561], [5934, 5617], [5926, 5637], [5861, 5642], [5801, 5677], [5699, 5617], [5669, 5588], [5681, 5651], [5674, 5732], [5642, 5736], [5618, 5688], [5557, 5706], [5535, 5759], [5512, 5760], [5504, 5815], [5545, 5818], [5543, 5838], [5488, 5817], [5479, 5858], [5495, 5879], [5471, 5891], [5470, 5946], [5555, 5992], [5541, 6009], [5694, 6088], [5735, 6082], [5770, 6142], [5882, 6132], [5912, 6141], [5940, 6125], [6095, 6143], [6111, 6169], [6126, 6160], [6143, 6139]]], [[[5280, 5633], [5297, 5662], [5272, 5700], [5306, 5706], [5369, 5757], [5380, 5746], [5417, 5762], [5487, 5731], [5463, 5728], [5448, 5692], [5403, 5642], [5351, 5628], [5342, 5561], [5313, 5556], [5336, 5608], [5280, 5633]]]] } }, { "type": "Feature", "id": "BG", "properties": { "hc-group": "admin0", "hc-middle-x": 0.54, "hc-middle-y": 0.49, "hc-key": "bg", "hc-a2": "BG", "name": "Bulgaria", "labelrank": "4", "country-abbrev": "Bulg.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "BGR", "iso-a2": "BG", "woe-id": "23424771", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[7353, 1794], [7373, 1738], [7359, 1683], [7291, 1678], [7265, 1596], [7264, 1551], [7287, 1467], [7255, 1461], [7212, 1374], [7250, 1382], [7288, 1337], [7352, 1291], [7366, 1265], [7320, 1259], [7271, 1219], [7200, 1259], [7149, 1241], [7136, 1215], [7058, 1175], [7060, 1145], [7026, 1104], [6967, 1083], [7003, 1040], [7004, 992], [6956, 965], [6884, 953], [6831, 918], [6735, 946], [6714, 926], [6671, 941], [6645, 975], [6547, 945], [6462, 882], [6390, 877], [6357, 845], [6313, 844], [6303, 916], [6313, 957], [6262, 1037], [6189, 1058], [6140, 1104], [6170, 1136], [6144, 1181], [6146, 1270], [6192, 1283], [6229, 1382], [6118, 1443], [6066, 1533], [6067, 1588], [6105, 1620], [6108, 1660], [6115, 1666], [6116, 1666], [6193, 1640], [6168, 1606], [6183, 1561], [6264, 1592], [6444, 1587], [6512, 1615], [6610, 1620], [6698, 1611], [6780, 1652], [6838, 1749], [7006, 1837], [7055, 1833], [7089, 1809], [7144, 1825], [7163, 1808], [7199, 1830], [7223, 1793], [7278, 1781], [7353, 1794]]] } }, { "type": "Feature", "id": "ES", "properties": { "hc-group": "admin0", "hc-middle-x": 0.38, "hc-middle-y": 0.53, "hc-key": "es", "hc-a2": "ES", "name": "Spain", "labelrank": "2", "country-abbrev": "Sp.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "ESP", "iso-a2": "ES", "woe-id": "23424950", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[1502, -54], [1511, -71], [1486, -84], [1488, -64], [1502, -54]]], [[[1546, 46], [1554, 23], [1497, -29], [1456, -3], [1495, 44], [1546, 46]]], [[[1936, 261], [1927, 203], [1997, 190], [1929, 81], [1890, 58], [1826, 103], [1806, 154], [1767, 130], [1740, 175], [1879, 250], [1936, 261]]], [[[2150, 269], [2183, 239], [2186, 195], [2124, 231], [2082, 238], [2083, 271], [2150, 269]]], [[[-240, -615], [-227, -613], [-212, -627], [-226, -637], [-240, -615]]], [[[1743, 1010], [1741, 1016], [1746, 1022], [1751, 1009], [1743, 1010]]], [[[-212, -550], [-280, -577], [-390, -461], [-390, -378], [-423, -351], [-410, -302], [-426, -252], [-503, -171], [-621, -134], [-621, -20], [-559, 40], [-533, 84], [-473, 83], [-444, 129], [-481, 131], [-520, 224], [-479, 302], [-423, 324], [-393, 365], [-430, 404], [-449, 478], [-438, 511], [-476, 588], [-361, 562], [-304, 645], [-328, 703], [-262, 740], [-270, 768], [-238, 881], [-249, 936], [-220, 941], [-168, 993], [-134, 993], [-54, 1057], [-122, 1124], [-107, 1176], [-226, 1223], [-257, 1193], [-338, 1204], [-354, 1228], [-457, 1228], [-463, 1252], [-423, 1288], [-441, 1327], [-534, 1320], [-566, 1304], [-596, 1288], [-587, 1350], [-515, 1391], [-569, 1392], [-513, 1429], [-557, 1437], [-523, 1496], [-578, 1477], [-586, 1499], [-540, 1545], [-582, 1564], [-574, 1593], [-606, 1604], [-593, 1640], [-553, 1673], [-514, 1671], [-482, 1695], [-455, 1674], [-372, 1686], [-356, 1731], [-254, 1763], [-154, 1714], [-134, 1675], [75, 1634], [238, 1587], [284, 1556], [443, 1491], [623, 1495], [629, 1468], [712, 1434], [786, 1445], [860, 1392], [909, 1376], [984, 1392], [989, 1363], [1059, 1338], [1034, 1294], [1135, 1241], [1182, 1231], [1213, 1182], [1270, 1188], [1324, 1134], [1370, 1139], [1390, 1120], [1470, 1114], [1478, 1158], [1615, 1104], [1634, 1067], [1645, 1016], [1691, 1033], [1760, 981], [1811, 998], [1848, 968], [1953, 995], [2005, 979], [2032, 944], [1994, 929], [1984, 895], [2004, 842], [1931, 775], [1785, 717], [1727, 667], [1609, 655], [1483, 627], [1414, 570], [1439, 525], [1381, 514], [1313, 426], [1239, 361], [1131, 223], [1138, 92], [1175, 24], [1224, -23], [1143, -71], [1081, -84], [1038, -115], [959, -245], [961, -319], [864, -330], [834, -311], [724, -358], [683, -399], [650, -471], [586, -524], [536, -485], [484, -484], [458, -514], [327, -472], [280, -482], [239, -459], [132, -437], [41, -430], [12, -464], [-40, -480], [-81, -467], [-154, -480], [-207, -551], [-212, -550]]]] } }, { "type": "Feature", "id": "IT", "properties": { "hc-group": "admin0", "hc-middle-x": 0.44, "hc-middle-y": 0.38, "hc-key": "it", "hc-a2": "IT", "name": "Italy", "labelrank": "2", "country-abbrev": "Italy", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "ITA", "iso-a2": "IT", "woe-id": "23424853", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[3951, -735], [3968, -746], [3964, -760], [3941, -747], [3951, -735]]], [[[4632, -225], [4627, -220], [4615, -212], [4628, -199], [4632, -225]]], [[[3101, -59], [3124, -77], [3111, -105], [3098, -75], [3101, -59]]], [[[3088, -62], [3076, -61], [3070, -47], [3089, -36], [3088, -62]]], [[[4361, 430], [4336, 430], [4339, 444], [4362, 437], [4361, 430]]], [[[3108, 525], [3108, 513], [3089, 508], [3096, 526], [3108, 525]]], [[[3570, 1021], [3559, 994], [3500, 1004], [3511, 1022], [3570, 1021]]], [[[4232, 1848], [4234, 1880], [4197, 1904], [4172, 1883], [4130, 1896], [4104, 1856], [3969, 1791], [3987, 1831], [3941, 1798], [3929, 1753], [3956, 1693], [3999, 1657], [3982, 1613], [3951, 1618], [3952, 1515], [3972, 1447], [4046, 1372], [4097, 1349], [4164, 1295], [4243, 1249], [4295, 1134], [4324, 1039], [4355, 983], [4508, 842], [4595, 804], [4666, 801], [4791, 822], [4831, 780], [4776, 731], [4777, 691], [4803, 671], [4934, 618], [5040, 591], [5140, 527], [5263, 487], [5321, 437], [5395, 344], [5373, 247], [5302, 273], [5278, 332], [5239, 378], [5164, 374], [5094, 397], [5054, 427], [5026, 402], [4967, 290], [4976, 256], [4949, 206], [4957, 172], [5012, 157], [5111, 103], [5111, 19], [5133, -6], [5113, -47], [5052, -47], [4988, -111], [5003, -197], [4918, -289], [4904, -348], [4805, -351], [4795, -270], [4825, -257], [4848, -197], [4830, -143], [4905, -111], [4910, -66], [4874, -17], [4845, 89], [4813, 123], [4787, 211], [4743, 268], [4685, 243], [4632, 288], [4582, 305], [4599, 352], [4538, 431], [4446, 398], [4475, 442], [4433, 472], [4389, 467], [4300, 585], [4268, 571], [4211, 594], [4151, 571], [4115, 620], [4058, 632], [4015, 684], [3968, 713], [3946, 762], [3876, 798], [3837, 869], [3780, 903], [3714, 902], [3734, 937], [3690, 992], [3634, 1019], [3644, 1045], [3589, 1053], [3594, 1118], [3570, 1188], [3547, 1214], [3533, 1311], [3500, 1371], [3440, 1384], [3317, 1469], [3212, 1491], [3157, 1458], [3107, 1400], [3093, 1358], [3048, 1329], [2951, 1315], [2947, 1336], [2994, 1398], [2987, 1425], [2929, 1412], [2858, 1449], [2825, 1488], [2823, 1539], [2868, 1577], [2845, 1630], [2803, 1651], [2780, 1703], [2830, 1708], [2885, 1743], [2898, 1787], [2863, 1817], [2860, 1855], [2827, 1879], [2830, 1910], [2876, 1937], [2908, 1923], [2981, 1950], [3039, 1928], [3097, 1988], [3091, 2025], [3166, 2075], [3162, 2022], [3196, 1984], [3243, 1967], [3255, 1898], [3287, 1913], [3272, 1939], [3331, 2036], [3330, 2087], [3365, 2089], [3389, 2031], [3470, 2049], [3486, 2010], [3509, 2022], [3486, 2071], [3495, 2121], [3562, 2101], [3551, 2141], [3567, 2197], [3676, 2170], [3694, 2212], [3737, 2234], [3823, 2232], [3913, 2265], [3895, 2240], [3956, 2154], [4122, 2120], [4216, 2116], [4152, 2046], [4209, 2017], [4176, 1965], [4209, 1955], [4203, 1909], [4269, 1861], [4232, 1848]], [[3995, 1344], [3998, 1370], [3986, 1365], [3979, 1352], [3995, 1344]], [[4013, 764], [4013, 764], [4013, 764], [4013, 764], [4013, 764]]], [[[4478, -359], [4561, -334], [4623, -299], [4666, -313], [4761, -256], [4763, -319], [4702, -424], [4681, -501], [4688, -552], [4748, -640], [4712, -662], [4694, -749], [4551, -718], [4496, -647], [4450, -628], [4404, -635], [4296, -582], [4228, -529], [4153, -506], [4105, -511], [4048, -440], [4064, -380], [4122, -328], [4157, -371], [4202, -322], [4252, -310], [4270, -344], [4366, -378], [4418, -353], [4478, -359]]], [[[3266, -34], [3251, -99], [3213, -132], [3155, -125], [3146, -78], [3104, -26], [3106, 18], [3148, 164], [3115, 173], [3137, 231], [3132, 293], [3100, 371], [3066, 368], [3061, 416], [3084, 469], [3148, 443], [3203, 467], [3307, 568], [3353, 545], [3381, 525], [3369, 495], [3439, 349], [3393, 274], [3417, 221], [3396, 45], [3376, -56], [3315, -32], [3266, -34]]]] } }, { "type": "Feature", "id": "SM", "properties": { "hc-group": "admin0", "hc-middle-x": 0.68, "hc-middle-y": 0.41, "hc-key": "sm", "hc-a2": "SM", "name": "", "labelrank": "6", "country-abbrev": "S.M.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "SMR", "iso-a2": "SM", "woe-id": "23424947", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[3995, 1344], [3979, 1352], [3986, 1365], [3998, 1370], [3995, 1344]]] } }, { "type": "Feature", "id": "VA", "properties": { "hc-group": "admin0", "hc-middle-x": 0.62, "hc-middle-y": 0.44, "hc-key": "va", "hc-a2": "VA", "name": "", "labelrank": "10", "country-abbrev": "Vat.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "VAT", "iso-a2": "VA", "woe-id": "23424986", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[4013, 764], [4013, 764], [4013, 764], [4013, 764], [4013, 764]]] } }, { "type": "Feature", "id": "TR", "properties": { "hc-group": "admin0", "hc-middle-x": 0.62, "hc-middle-y": 0.51, "hc-key": "tr", "hc-a2": "TR", "name": "Turkey", "labelrank": "2", "country-abbrev": "Tur.", "subregion": "Western Asia", "region-wb": "Europe & Central Asia", "iso-a3": "TUR", "iso-a2": "TR", "woe-id": "23424969", "continent": "Asia" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[7048, 641], [7008, 614], [6984, 617], [7031, 663], [7048, 641]]], [[[7377, 872], [7400, 872], [7378, 846], [7356, 860], [7377, 872]]], [[[7026, 1104], [7060, 1145], [7058, 1175], [7136, 1215], [7149, 1241], [7200, 1259], [7271, 1219], [7320, 1259], [7366, 1265], [7367, 1220], [7404, 1176], [7482, 1136], [7608, 1115], [7653, 1117], [7644, 1044], [7562, 1015], [7478, 1025], [7426, 979], [7331, 959], [7321, 909], [7281, 839], [7186, 763], [7178, 732], [7097, 621], [7110, 666], [7091, 700], [7208, 812], [7195, 827], [7137, 795], [7043, 777], [7028, 811], [7081, 892], [7056, 973], [7113, 1024], [7089, 1088], [7026, 1104]]], [[[9732, 429], [9709, 427], [9717, 324], [9732, 308], [9732, 245], [9709, 236], [9731, 170], [9699, 144], [9700, 102], [9638, 110], [9642, 143], [9568, 212], [9628, 325], [9607, 380], [9556, 400], [9498, 327], [9502, 279], [9445, 237], [9287, 266], [9243, 235], [9170, 98], [9163, 32], [9133, 54], [9107, -9], [8982, -55], [8915, -110], [8801, -100], [8689, -21], [8509, 5], [8352, -16], [8335, -55], [8356, -128], [8340, -219], [8301, -212], [8181, -304], [8158, -284], [8099, -292], [8040, -273], [8000, -223], [8004, -185], [7961, -170], [7948, -209], [7892, -205], [7879, -172], [7800, -182], [7811, -212], [7781, -263], [7741, -246], [7754, -221], [7682, -240], [7674, -274], [7600, -284], [7653, -235], [7752, -207], [7737, -175], [7792, -123], [7626, -189], [7594, -180], [7558, -209], [7560, -159], [7597, -159], [7617, -99], [7583, -114], [7568, -76], [7518, -98], [7500, -29], [7450, -20], [7499, 16], [7480, 85], [7391, 80], [7355, 125], [7323, 84], [7232, 113], [7280, 153], [7234, 219], [7268, 237], [7305, 205], [7329, 146], [7417, 196], [7380, 197], [7311, 268], [7348, 280], [7369, 348], [7329, 331], [7324, 377], [7249, 421], [7305, 498], [7291, 525], [7117, 451], [7123, 498], [7103, 589], [7133, 619], [7143, 674], [7201, 751], [7262, 762], [7321, 796], [7363, 765], [7436, 783], [7400, 829], [7479, 841], [7456, 812], [7644, 862], [7687, 862], [7724, 893], [7635, 896], [7672, 943], [7792, 990], [7866, 1032], [7743, 998], [7655, 1041], [7651, 1092], [7679, 1126], [7825, 1139], [7879, 1153], [7902, 1180], [8032, 1178], [8116, 1207], [8142, 1249], [8133, 1281], [8262, 1408], [8278, 1451], [8340, 1507], [8402, 1540], [8471, 1606], [8686, 1658], [8761, 1684], [8797, 1744], [8844, 1737], [8842, 1713], [8888, 1673], [8964, 1661], [9041, 1721], [9086, 1704], [9106, 1660], [9194, 1625], [9215, 1675], [9298, 1682], [9322, 1656], [9449, 1661], [9460, 1698], [9520, 1672], [9616, 1692], [9691, 1735], [9724, 1777], [9732, 1781], [9732, 429]]]] } }, { "type": "Feature", "id": "MT", "properties": { "hc-group": "admin0", "hc-middle-x": 0.67, "hc-middle-y": 0.77, "hc-key": "mt", "hc-a2": "MT", "name": "Malta", "labelrank": "5", "country-abbrev": "Malta", "subregion": "Southern Europe", "region-wb": "Middle East & North Africa", "iso-a3": "MLT", "iso-a2": "MT", "woe-id": "23424897", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[4588, -999], [4533, -992], [4526, -965], [4572, -975], [4588, -999]]], [[[4514, -952], [4492, -948], [4508, -935], [4528, -946], [4514, -952]]]] } }, { "type": "Feature", "id": "FR", "properties": { "hc-group": "admin0", "hc-middle-x": 0.47, "hc-middle-y": 0.47, "hc-key": "fr", "hc-a2": "FR", "name": "France", "labelrank": "2", "country-abbrev": "Fr.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "FRA", "iso-a2": "FR", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[1209, 2125], [1227, 2092], [1216, 2069], [1190, 2121], [1209, 2125]]], [[[1184, 2202], [1214, 2184], [1223, 2170], [1167, 2205], [1184, 2202]]], [[[1077, 2433], [1065, 2431], [1059, 2452], [1077, 2447], [1077, 2433]]], [[[915, 2566], [923, 2556], [890, 2567], [893, 2589], [915, 2566]]], [[[2720, 2051], [2736, 2073], [2835, 2080], [2844, 1995], [2876, 1937], [2830, 1910], [2827, 1879], [2860, 1855], [2863, 1817], [2898, 1787], [2885, 1743], [2830, 1708], [2780, 1703], [2803, 1651], [2845, 1630], [2868, 1577], [2823, 1539], [2825, 1488], [2858, 1449], [2929, 1412], [2987, 1425], [2994, 1398], [2947, 1336], [2951, 1315], [2945, 1307], [2937, 1301], [2931, 1307], [2922, 1295], [2876, 1277], [2872, 1248], [2784, 1209], [2754, 1175], [2770, 1150], [2592, 1113], [2547, 1158], [2487, 1170], [2478, 1211], [2429, 1206], [2454, 1234], [2402, 1241], [2378, 1215], [2324, 1226], [2315, 1252], [2250, 1258], [2231, 1287], [2195, 1284], [2072, 1222], [2010, 1176], [1989, 1130], [1981, 1017], [2005, 979], [1953, 995], [1848, 968], [1811, 998], [1760, 981], [1691, 1033], [1697, 1064], [1634, 1067], [1615, 1104], [1478, 1158], [1470, 1114], [1390, 1120], [1370, 1139], [1324, 1134], [1270, 1188], [1213, 1182], [1182, 1231], [1135, 1241], [1034, 1294], [1059, 1338], [989, 1363], [984, 1392], [1013, 1392], [1059, 1437], [1169, 1739], [1152, 1731], [1216, 1974], [1230, 1995], [1284, 1915], [1291, 1943], [1214, 2039], [1247, 2091], [1256, 2193], [1130, 2285], [1126, 2324], [1083, 2386], [1119, 2448], [1091, 2486], [1101, 2527], [1073, 2513], [1026, 2561], [1060, 2567], [1044, 2600], [981, 2603], [996, 2638], [936, 2634], [860, 2708], [799, 2726], [788, 2753], [700, 2747], [698, 2797], [656, 2833], [733, 2829], [736, 2855], [696, 2895], [737, 2918], [659, 2913], [664, 2956], [711, 2987], [760, 2981], [828, 2994], [845, 2960], [858, 2988], [901, 2967], [920, 3008], [1000, 3002], [1059, 2885], [1137, 2923], [1151, 2890], [1227, 2916], [1224, 2890], [1313, 2887], [1283, 2917], [1297, 2997], [1296, 3054], [1264, 3110], [1258, 3206], [1317, 3176], [1357, 3187], [1384, 3157], [1366, 3140], [1383, 3100], [1447, 3071], [1523, 3053], [1556, 3030], [1633, 3059], [1681, 3063], [1625, 3083], [1659, 3147], [1746, 3178], [1841, 3190], [1906, 3248], [1919, 3273], [1946, 3441], [2022, 3473], [2124, 3485], [2123, 3485], [2129, 3413], [2161, 3376], [2227, 3382], [2244, 3311], [2310, 3281], [2310, 3245], [2377, 3244], [2408, 3217], [2390, 3138], [2443, 3122], [2486, 3135], [2492, 3162], [2529, 3175], [2510, 3129], [2519, 3074], [2536, 3076], [2629, 2982], [2688, 2991], [2719, 2961], [2752, 2975], [2791, 2962], [2819, 2954], [2854, 2877], [2879, 2886], [2960, 2853], [2984, 2871], [3032, 2830], [3085, 2829], [3136, 2805], [3116, 2766], [3059, 2708], [3045, 2634], [3008, 2560], [3016, 2533], [2996, 2470], [3006, 2412], [2964, 2369], [2892, 2392], [2862, 2351], [2897, 2346], [2805, 2247], [2773, 2237], [2768, 2184], [2706, 2139], [2688, 2089], [2704, 2071], [2664, 2007], [2731, 2035], [2720, 2051]], [[1743, 1010], [1751, 1009], [1746, 1022], [1741, 1016], [1743, 1010]]], [[[3204, 798], [3163, 857], [3201, 949], [3285, 996], [3325, 981], [3337, 1073], [3354, 1080], [3367, 1026], [3360, 972], [3377, 942], [3380, 816], [3347, 770], [3346, 698], [3306, 600], [3212, 657], [3241, 695], [3192, 706], [3203, 766], [3169, 777], [3204, 798]]]] } }, { "type": "Feature", "id": "NO", "properties": { "hc-group": "admin0", "hc-middle-x": 0.43, "hc-middle-y": 0.80, "hc-key": "no", "hc-a2": "NO", "name": "Norway", "labelrank": "3", "country-abbrev": "Nor.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "NOR", "iso-a2": "NO", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[2823, 5756], [2848, 5748], [2843, 5737], [2818, 5753], [2823, 5756]]], [[[2800, 5766], [2790, 5779], [2796, 5789], [2803, 5778], [2800, 5766]]], [[[2884, 5781], [2873, 5785], [2877, 5796], [2899, 5793], [2884, 5781]]], [[[2777, 5805], [2777, 5769], [2759, 5778], [2769, 5841], [2777, 5805]]], [[[2778, 5961], [2792, 5938], [2757, 5944], [2763, 5974], [2778, 5961]]], [[[2819, 5951], [2791, 5950], [2785, 5984], [2810, 5991], [2819, 5951]]], [[[2847, 6026], [2842, 5982], [2822, 5979], [2818, 6024], [2847, 6026]]], [[[2789, 6032], [2789, 6009], [2776, 6024], [2782, 6042], [2789, 6032]]], [[[2770, 6105], [2770, 6070], [2748, 6098], [2755, 6142], [2770, 6105]]], [[[2764, 6164], [2782, 6157], [2786, 6132], [2759, 6160], [2764, 6164]]], [[[2744, 6285], [2757, 6268], [2750, 6265], [2737, 6285], [2744, 6285]]], [[[2734, 6314], [2729, 6303], [2722, 6324], [2730, 6330], [2734, 6314]]], [[[2758, 6346], [2771, 6338], [2743, 6323], [2745, 6350], [2758, 6346]]], [[[2782, 6565], [2805, 6551], [2775, 6531], [2760, 6550], [2782, 6565]]], [[[2800, 6596], [2811, 6592], [2802, 6572], [2789, 6604], [2800, 6596]]], [[[2893, 6675], [2901, 6648], [2869, 6646], [2873, 6674], [2893, 6675]]], [[[2880, 6686], [2899, 6693], [2896, 6683], [2868, 6687], [2880, 6686]]], [[[2943, 6687], [2915, 6661], [2907, 6693], [2927, 6711], [2943, 6687]]], [[[2964, 6713], [2978, 6701], [2947, 6703], [2938, 6713], [2964, 6713]]], [[[3061, 6794], [3062, 6784], [3029, 6773], [3032, 6794], [3061, 6794]]], [[[3050, 6830], [3065, 6830], [3059, 6806], [3046, 6817], [3050, 6830]]], [[[3200, 6891], [3183, 6874], [3169, 6884], [3176, 6896], [3200, 6891]]], [[[3168, 6874], [3147, 6853], [3131, 6886], [3153, 6875], [3168, 6874]]], [[[3253, 6915], [3238, 6915], [3235, 6931], [3244, 6931], [3253, 6915]]], [[[3237, 6913], [3214, 6907], [3203, 6920], [3223, 6938], [3237, 6913]]], [[[3227, 6967], [3188, 6977], [3215, 7006], [3238, 6981], [3227, 6967]]], [[[3321, 7101], [3324, 7076], [3313, 7067], [3257, 7062], [3321, 7101]]], [[[3651, 7346], [3663, 7333], [3660, 7319], [3649, 7325], [3651, 7346]]], [[[3633, 7339], [3658, 7299], [3628, 7308], [3615, 7351], [3633, 7339]]], [[[3648, 7351], [3644, 7336], [3627, 7357], [3642, 7363], [3648, 7351]]], [[[3629, 7427], [3613, 7424], [3581, 7411], [3614, 7439], [3629, 7427]]], [[[3580, 7414], [3570, 7409], [3576, 7431], [3617, 7446], [3580, 7414]]], [[[3699, 7488], [3672, 7467], [3667, 7471], [3675, 7487], [3699, 7488]]], [[[3759, 7501], [3747, 7473], [3727, 7478], [3750, 7520], [3759, 7501]]], [[[3773, 7608], [3785, 7573], [3736, 7520], [3740, 7562], [3773, 7608]]], [[[3716, 7662], [3713, 7631], [3693, 7638], [3701, 7661], [3716, 7662]]], [[[3809, 7748], [3780, 7719], [3765, 7722], [3777, 7749], [3809, 7748]]], [[[3791, 7809], [3797, 7789], [3783, 7773], [3755, 7758], [3791, 7809]]], [[[3814, 7846], [3823, 7829], [3809, 7822], [3803, 7832], [3814, 7846]]], [[[3830, 7885], [3824, 7862], [3812, 7870], [3813, 7887], [3830, 7885]]], [[[3971, 8096], [3969, 8064], [3943, 8083], [3950, 8101], [3971, 8096]]], [[[3984, 8190], [3983, 8182], [3965, 8175], [3980, 8195], [3984, 8190]]], [[[4054, 8360], [4075, 8347], [4039, 8341], [4039, 8358], [4054, 8360]]], [[[4072, 8359], [4062, 8358], [4059, 8367], [4066, 8380], [4072, 8359]]], [[[3826, 8372], [3831, 8341], [3794, 8296], [3813, 8365], [3826, 8372]]], [[[3859, 8374], [3843, 8351], [3835, 8373], [3863, 8394], [3859, 8374]]], [[[4024, 8439], [4013, 8439], [4022, 8456], [4030, 8450], [4024, 8439]]], [[[3950, 8456], [3946, 8436], [3940, 8449], [3930, 8460], [3950, 8456]]], [[[3920, 8440], [3929, 8414], [3900, 8406], [3887, 8379], [3868, 8396], [3868, 8430], [3920, 8440]]], [[[4049, 8500], [4009, 8443], [3948, 8407], [3978, 8458], [3965, 8474], [3993, 8493], [4049, 8500]]], [[[4187, 8508], [4154, 8495], [4161, 8532], [4178, 8540], [4187, 8508]]], [[[4004, 8514], [3985, 8532], [4029, 8533], [4018, 8515], [4004, 8514]]], [[[4255, 8614], [4227, 8601], [4226, 8616], [4242, 8644], [4255, 8614]]], [[[4265, 8646], [4263, 8664], [4288, 8650], [4267, 8626], [4265, 8646]]], [[[4018, 8630], [4005, 8632], [4008, 8645], [4017, 8645], [4018, 8630]]], [[[4174, 8672], [4190, 8672], [4192, 8647], [4157, 8669], [4174, 8672]]], [[[4280, 8687], [4273, 8700], [4282, 8716], [4293, 8708], [4280, 8687]]], [[[4108, 8681], [4067, 8660], [4079, 8704], [4131, 8772], [4131, 8720], [4108, 8681]]], [[[4402, 8972], [4427, 8934], [4405, 8912], [4411, 8885], [4347, 8859], [4324, 8875], [4355, 8879], [4340, 8913], [4355, 8940], [4400, 8943], [4402, 8972]]], [[[4594, 8976], [4583, 8973], [4580, 9002], [4595, 9008], [4594, 8976]]], [[[5553, 9194], [5561, 9190], [5528, 9163], [5532, 9212], [5553, 9194]]], [[[4490, 8977], [4471, 8969], [4472, 8994], [4504, 9015], [4490, 8977]]], [[[4616, 9050], [4630, 9045], [4617, 9023], [4596, 9036], [4616, 9050]]], [[[4434, 9036], [4474, 9017], [4462, 8968], [4435, 8949], [4388, 8992], [4397, 9014], [4434, 9036]]], [[[4391, 9028], [4409, 9033], [4384, 9003], [4379, 9041], [4391, 9028]]], [[[4606, 9062], [4599, 9059], [4596, 9083], [4607, 9071], [4606, 9062]]], [[[4467, 9047], [4447, 9050], [4446, 9063], [4454, 9064], [4467, 9047]]], [[[4592, 9071], [4576, 9048], [4553, 9062], [4568, 9105], [4594, 9096], [4592, 9071]]], [[[4425, 9091], [4432, 9055], [4420, 9048], [4408, 9057], [4425, 9091]]], [[[4476, 9096], [4491, 9074], [4528, 9061], [4496, 9041], [4471, 9086], [4476, 9096]]], [[[4683, 9132], [4676, 9137], [4675, 9169], [4684, 9161], [4683, 9132]]], [[[4774, 9185], [4804, 9172], [4813, 9150], [4754, 9152], [4753, 9181], [4774, 9185]]], [[[4843, 9269], [4867, 9228], [4848, 9178], [4821, 9162], [4791, 9208], [4843, 9269]]], [[[4869, 9303], [4905, 9283], [4873, 9246], [4852, 9298], [4869, 9303]]], [[[4876, 9399], [4883, 9370], [4863, 9379], [4864, 9402], [4876, 9399]]], [[[4940, 9438], [4944, 9418], [4926, 9424], [4933, 9441], [4940, 9438]]], [[[5023, 9477], [5051, 9449], [5083, 9441], [5024, 9405], [4993, 9434], [5023, 9477]]], [[[1712, 9534], [1697, 9493], [1622, 9482], [1587, 9453], [1577, 9474], [1647, 9502], [1675, 9535], [1712, 9534]]], [[[2837, 6137], [2847, 6128], [2861, 6143], [2864, 6225], [2838, 6190], [2804, 6173], [2756, 6246], [2808, 6216], [2808, 6249], [2774, 6257], [2774, 6317], [2832, 6307], [2898, 6331], [2951, 6306], [2999, 6341], [3049, 6311], [3103, 6327], [3106, 6341], [3048, 6320], [2986, 6367], [2975, 6324], [2939, 6346], [2852, 6338], [2825, 6323], [2809, 6354], [2778, 6366], [2772, 6425], [2831, 6461], [2782, 6487], [2782, 6518], [2834, 6545], [2839, 6563], [2889, 6540], [2997, 6528], [2848, 6572], [2810, 6563], [2834, 6599], [2804, 6641], [2820, 6655], [2854, 6608], [2853, 6645], [2921, 6644], [2937, 6675], [3031, 6713], [2977, 6718], [3009, 6739], [2972, 6738], [2981, 6761], [3020, 6745], [3043, 6771], [3086, 6769], [3142, 6735], [3144, 6774], [3186, 6789], [3226, 6784], [3219, 6802], [3125, 6778], [3116, 6795], [3070, 6791], [3065, 6852], [3114, 6874], [3143, 6843], [3207, 6860], [3223, 6899], [3256, 6854], [3254, 6831], [3293, 6829], [3234, 6900], [3284, 6904], [3282, 6916], [3268, 6913], [3248, 6934], [3277, 6938], [3279, 6933], [3276, 6952], [3314, 6967], [3323, 6991], [3380, 6970], [3367, 7013], [3438, 7053], [3472, 6989], [3455, 6960], [3491, 6959], [3490, 6992], [3517, 7000], [3583, 6986], [3598, 7001], [3566, 7025], [3612, 7076], [3668, 7101], [3620, 7126], [3671, 7165], [3640, 7169], [3602, 7143], [3617, 7110], [3596, 7079], [3532, 7034], [3467, 7015], [3451, 7067], [3481, 7094], [3418, 7059], [3418, 7091], [3503, 7139], [3469, 7145], [3499, 7216], [3555, 7265], [3555, 7291], [3591, 7298], [3599, 7336], [3626, 7290], [3653, 7276], [3670, 7328], [3654, 7368], [3710, 7397], [3684, 7402], [3717, 7441], [3664, 7398], [3633, 7401], [3653, 7431], [3707, 7452], [3725, 7476], [3747, 7468], [3802, 7496], [3840, 7559], [3789, 7501], [3768, 7537], [3803, 7582], [3793, 7633], [3773, 7616], [3765, 7646], [3815, 7745], [3843, 7777], [3805, 7768], [3823, 7796], [3901, 7831], [3954, 7833], [3906, 7846], [3842, 7816], [3875, 7848], [3836, 7863], [3856, 7880], [3862, 7946], [3889, 7960], [3894, 7999], [3925, 8002], [3898, 8039], [3971, 8056], [3984, 8110], [4032, 8130], [4047, 8109], [4068, 8132], [4100, 8120], [4110, 8135], [4064, 8142], [4074, 8162], [4019, 8130], [4019, 8148], [3979, 8135], [4013, 8192], [4034, 8179], [4058, 8201], [4020, 8211], [4051, 8236], [4106, 8209], [4149, 8246], [4108, 8224], [4081, 8226], [4071, 8262], [4114, 8296], [4088, 8311], [4030, 8258], [4023, 8284], [4048, 8291], [4021, 8312], [4043, 8335], [4077, 8336], [4131, 8359], [4149, 8378], [4143, 8378], [4136, 8369], [4120, 8376], [4106, 8379], [4072, 8380], [4095, 8411], [4142, 8414], [4143, 8449], [4160, 8428], [4157, 8385], [4183, 8343], [4187, 8376], [4208, 8350], [4209, 8385], [4190, 8403], [4197, 8447], [4164, 8472], [4214, 8458], [4169, 8483], [4220, 8504], [4236, 8481], [4313, 8520], [4310, 8551], [4258, 8516], [4201, 8512], [4206, 8574], [4269, 8615], [4315, 8661], [4285, 8660], [4307, 8721], [4347, 8749], [4335, 8783], [4360, 8847], [4398, 8795], [4432, 8809], [4379, 8837], [4379, 8860], [4415, 8874], [4438, 8829], [4476, 8818], [4476, 8781], [4494, 8783], [4475, 8829], [4454, 8825], [4426, 8878], [4434, 8933], [4453, 8950], [4503, 8963], [4497, 8924], [4518, 8910], [4514, 8952], [4528, 8955], [4537, 9010], [4565, 8998], [4562, 8851], [4539, 8804], [4572, 8846], [4587, 8905], [4581, 8963], [4644, 9005], [4660, 9055], [4723, 9003], [4718, 9051], [4704, 9071], [4669, 9076], [4632, 9106], [4666, 9144], [4703, 9099], [4692, 9135], [4736, 9150], [4749, 9138], [4812, 9136], [4828, 9084], [4863, 9066], [4880, 9092], [4839, 9106], [4860, 9124], [4842, 9148], [4868, 9173], [4858, 9194], [4891, 9245], [4932, 9245], [4908, 9261], [4923, 9308], [4953, 9294], [4939, 9329], [4913, 9329], [4917, 9362], [4944, 9340], [4936, 9401], [4987, 9394], [5005, 9357], [5018, 9381], [5061, 9402], [5068, 9391], [5007, 9267], [5022, 9278], [5032, 9211], [5015, 9183], [5022, 9138], [5040, 9142], [5067, 9216], [5053, 9221], [5092, 9324], [5092, 9351], [5111, 9405], [5136, 9438], [5151, 9400], [5149, 9363], [5123, 9338], [5155, 9343], [5159, 9257], [5203, 9350], [5195, 9385], [5226, 9426], [5181, 9438], [5201, 9450], [5186, 9473], [5220, 9459], [5211, 9501], [5245, 9491], [5272, 9513], [5278, 9486], [5314, 9491], [5314, 9454], [5298, 9425], [5252, 9415], [5293, 9408], [5255, 9357], [5312, 9402], [5312, 9374], [5284, 9325], [5323, 9308], [5342, 9231], [5329, 9315], [5333, 9413], [5347, 9465], [5372, 9475], [5414, 9455], [5416, 9427], [5455, 9448], [5454, 9414], [5477, 9450], [5582, 9386], [5590, 9401], [5620, 9356], [5571, 9330], [5547, 9266], [5450, 9255], [5399, 9256], [5388, 9238], [5508, 9223], [5489, 9196], [5519, 9206], [5527, 9154], [5560, 9161], [5576, 9184], [5564, 9210], [5601, 9202], [5638, 9209], [5659, 9172], [5664, 9128], [5628, 9120], [5599, 9138], [5597, 9081], [5581, 9050], [5529, 9010], [5532, 8960], [5509, 8926], [5490, 8946], [5485, 8979], [5515, 9065], [5476, 9121], [5392, 9139], [5361, 9160], [5320, 9205], [5290, 9182], [5252, 9135], [5225, 9140], [5190, 9125], [5173, 9058], [5157, 9048], [5153, 8993], [5162, 8948], [5159, 8892], [5178, 8840], [5171, 8799], [5127, 8767], [5129, 8714], [5106, 8686], [5079, 8712], [5041, 8717], [4991, 8740], [4976, 8706], [4923, 8666], [4900, 8683], [4835, 8679], [4823, 8711], [4776, 8761], [4725, 8830], [4687, 8832], [4662, 8795], [4680, 8769], [4669, 8753], [4635, 8767], [4625, 8745], [4570, 8732], [4600, 8702], [4600, 8626], [4575, 8586], [4608, 8572], [4579, 8529], [4475, 8562], [4432, 8556], [4406, 8575], [4379, 8560], [4391, 8447], [4367, 8387], [4298, 8421], [4246, 8357], [4219, 8248], [4188, 8230], [4182, 8204], [4224, 8141], [4225, 8096], [4186, 8043], [4149, 7954], [4123, 7920], [4134, 7856], [4086, 7816], [4024, 7804], [4042, 7721], [4035, 7678], [4036, 7564], [4015, 7494], [3940, 7341], [4002, 7302], [4012, 7233], [3986, 7174], [3894, 7193], [3825, 7151], [3762, 7043], [3767, 7001], [3741, 6952], [3774, 6868], [3759, 6845], [3767, 6790], [3760, 6746], [3794, 6644], [3777, 6495], [3814, 6454], [3841, 6445], [3880, 6395], [3857, 6297], [3797, 6278], [3816, 6212], [3850, 6144], [3836, 6080], [3842, 6028], [3790, 5963], [3748, 5954], [3756, 5924], [3725, 5862], [3747, 5773], [3727, 5677], [3695, 5669], [3693, 5697], [3682, 5728], [3612, 5755], [3600, 5745], [3566, 5820], [3574, 5870], [3560, 5908], [3573, 5946], [3555, 5954], [3549, 5910], [3565, 5863], [3549, 5847], [3547, 5769], [3531, 5776], [3524, 5734], [3471, 5685], [3431, 5685], [3368, 5649], [3395, 5649], [3249, 5484], [3226, 5481], [3190, 5441], [3177, 5477], [3158, 5436], [3106, 5419], [3017, 5426], [2946, 5455], [2973, 5484], [2870, 5537], [2865, 5560], [2827, 5578], [2797, 5647], [2813, 5729], [2839, 5695], [2883, 5686], [2862, 5740], [2921, 5792], [2897, 5830], [2835, 5805], [2825, 5838], [2806, 5799], [2767, 5869], [2816, 5932], [2853, 5912], [2876, 5935], [2841, 5964], [2890, 5991], [2919, 6065], [2984, 6134], [2928, 6105], [2878, 6052], [2875, 6012], [2850, 6018], [2855, 6053], [2837, 6076], [2815, 6056], [2787, 6072], [2784, 6124], [2805, 6163], [2820, 6150], [2808, 6168], [2862, 6203], [2857, 6144], [2837, 6137]]], [[[3351, 7049], [3352, 7056], [3362, 7056], [3368, 7050], [3353, 7046], [3369, 7031], [3280, 6993], [3251, 7003], [3287, 7042], [3342, 7057], [3351, 7049]]], [[[4021, 8662], [4042, 8649], [4054, 8642], [4064, 8566], [4036, 8541], [4007, 8557], [4044, 8579], [4041, 8595], [3986, 8552], [3957, 8569], [3990, 8595], [4025, 8605], [4021, 8662]]], [[[4773, 9266], [4803, 9297], [4786, 9313], [4816, 9315], [4819, 9336], [4816, 9285], [4784, 9234], [4713, 9205], [4726, 9247], [4694, 9238], [4726, 9274], [4773, 9266]]], [[[4199, 8593], [4192, 8544], [4150, 8536], [4140, 8493], [4115, 8501], [4104, 8462], [4073, 8476], [4050, 8462], [4035, 8461], [4061, 8507], [4055, 8538], [4084, 8562], [4073, 8614], [4091, 8659], [4119, 8663], [4119, 8609], [4133, 8605], [4118, 8557], [4146, 8599], [4158, 8649], [4180, 8635], [4199, 8593]]], [[[4220, 8743], [4241, 8781], [4218, 8805], [4266, 8805], [4276, 8820], [4250, 8833], [4254, 8851], [4291, 8832], [4307, 8874], [4333, 8847], [4341, 8804], [4323, 8792], [4334, 8751], [4284, 8737], [4215, 8700], [4238, 8726], [4220, 8743]]]] } }, { "type": "Feature", "id": "DE", "properties": { "hc-group": "admin0", "hc-middle-x": 0.47, "hc-middle-y": 0.53, "hc-key": "de", "hc-a2": "DE", "name": "Germany", "labelrank": "2", "country-abbrev": "Ger.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "DEU", "iso-a2": "DE", "woe-id": "23424829", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[3422, 2394], [3345, 2433], [3297, 2473], [3318, 2430], [3264, 2425], [3205, 2468], [3164, 2431], [3174, 2408], [3006, 2412], [2996, 2470], [3016, 2533], [3008, 2560], [3045, 2634], [3059, 2708], [3116, 2766], [3136, 2805], [3085, 2829], [3032, 2830], [2984, 2871], [2960, 2853], [2879, 2886], [2854, 2877], [2819, 2954], [2791, 2962], [2825, 3058], [2774, 3087], [2759, 3155], [2765, 3182], [2809, 3209], [2804, 3257], [2779, 3261], [2778, 3297], [2746, 3338], [2761, 3382], [2737, 3419], [2780, 3452], [2766, 3475], [2794, 3519], [2779, 3594], [2751, 3642], [2788, 3666], [2832, 3644], [2910, 3678], [2887, 3701], [2952, 3754], [2945, 3818], [2897, 3827], [2912, 3874], [2959, 3874], [2969, 3933], [2988, 3965], [2993, 4045], [3013, 4070], [2965, 4084], [2978, 4144], [3003, 4166], [3128, 4178], [3163, 4128], [3144, 4114], [3169, 4087], [3189, 4115], [3179, 4143], [3231, 4125], [3218, 4165], [3235, 4214], [3283, 4206], [3343, 4213], [3309, 4223], [3280, 4265], [3282, 4328], [3250, 4334], [3247, 4367], [3286, 4374], [3312, 4400], [3259, 4467], [3255, 4513], [3282, 4516], [3384, 4487], [3384, 4487], [3408, 4503], [3483, 4447], [3481, 4410], [3608, 4345], [3659, 4353], [3658, 4307], [3605, 4266], [3628, 4244], [3677, 4260], [3725, 4229], [3731, 4256], [3770, 4302], [3833, 4308], [3872, 4347], [3897, 4397], [3961, 4368], [3987, 4389], [4002, 4345], [4064, 4296], [4103, 4313], [4119, 4289], [4122, 4320], [4193, 4256], [4187, 4247], [4192, 4239], [4137, 4226], [4146, 4291], [4124, 4280], [4141, 4255], [4127, 4235], [4157, 4207], [4206, 4188], [4238, 4067], [4231, 4002], [4198, 3974], [4196, 3943], [4292, 3870], [4276, 3824], [4307, 3777], [4322, 3727], [4295, 3647], [4322, 3611], [4327, 3566], [4367, 3549], [4385, 3489], [4354, 3378], [4318, 3372], [4293, 3419], [4256, 3423], [4269, 3379], [4136, 3323], [4109, 3288], [4070, 3282], [4030, 3255], [3940, 3221], [3900, 3155], [3860, 3197], [3894, 3121], [3947, 3082], [3923, 3034], [4004, 2918], [4043, 2910], [4079, 2860], [4139, 2811], [4163, 2815], [4205, 2765], [4189, 2693], [4151, 2710], [4132, 2649], [4062, 2613], [4008, 2569], [4059, 2492], [4041, 2456], [4066, 2454], [4072, 2390], [4021, 2406], [4016, 2438], [3965, 2426], [3902, 2446], [3900, 2416], [3794, 2409], [3724, 2353], [3670, 2350], [3632, 2385], [3558, 2401], [3566, 2362], [3538, 2323], [3467, 2387], [3422, 2394]], [[3343, 4213], [3357, 4210], [3357, 4210], [3357, 4210], [3357, 4210], [3403, 4138], [3374, 4205], [3357, 4210], [3357, 4210], [3357, 4210], [3357, 4210], [3354, 4215], [3343, 4213]]], [[[3731, 4262], [3727, 4247], [3711, 4250], [3726, 4265], [3731, 4262]]], [[[3291, 4389], [3278, 4399], [3284, 4404], [3304, 4405], [3291, 4389]]], [[[3688, 4393], [3698, 4374], [3646, 4389], [3665, 4409], [3688, 4393]]], [[[4044, 4454], [4086, 4437], [4077, 4404], [4111, 4369], [4066, 4367], [4028, 4339], [4002, 4362], [4024, 4377], [4008, 4423], [4044, 4454]]], [[[3239, 4455], [3210, 4462], [3221, 4473], [3236, 4473], [3239, 4455]]], [[[3210, 4514], [3193, 4513], [3208, 4554], [3204, 4535], [3210, 4514]]], [[[3319, 2429], [3321, 2426], [3321, 2426], [3319, 2429]]]] } }, { "type": "Feature", "id": "IE", "properties": { "hc-group": "admin0", "hc-middle-x": 0.61, "hc-middle-y": 0.60, "hc-key": "ie", "hc-a2": "IE", "name": "Ireland", "labelrank": "3", "country-abbrev": "Ire.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "IRL", "iso-a2": "IE", "woe-id": "23424803", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[135, 4725], [124, 4687], [114, 4713], [82, 4730], [135, 4725]]], [[[746, 4592], [766, 4559], [727, 4568], [735, 4525], [725, 4463], [742, 4439], [725, 4388], [719, 4263], [663, 4188], [656, 4154], [613, 4108], [605, 4057], [529, 4093], [512, 4071], [418, 4086], [382, 4055], [338, 4055], [299, 4028], [255, 4032], [161, 3989], [135, 4002], [56, 3997], [36, 4014], [-44, 4006], [16, 4039], [29, 4070], [-68, 4058], [-72, 4082], [1, 4110], [-65, 4105], [-114, 4157], [-78, 4178], [-14, 4185], [-5, 4200], [-102, 4220], [-96, 4241], [-38, 4256], [9, 4227], [26, 4264], [10, 4280], [61, 4287], [79, 4310], [137, 4294], [196, 4300], [197, 4332], [162, 4301], [95, 4324], [45, 4325], [112, 4353], [151, 4397], [130, 4404], [181, 4452], [237, 4436], [245, 4471], [130, 4499], [143, 4528], [92, 4528], [114, 4544], [74, 4553], [62, 4608], [121, 4610], [123, 4652], [182, 4646], [190, 4674], [130, 4679], [153, 4697], [142, 4783], [178, 4806], [276, 4765], [279, 4723], [304, 4760], [397, 4731], [372, 4762], [448, 4791], [481, 4819], [390, 4835], [376, 4862], [424, 4888], [462, 4881], [447, 4915], [493, 4969], [574, 4962], [602, 4975], [614, 4903], [622, 4975], [655, 4972], [651, 4996], [711, 4932], [652, 4902], [622, 4890], [581, 4822], [532, 4831], [538, 4795], [459, 4770], [496, 4684], [576, 4637], [639, 4710], [662, 4684], [668, 4641], [690, 4626], [685, 4588], [746, 4592]]]] } }, { "type": "Feature", "id": "UA", "properties": { "hc-group": "admin0", "hc-middle-x": 0.58, "hc-middle-y": 0.41, "hc-key": "ua", "hc-a2": "UA", "name": "Ukraine", "labelrank": "3", "country-abbrev": "Ukr.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "UKR", "iso-a2": "UA", "woe-id": "23424976", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[7455, 2386], [7493, 2450], [7501, 2459], [7470, 2406], [7455, 2386]]], [[[7966, 2676], [7994, 2681], [8031, 2696], [8047, 2688], [7966, 2676]]], [[[7864, 2673], [7779, 2665], [7752, 2669], [7846, 2675], [7864, 2673]]], [[[5798, 2837], [5793, 2890], [5819, 2928], [5819, 2970], [5841, 3040], [5904, 3029], [5867, 3073], [5861, 3130], [5837, 3173], [5900, 3310], [5994, 3455], [6035, 3467], [6051, 3510], [6010, 3586], [6038, 3595], [5989, 3635], [5976, 3670], [5922, 3719], [5907, 3769], [5926, 3810], [5970, 3801], [6008, 3848], [6025, 3898], [6082, 3911], [6159, 3947], [6262, 3963], [6378, 3967], [6462, 3957], [6519, 3969], [6542, 3930], [6616, 3948], [6634, 3914], [6639, 3956], [6687, 3955], [6704, 3988], [6737, 3959], [6780, 3978], [6813, 3942], [6825, 3992], [6865, 4022], [6918, 3960], [6961, 4007], [7005, 4004], [7053, 4033], [7103, 3994], [7140, 3984], [7149, 4017], [7106, 4084], [7114, 4151], [7144, 4237], [7196, 4244], [7228, 4275], [7278, 4286], [7305, 4275], [7359, 4306], [7358, 4378], [7461, 4389], [7495, 4437], [7544, 4450], [7559, 4434], [7598, 4468], [7657, 4432], [7685, 4375], [7746, 4356], [7755, 4326], [7716, 4303], [7775, 4229], [7767, 4189], [7843, 4209], [7871, 4200], [7929, 4227], [7978, 4187], [8043, 4111], [8032, 4093], [8058, 4058], [8114, 4038], [8131, 4069], [8177, 4085], [8220, 4059], [8238, 4073], [8284, 4059], [8325, 4117], [8405, 4175], [8447, 4151], [8492, 4103], [8559, 4075], [8583, 4097], [8571, 4130], [8675, 4127], [8730, 4116], [8766, 4149], [8806, 4125], [8846, 4141], [8909, 4111], [8957, 4148], [8960, 4107], [9002, 4059], [8986, 3990], [8948, 3965], [8976, 3938], [9015, 3941], [8984, 3894], [8990, 3846], [9021, 3859], [9090, 3791], [9081, 3739], [9100, 3657], [8932, 3589], [8934, 3537], [8873, 3489], [8881, 3393], [8905, 3344], [8790, 3293], [8767, 3220], [8748, 3228], [8710, 3193], [8685, 3138], [8660, 3145], [8577, 3079], [8526, 3055], [8457, 2941], [8432, 2953], [8409, 2894], [8369, 2847], [8405, 2786], [8463, 2728], [8547, 2667], [8583, 2657], [8621, 2681], [8638, 2731], [8673, 2711], [8692, 2749], [8781, 2772], [8770, 2707], [8791, 2664], [8756, 2632], [8717, 2630], [8685, 2601], [8631, 2618], [8538, 2498], [8491, 2476], [8444, 2431], [8433, 2370], [8377, 2301], [8328, 2290], [8246, 2312], [8278, 2340], [8252, 2382], [8259, 2429], [8232, 2470], [8195, 2485], [8168, 2467], [8079, 2498], [8006, 2470], [7998, 2503], [8048, 2572], [8195, 2713], [8166, 2718], [8144, 2762], [8135, 2728], [8065, 2759], [8051, 2728], [7988, 2706], [7938, 2672], [7887, 2672], [7783, 2705], [7811, 2745], [7721, 2746], [7876, 2771], [7896, 2816], [7798, 2795], [7766, 2837], [7766, 2785], [7693, 2768], [7604, 2727], [7565, 2690], [7579, 2673], [7551, 2554], [7503, 2462], [7472, 2461], [7470, 2423], [7440, 2382], [7406, 2436], [7425, 2339], [7451, 2343], [7468, 2301], [7457, 2266], [7445, 2302], [7373, 2312], [7282, 2223], [7186, 2225], [7150, 2258], [7203, 2283], [7190, 2327], [7228, 2391], [7223, 2426], [7259, 2448], [7256, 2502], [7235, 2519], [7222, 2574], [7258, 2609], [7279, 2560], [7319, 2610], [7355, 2583], [7369, 2620], [7405, 2591], [7448, 2613], [7404, 2644], [7384, 2725], [7302, 2743], [7303, 2774], [7273, 2849], [7248, 2829], [7174, 2884], [7170, 2984], [7141, 3008], [7112, 2987], [7070, 3029], [7015, 3026], [6981, 3041], [6926, 3031], [6850, 3073], [6803, 3068], [6749, 3021], [6685, 3015], [6652, 2968], [6596, 2941], [6585, 2873], [6419, 2808], [6400, 2767], [6360, 2740], [6283, 2792], [6223, 2767], [6132, 2776], [6052, 2762], [6000, 2782], [5962, 2732], [5928, 2776], [5901, 2766], [5872, 2803], [5848, 2799], [5824, 2842], [5798, 2837]], [[7457, 2615], [7536, 2553], [7547, 2572], [7470, 2626], [7457, 2615]], [[8226, 2751], [8230, 2774], [8290, 2767], [8336, 2746], [8341, 2716], [8384, 2771], [8375, 2732], [8448, 2722], [8511, 2641], [8573, 2639], [8552, 2659], [8454, 2726], [8380, 2809], [8334, 2833], [8341, 2785], [8309, 2776], [8319, 2817], [8239, 2836], [8226, 2787], [8209, 2801], [8147, 2787], [8226, 2751]]]] } }, { "type": "Feature", "id": "FI", "properties": { "hc-group": "admin0", "hc-middle-x": 0.58, "hc-middle-y": 0.72, "hc-key": "fi", "hc-a2": "FI", "name": "Finland", "labelrank": "3", "country-abbrev": "Fin.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "FIN", "iso-a2": "FI", "woe-id": "23424812", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[4993, 6096], [4976, 6089], [4970, 6088], [4977, 6101], [4993, 6096]]], [[[4992, 6109], [5004, 6120], [5016, 6114], [5011, 6102], [4992, 6109]]], [[[4939, 6118], [4961, 6095], [4955, 6084], [4930, 6101], [4939, 6118]]], [[[4959, 6128], [4966, 6130], [4964, 6111], [4954, 6118], [4959, 6128]]], [[[4873, 6139], [4861, 6117], [4851, 6132], [4858, 6155], [4873, 6139]]], [[[4902, 6194], [4957, 6174], [4947, 6141], [4922, 6163], [4931, 6115], [4891, 6105], [4867, 6158], [4902, 6194]]], [[[5277, 6163], [5280, 6143], [5272, 6140], [5263, 6163], [5277, 6163]]], [[[5158, 6164], [5156, 6153], [5142, 6149], [5147, 6172], [5158, 6164]]], [[[5191, 6183], [5175, 6160], [5167, 6161], [5170, 6182], [5191, 6183]]], [[[5210, 6170], [5199, 6182], [5212, 6195], [5210, 6182], [5210, 6170]]], [[[5722, 6296], [5708, 6311], [5710, 6317], [5727, 6305], [5722, 6296]]], [[[5326, 6209], [5314, 6149], [5284, 6144], [5272, 6198], [5326, 6209]]], [[[5243, 6212], [5215, 6212], [5220, 6227], [5248, 6226], [5243, 6212]]], [[[5261, 6239], [5254, 6226], [5245, 6233], [5256, 6244], [5261, 6239]]], [[[5222, 6241], [5239, 6247], [5240, 6243], [5227, 6236], [5222, 6241]]], [[[5196, 6222], [5169, 6235], [5179, 6259], [5200, 6229], [5196, 6222]]], [[[5114, 6275], [5115, 6255], [5107, 6259], [5095, 6277], [5114, 6275]]], [[[5079, 6373], [5065, 6389], [5072, 6396], [5084, 6386], [5079, 6373]]], [[[4937, 7061], [4954, 7049], [4977, 7043], [4964, 7024], [4937, 7061]]], [[[5064, 7083], [5069, 7094], [5088, 7090], [5076, 7072], [5064, 7083]]], [[[4972, 7074], [4968, 7065], [4954, 7075], [4968, 7088], [4972, 7074]]], [[[5135, 7240], [5138, 7228], [5131, 7222], [5121, 7233], [5135, 7240]]], [[[5322, 7664], [5299, 7629], [5286, 7647], [5295, 7662], [5322, 7664]]], [[[5345, 6190], [5331, 6207], [5327, 6241], [5281, 6204], [5269, 6214], [5287, 6256], [5239, 6250], [5173, 6282], [5163, 6310], [5142, 6267], [5098, 6304], [5093, 6379], [5067, 6421], [5089, 6423], [5097, 6469], [5073, 6573], [5103, 6565], [5073, 6596], [5037, 6676], [5017, 6687], [5013, 6796], [4984, 6806], [4983, 6864], [4964, 6884], [4975, 6939], [5002, 6971], [5001, 7006], [5028, 6998], [4995, 7046], [5044, 7070], [5050, 7045], [5104, 7098], [5073, 7134], [5102, 7148], [5112, 7214], [5146, 7203], [5158, 7255], [5202, 7289], [5195, 7332], [5255, 7403], [5254, 7443], [5289, 7495], [5290, 7539], [5322, 7603], [5356, 7625], [5385, 7602], [5393, 7628], [5369, 7651], [5398, 7650], [5360, 7689], [5364, 7730], [5355, 7797], [5315, 7825], [5266, 7823], [5238, 7871], [5223, 7856], [5191, 7866], [5161, 7928], [5117, 7968], [5095, 8033], [5116, 8076], [5106, 8131], [5115, 8151], [5047, 8242], [5053, 8324], [5012, 8336], [5020, 8369], [4997, 8455], [5012, 8473], [4945, 8521], [4925, 8569], [4893, 8592], [4833, 8607], [4808, 8603], [4787, 8627], [4732, 8654], [4661, 8729], [4625, 8745], [4635, 8767], [4669, 8753], [4680, 8769], [4662, 8795], [4687, 8832], [4725, 8830], [4776, 8761], [4823, 8711], [4835, 8679], [4900, 8683], [4923, 8666], [4976, 8706], [4991, 8740], [5041, 8717], [5079, 8712], [5106, 8686], [5129, 8714], [5127, 8767], [5171, 8799], [5178, 8840], [5159, 8892], [5162, 8948], [5153, 8993], [5157, 9048], [5173, 9058], [5190, 9125], [5225, 9140], [5252, 9135], [5290, 9182], [5320, 9205], [5361, 9160], [5392, 9139], [5476, 9121], [5515, 9065], [5485, 8979], [5490, 8946], [5509, 8926], [5467, 8875], [5508, 8866], [5495, 8771], [5543, 8678], [5621, 8661], [5680, 8597], [5730, 8568], [5735, 8514], [5708, 8441], [5685, 8340], [5696, 8295], [5773, 8209], [5793, 8170], [5847, 8111], [5891, 8036], [5907, 7989], [5863, 7968], [5889, 7883], [5880, 7852], [5913, 7851], [5920, 7819], [5900, 7782], [5939, 7733], [5974, 7739], [6000, 7703], [5979, 7678], [6002, 7628], [6081, 7597], [6094, 7531], [6072, 7463], [6049, 7441], [6136, 7380], [6185, 7369], [6251, 7333], [6261, 7312], [6320, 7265], [6313, 7140], [6287, 7068], [6260, 7026], [6195, 6828], [6171, 6788], [6144, 6709], [6100, 6652], [6036, 6533], [6004, 6463], [5961, 6425], [5915, 6445], [5896, 6417], [5808, 6365], [5760, 6377], [5762, 6313], [5734, 6307], [5718, 6339], [5702, 6300], [5659, 6290], [5659, 6272], [5580, 6239], [5570, 6198], [5551, 6217], [5449, 6162], [5424, 6157], [5404, 6119], [5356, 6102], [5399, 6143], [5377, 6144], [5394, 6176], [5356, 6176], [5346, 6188], [5344, 6176], [5342, 6158], [5333, 6178], [5345, 6190]]]] } }, { "type": "Feature", "id": "SE", "properties": { "hc-group": "admin0", "hc-middle-x": 0.52, "hc-middle-y": 0.34, "hc-key": "se", "hc-a2": "SE", "name": "Sweden", "labelrank": "3", "country-abbrev": "Swe.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "SWE", "iso-a2": "SE", "woe-id": "23424954", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[4581, 5272], [4583, 5238], [4535, 5043], [4529, 4978], [4507, 4942], [4497, 5032], [4523, 5130], [4538, 5137], [4566, 5259], [4581, 5272]]], [[[4891, 5495], [4910, 5490], [4866, 5467], [4871, 5487], [4891, 5495]]], [[[3744, 5428], [3733, 5400], [3712, 5397], [3709, 5423], [3744, 5428]]], [[[3751, 5482], [3754, 5447], [3710, 5435], [3696, 5456], [3732, 5493], [3751, 5482]]], [[[4523, 5546], [4520, 5537], [4508, 5566], [4529, 5555], [4523, 5546]]], [[[4726, 5760], [4721, 5748], [4707, 5740], [4707, 5752], [4726, 5760]]], [[[4703, 5774], [4693, 5756], [4681, 5760], [4687, 5772], [4703, 5774]]], [[[4628, 5737], [4620, 5738], [4617, 5776], [4629, 5757], [4628, 5737]]], [[[4738, 5788], [4732, 5773], [4722, 5779], [4737, 5805], [4738, 5788]]], [[[4740, 5856], [4743, 5848], [4741, 5838], [4713, 5856], [4740, 5856]]], [[[4755, 5930], [4740, 5895], [4731, 5912], [4741, 5929], [4755, 5930]]], [[[4779, 5953], [4788, 5967], [4786, 5948], [4777, 5952], [4779, 5953]]], [[[4790, 6015], [4791, 6010], [4776, 6006], [4783, 6029], [4790, 6015]]], [[[4688, 6191], [4710, 6150], [4685, 6166], [4681, 6205], [4688, 6191]]], [[[4563, 6851], [4572, 6851], [4569, 6834], [4556, 6831], [4563, 6851]]], [[[4889, 7192], [4898, 7199], [4898, 7178], [4891, 7169], [4889, 7192]]], [[[4984, 7737], [4981, 7732], [4983, 7723], [4969, 7739], [4984, 7737]]], [[[5014, 7760], [5021, 7760], [5017, 7746], [5009, 7757], [5014, 7760]]], [[[4737, 5337], [4781, 5427], [4820, 5465], [4829, 5444], [4861, 5466], [4876, 5446], [4837, 5414], [4844, 5332], [4867, 5322], [4830, 5286], [4840, 5271], [4792, 5232], [4785, 5177], [4761, 5169], [4776, 5205], [4743, 5265], [4752, 5301], [4737, 5337]]], [[[4625, 8745], [4661, 8729], [4732, 8654], [4787, 8627], [4808, 8603], [4833, 8607], [4893, 8592], [4925, 8569], [4945, 8521], [5012, 8473], [4997, 8455], [5020, 8369], [5012, 8336], [5053, 8324], [5047, 8242], [5115, 8151], [5106, 8131], [5116, 8076], [5095, 8033], [5117, 7968], [5161, 7928], [5191, 7866], [5167, 7842], [5135, 7857], [5097, 7848], [5074, 7811], [5013, 7844], [5017, 7815], [4988, 7838], [4970, 7786], [4995, 7744], [4913, 7774], [4968, 7739], [4929, 7731], [4946, 7697], [4891, 7682], [4922, 7655], [4919, 7613], [4879, 7513], [4863, 7506], [4936, 7408], [4882, 7303], [4872, 7224], [4838, 7205], [4820, 7152], [4789, 7151], [4754, 7104], [4749, 7076], [4715, 7110], [4726, 7067], [4695, 7077], [4698, 7043], [4673, 6991], [4656, 6999], [4622, 6975], [4596, 6913], [4609, 6891], [4560, 6858], [4538, 6870], [4560, 6814], [4521, 6754], [4482, 6780], [4472, 6739], [4501, 6688], [4488, 6609], [4501, 6542], [4458, 6497], [4477, 6471], [4490, 6327], [4518, 6257], [4502, 6243], [4558, 6233], [4571, 6196], [4609, 6224], [4619, 6200], [4713, 6127], [4678, 6140], [4708, 6106], [4754, 6099], [4781, 6040], [4762, 6002], [4798, 6008], [4748, 5958], [4717, 5912], [4660, 5882], [4732, 5872], [4721, 5897], [4770, 5878], [4763, 5862], [4703, 5859], [4729, 5811], [4676, 5782], [4660, 5738], [4637, 5738], [4632, 5796], [4611, 5784], [4615, 5719], [4522, 5639], [4417, 5642], [4446, 5623], [4502, 5632], [4528, 5600], [4497, 5582], [4512, 5550], [4514, 5494], [4490, 5435], [4465, 5421], [4515, 5366], [4494, 5370], [4518, 5303], [4498, 5275], [4491, 5215], [4513, 5179], [4452, 4992], [4446, 4944], [4421, 4893], [4415, 4914], [4373, 4924], [4334, 4902], [4274, 4907], [4232, 4897], [4247, 4864], [4201, 4861], [4161, 4798], [4160, 4770], [4191, 4714], [4163, 4674], [4114, 4683], [4016, 4653], [3962, 4674], [3956, 4718], [3976, 4746], [3953, 4767], [3880, 4916], [3927, 4904], [3897, 4958], [3939, 4970], [3934, 5026], [3912, 5025], [3889, 5074], [3853, 5099], [3798, 5256], [3779, 5227], [3775, 5302], [3742, 5330], [3738, 5364], [3762, 5474], [3756, 5503], [3707, 5491], [3692, 5535], [3665, 5507], [3672, 5577], [3645, 5689], [3660, 5725], [3693, 5697], [3695, 5669], [3727, 5677], [3747, 5773], [3725, 5862], [3756, 5924], [3748, 5954], [3790, 5963], [3842, 6028], [3836, 6080], [3850, 6144], [3816, 6212], [3797, 6278], [3857, 6297], [3880, 6395], [3841, 6445], [3814, 6454], [3777, 6495], [3794, 6644], [3760, 6746], [3767, 6790], [3759, 6845], [3774, 6868], [3741, 6952], [3767, 7001], [3762, 7043], [3825, 7151], [3894, 7193], [3986, 7174], [4012, 7233], [4002, 7302], [3940, 7341], [4015, 7494], [4036, 7564], [4035, 7678], [4042, 7721], [4024, 7804], [4086, 7816], [4134, 7856], [4123, 7920], [4149, 7954], [4186, 8043], [4225, 8096], [4224, 8141], [4182, 8204], [4188, 8230], [4219, 8248], [4246, 8357], [4298, 8421], [4367, 8387], [4391, 8447], [4379, 8560], [4406, 8575], [4432, 8556], [4475, 8562], [4579, 8529], [4608, 8572], [4575, 8586], [4600, 8626], [4600, 8702], [4570, 8732], [4625, 8745]]]] } }, { "type": "Feature", "id": "RU", "properties": { "hc-group": "admin0", "hc-middle-x": 0.59, "hc-middle-y": 0.45, "hc-key": "ru", "hc-a2": "RU", "name": "Russia", "labelrank": "2", "country-abbrev": "Rus.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "RUS", "iso-a2": "RU", "woe-id": "23424936", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[6161, 5739], [6243, 5717], [6237, 5759], [6194, 5799], [6149, 5776], [6124, 5800], [6149, 5876], [6122, 5986], [6102, 6021], [6106, 6046], [6108, 6072], [6115, 6109], [6124, 6119], [6130, 6125], [6119, 6126], [6130, 6125], [6143, 6139], [6126, 6160], [6111, 6169], [6091, 6230], [6097, 6261], [6148, 6234], [6154, 6294], [6188, 6280], [6221, 6303], [6234, 6358], [6388, 6364], [6381, 6399], [6342, 6396], [6317, 6431], [6199, 6407], [6158, 6445], [6127, 6446], [6091, 6487], [6133, 6467], [6112, 6530], [6078, 6516], [6061, 6476], [6004, 6463], [6036, 6533], [6100, 6652], [6144, 6709], [6171, 6788], [6195, 6828], [6260, 7026], [6287, 7068], [6313, 7140], [6320, 7265], [6261, 7312], [6251, 7333], [6185, 7369], [6136, 7380], [6049, 7441], [6072, 7463], [6094, 7531], [6081, 7597], [6002, 7628], [5979, 7678], [6000, 7703], [5974, 7739], [5939, 7733], [5900, 7782], [5920, 7819], [5913, 7851], [5880, 7852], [5889, 7883], [5863, 7968], [5907, 7989], [5891, 8036], [5847, 8111], [5793, 8170], [5773, 8209], [5696, 8295], [5685, 8340], [5708, 8441], [5735, 8514], [5730, 8568], [5680, 8597], [5621, 8661], [5543, 8678], [5495, 8771], [5508, 8866], [5467, 8875], [5509, 8926], [5532, 8960], [5529, 9010], [5581, 9050], [5597, 9081], [5599, 9138], [5628, 9120], [5664, 9128], [5659, 9172], [5638, 9209], [5685, 9209], [5710, 9193], [5747, 9204], [5726, 9251], [5760, 9239], [5736, 9277], [5746, 9292], [5820, 9258], [5849, 9267], [5881, 9239], [5863, 9208], [5786, 9206], [5779, 9175], [5814, 9193], [5836, 9176], [5895, 9185], [5883, 9145], [5922, 9186], [5944, 9186], [5940, 9121], [5965, 9116], [5964, 9160], [6046, 9184], [6077, 9175], [6141, 9187], [6142, 9207], [6217, 9203], [6264, 9182], [6330, 9171], [6416, 9139], [6441, 9140], [6559, 9072], [6574, 9088], [6704, 9042], [6761, 9048], [6812, 9033], [6845, 8998], [6855, 9022], [6905, 9008], [6932, 8944], [6953, 8939], [6971, 8891], [6994, 8896], [7027, 8838], [7034, 8774], [7005, 8628], [6980, 8579], [6916, 8501], [6838, 8442], [6764, 8422], [6626, 8430], [6572, 8412], [6444, 8403], [6359, 8434], [6325, 8401], [6282, 8430], [6243, 8419], [6195, 8445], [6200, 8416], [6106, 8461], [6091, 8493], [6038, 8497], [6028, 8483], [6073, 8455], [6081, 8424], [6125, 8392], [6171, 8394], [6159, 8338], [6198, 8349], [6253, 8343], [6252, 8307], [6375, 8282], [6437, 8236], [6462, 8184], [6427, 8204], [6459, 8148], [6442, 8071], [6519, 7996], [6512, 7973], [6552, 7949], [6545, 7915], [6581, 7883], [6562, 7858], [6666, 7811], [6708, 7845], [6743, 7813], [6782, 7804], [6801, 7775], [6860, 7771], [6919, 7785], [6942, 7770], [7012, 7842], [7014, 7867], [6972, 7910], [6972, 7940], [6922, 7956], [6891, 7915], [6859, 7919], [6783, 7980], [6758, 7982], [6722, 8032], [6761, 8060], [6742, 8112], [6761, 8128], [6859, 8118], [6917, 8089], [7033, 8099], [7129, 8080], [7147, 8130], [7199, 8115], [7240, 8128], [7178, 8223], [7129, 8251], [7045, 8320], [7033, 8381], [7069, 8437], [7094, 8533], [7145, 8580], [7172, 8670], [7178, 8751], [7236, 8752], [7235, 8729], [7303, 8780], [7377, 8744], [7353, 8690], [7399, 8745], [7436, 8729], [7476, 8684], [7413, 8795], [7402, 8910], [7374, 8932], [7369, 8976], [7324, 9009], [7263, 9008], [7238, 9051], [7210, 9191], [7194, 9213], [7159, 9318], [7139, 9335], [7019, 9368], [7027, 9390], [7093, 9384], [7223, 9450], [7299, 9457], [7325, 9430], [7402, 9407], [7463, 9341], [7403, 9282], [7343, 9236], [7359, 9198], [7338, 9166], [7360, 9106], [7449, 9098], [7514, 9042], [7542, 9038], [7591, 9079], [7600, 9064], [7667, 9142], [7689, 9179], [7655, 9230], [7644, 9306], [7615, 9329], [7639, 9386], [7683, 9428], [7668, 9467], [7697, 9484], [7728, 9545], [7765, 9652], [7773, 9713], [7794, 9714], [7870, 9851], [7872, 9851], [7892, 9835], [7898, 9795], [7929, 9801], [7936, 9851], [8020, 9851], [8021, 9833], [8055, 9851], [9732, 9851], [9732, 2582], [9688, 2568], [9659, 2542], [9662, 2497], [9589, 2522], [9379, 2615], [9285, 2633], [9196, 2619], [9107, 2671], [9032, 2637], [8968, 2690], [8806, 2713], [8834, 2751], [8827, 2795], [8896, 2789], [8901, 2761], [8965, 2827], [9012, 2828], [8978, 2893], [8970, 2849], [8950, 2912], [8981, 2954], [8977, 3041], [9017, 3090], [9065, 3076], [9077, 3107], [9018, 3114], [8967, 3143], [8941, 3127], [8863, 3194], [8924, 3204], [8970, 3283], [9035, 3333], [9069, 3391], [9105, 3400], [9077, 3467], [9026, 3422], [8905, 3344], [8881, 3393], [8873, 3489], [8934, 3537], [8932, 3589], [9100, 3657], [9081, 3739], [9090, 3791], [9021, 3859], [8990, 3846], [8984, 3894], [9015, 3941], [8976, 3938], [8948, 3965], [8986, 3990], [9002, 4059], [8960, 4107], [8957, 4148], [8909, 4111], [8846, 4141], [8806, 4125], [8766, 4149], [8730, 4116], [8675, 4127], [8571, 4130], [8583, 4097], [8559, 4075], [8492, 4103], [8447, 4151], [8405, 4175], [8325, 4117], [8284, 4059], [8238, 4073], [8220, 4059], [8177, 4085], [8131, 4069], [8114, 4038], [8058, 4058], [8032, 4093], [8043, 4111], [7978, 4187], [7929, 4227], [7871, 4200], [7843, 4209], [7767, 4189], [7775, 4229], [7716, 4303], [7755, 4326], [7746, 4356], [7685, 4375], [7657, 4432], [7598, 4468], [7559, 4434], [7544, 4450], [7495, 4437], [7461, 4389], [7358, 4378], [7359, 4306], [7305, 4275], [7278, 4286], [7227, 4334], [7171, 4478], [7114, 4511], [7126, 4570], [7180, 4585], [7246, 4572], [7290, 4620], [7320, 4704], [7266, 4719], [7254, 4763], [7183, 4772], [7129, 4751], [7118, 4826], [7024, 4849], [6987, 4904], [6960, 4909], [6966, 4950], [6889, 4976], [6884, 5017], [6907, 5053], [6852, 5115], [6861, 5155], [6840, 5206], [6818, 5198], [6759, 5240], [6715, 5246], [6663, 5224], [6610, 5166], [6584, 5189], [6576, 5237], [6517, 5241], [6489, 5207], [6449, 5241], [6400, 5217], [6371, 5238], [6371, 5279], [6340, 5347], [6284, 5395], [6262, 5427], [6240, 5414], [6248, 5510], [6241, 5547], [6181, 5574], [6177, 5602], [6151, 5595], [6159, 5682], [6194, 5705], [6161, 5739]], [[5965, 9116], [5965, 9113], [5965, 9113], [5965, 9113], [5933, 9064], [5966, 9090], [5965, 9113], [5965, 9113], [5965, 9113], [5967, 9115], [5965, 9116]]], [[[6120, 6424], [6130, 6432], [6151, 6421], [6138, 6413], [6120, 6424]]], [[[6732, 7851], [6707, 7864], [6714, 7869], [6731, 7863], [6732, 7851]]], [[[6624, 8069], [6645, 8030], [6594, 8040], [6591, 8054], [6624, 8069]]], [[[6641, 8087], [6652, 8081], [6676, 8089], [6657, 8072], [6641, 8087]]], [[[7211, 8811], [7186, 8812], [7174, 8829], [7188, 8834], [7211, 8811]]], [[[7795, 9756], [7773, 9714], [7788, 9768], [7821, 9784], [7795, 9756]]], [[[6041, 9195], [6002, 9182], [5996, 9191], [6016, 9204], [6041, 9195]]], [[[5279, 4758], [5218, 4659], [5310, 4654], [5333, 4669], [5314, 4740], [5326, 4758], [5472, 4718], [5549, 4740], [5594, 4700], [5595, 4571], [5615, 4546], [5604, 4540], [5111, 4489], [5209, 4577], [5134, 4570], [5118, 4544], [5118, 4544], [5118, 4544], [5137, 4642], [5191, 4649], [5231, 4685], [5268, 4759], [5279, 4758], [5279, 4758]]], [[[5088, 4491], [5086, 4492], [5103, 4518], [5103, 4518], [5088, 4491]]], [[[7186, 8155], [7163, 8163], [7191, 8181], [7206, 8168], [7216, 8145], [7193, 8153], [7230, 8134], [7199, 8120], [7145, 8136], [7155, 8151], [7186, 8155]]], [[[5103, 4518], [5118, 4544], [5118, 4544], [5118, 4544], [5117, 4538], [5103, 4518], [5103, 4518]]], [[[7399, 9803], [7406, 9851], [7585, 9851], [7583, 9843], [7591, 9782], [7564, 9727], [7510, 9677], [7448, 9702], [7399, 9803]]]] } }, { "type": "Feature", "id": "GB", "properties": { "hc-group": "admin0", "hc-middle-x": 0.18, "hc-middle-y": 0.36, "hc-key": "gb", "hc-a2": "GB", "name": "United Kingdom", "labelrank": "2", "country-abbrev": "U.K.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "GBR", "iso-a2": "GB", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[1201, 3080], [1215, 3052], [1176, 3062], [1178, 3081], [1201, 3080]]], [[[1423, 3486], [1461, 3456], [1411, 3434], [1382, 3463], [1423, 3486]]], [[[968, 4314], [973, 4313], [980, 4292], [962, 4305], [968, 4314]]], [[[1043, 4292], [1070, 4288], [1010, 4250], [979, 4298], [986, 4332], [1036, 4324], [1043, 4292]]], [[[1017, 4928], [983, 4948], [995, 5006], [1025, 4996], [1017, 4928]]], [[[1052, 5006], [1038, 5025], [1033, 5063], [1050, 5050], [1052, 5006]]], [[[885, 5073], [888, 5028], [851, 5030], [842, 5065], [811, 5045], [830, 5088], [886, 5105], [885, 5073]]], [[[898, 5153], [887, 5135], [874, 5134], [891, 5156], [898, 5153]]], [[[961, 5153], [957, 5129], [905, 5060], [894, 5095], [961, 5153]]], [[[803, 5273], [790, 5294], [831, 5297], [807, 5283], [803, 5273]]], [[[946, 5292], [953, 5262], [986, 5245], [991, 5217], [878, 5206], [922, 5254], [894, 5284], [935, 5305], [946, 5292]]], [[[862, 5305], [840, 5306], [862, 5321], [885, 5326], [862, 5305]]], [[[763, 5445], [745, 5435], [733, 5442], [754, 5460], [763, 5445]]], [[[935, 5412], [925, 5393], [906, 5415], [929, 5426], [935, 5412]]], [[[796, 5561], [811, 5523], [775, 5475], [769, 5517], [796, 5561]]], [[[811, 5581], [819, 5559], [805, 5558], [790, 5574], [811, 5581]]], [[[838, 5625], [833, 5583], [780, 5621], [795, 5637], [838, 5625]]], [[[1551, 5818], [1538, 5794], [1529, 5824], [1542, 5826], [1551, 5818]]], [[[1501, 5850], [1508, 5826], [1487, 5818], [1473, 5849], [1501, 5850]]], [[[1527, 5917], [1583, 5845], [1561, 5835], [1544, 5861], [1509, 5854], [1490, 5887], [1502, 5918], [1527, 5917]]], [[[1607, 5906], [1619, 5887], [1606, 5883], [1600, 5908], [1607, 5906]]], [[[1548, 5925], [1554, 5910], [1540, 5912], [1538, 5930], [1548, 5925]]], [[[1590, 5936], [1590, 5908], [1582, 5907], [1578, 5924], [1590, 5936]]], [[[1647, 5941], [1626, 5926], [1614, 5932], [1619, 5939], [1647, 5941]]], [[[1569, 5971], [1575, 5943], [1558, 5948], [1549, 5970], [1569, 5971]]], [[[1936, 6281], [1938, 6271], [1924, 6271], [1919, 6289], [1936, 6281]]], [[[1871, 6164], [1837, 6082], [1824, 6092], [1855, 6186], [1824, 6165], [1802, 6213], [1845, 6210], [1841, 6261], [1817, 6262], [1863, 6293], [1847, 6234], [1892, 6239], [1871, 6164]]], [[[1904, 6323], [1916, 6320], [1900, 6254], [1883, 6259], [1904, 6323]]], [[[1949, 6333], [1938, 6303], [1918, 6307], [1936, 6350], [1949, 6333]]], [[[1131, 3142], [1108, 3146], [1111, 3154], [1140, 3166], [1131, 3142]]], [[[1023, 4529], [989, 4528], [1011, 4570], [1049, 4605], [1082, 4612], [1081, 4575], [1023, 4529]]], [[[-207, -551], [-210, -560], [-212, -550], [-207, -551]]], [[[9095, -490], [9069, -492], [9034, -504], [9046, -485], [9095, -490]]], [[[9270, -328], [9261, -336], [9242, -332], [9236, -330], [9242, -332], [9237, -333], [9224, -339], [9224, -339], [9223, -335], [9219, -325], [9213, -324], [9213, -324], [9233, -318], [9262, -296], [9262, -296], [9261, -299], [9240, -313], [9270, -328]], [[9232, -327], [9232, -324], [9229, -325], [9230, -327], [9232, -327]]], [[[1830, 3601], [1855, 3592], [1936, 3594], [1915, 3521], [1853, 3503], [1840, 3469], [1808, 3479], [1725, 3455], [1705, 3437], [1628, 3471], [1555, 3474], [1508, 3461], [1496, 3491], [1420, 3494], [1303, 3481], [1290, 3456], [1211, 3481], [1203, 3467], [1138, 3522], [1064, 3519], [1015, 3491], [1009, 3452], [970, 3405], [944, 3406], [885, 3466], [776, 3474], [761, 3448], [714, 3448], [705, 3410], [674, 3387], [633, 3446], [587, 3433], [597, 3463], [644, 3463], [728, 3514], [738, 3539], [784, 3551], [840, 3602], [856, 3659], [889, 3647], [934, 3701], [1004, 3698], [1069, 3668], [1134, 3657], [1142, 3691], [1204, 3735], [1257, 3796], [1213, 3761], [1161, 3761], [1116, 3721], [1053, 3733], [1010, 3807], [985, 3794], [929, 3803], [923, 3866], [870, 3863], [817, 3838], [812, 3872], [776, 3942], [818, 3963], [861, 3953], [986, 4004], [1026, 4074], [1039, 4180], [985, 4185], [961, 4159], [918, 4168], [955, 4201], [1001, 4221], [1048, 4271], [1194, 4279], [1224, 4247], [1220, 4281], [1244, 4294], [1243, 4326], [1286, 4374], [1263, 4388], [1277, 4433], [1324, 4481], [1291, 4516], [1249, 4491], [1225, 4578], [1205, 4617], [1266, 4714], [1298, 4729], [1242, 4752], [1231, 4719], [1190, 4724], [1165, 4701], [1132, 4713], [1101, 4753], [1094, 4689], [1025, 4757], [1006, 4744], [1011, 4691], [980, 4761], [1017, 4840], [1101, 4927], [1065, 4997], [1080, 5048], [1101, 5062], [1100, 5109], [1065, 5045], [1039, 5069], [1010, 5064], [1006, 5031], [970, 4998], [950, 4923], [903, 4915], [958, 5036], [958, 5101], [1001, 5152], [978, 5167], [1013, 5213], [1069, 5218], [1025, 5232], [1071, 5292], [995, 5245], [951, 5291], [971, 5303], [922, 5320], [932, 5335], [982, 5321], [988, 5362], [1054, 5463], [1027, 5491], [1037, 5556], [1062, 5536], [1051, 5587], [1058, 5629], [1093, 5647], [1112, 5620], [1131, 5643], [1167, 5614], [1127, 5685], [1148, 5677], [1145, 5729], [1192, 5729], [1185, 5753], [1229, 5825], [1273, 5794], [1400, 5774], [1464, 5786], [1521, 5771], [1498, 5737], [1500, 5708], [1474, 5681], [1325, 5602], [1324, 5566], [1362, 5562], [1274, 5481], [1382, 5502], [1401, 5520], [1462, 5496], [1488, 5501], [1546, 5480], [1637, 5469], [1654, 5405], [1613, 5366], [1592, 5311], [1554, 5245], [1512, 5212], [1491, 5171], [1429, 5146], [1432, 5118], [1469, 5088], [1431, 5067], [1403, 5076], [1362, 5041], [1296, 5041], [1370, 5007], [1422, 5032], [1448, 5025], [1519, 4972], [1558, 4882], [1586, 4863], [1584, 4742], [1603, 4625], [1628, 4576], [1711, 4521], [1730, 4457], [1778, 4405], [1750, 4383], [1756, 4346], [1794, 4266], [1763, 4265], [1724, 4304], [1739, 4267], [1791, 4218], [1813, 4142], [1806, 4103], [1743, 4053], [1803, 4017], [1843, 4064], [1911, 4056], [1963, 4037], [2022, 3985], [2034, 3900], [2002, 3841], [1988, 3788], [1913, 3738], [1898, 3712], [1872, 3728], [1844, 3654], [1767, 3648], [1809, 3635], [1781, 3619], [1823, 3604], [1821, 3625], [1842, 3614], [1848, 3599], [1830, 3601]]], [[[989, 5494], [996, 5479], [1046, 5460], [1035, 5441], [976, 5406], [984, 5454], [937, 5454], [922, 5503], [886, 5554], [922, 5560], [917, 5592], [950, 5557], [973, 5607], [990, 5569], [977, 5518], [989, 5495], [995, 5528], [1011, 5545], [999, 5516], [989, 5494]]], [[[902, 5785], [935, 5767], [936, 5789], [1032, 5834], [1037, 5783], [993, 5753], [989, 5703], [954, 5676], [875, 5640], [862, 5666], [909, 5691], [872, 5716], [902, 5785]]], [[[652, 4902], [679, 4888], [706, 4926], [738, 4913], [787, 4923], [845, 4898], [875, 4749], [902, 4722], [907, 4664], [888, 4631], [888, 4687], [855, 4642], [877, 4622], [822, 4614], [780, 4566], [746, 4592], [685, 4588], [690, 4626], [668, 4641], [662, 4684], [639, 4710], [576, 4637], [496, 4684], [459, 4770], [538, 4795], [532, 4831], [581, 4822], [622, 4890], [652, 4902]]]] } }, { "type": "Feature", "id": "CY", "properties": { "hc-group": "admin0", "hc-middle-x": 0.19, "hc-middle-y": 0.71, "hc-key": "cy", "hc-a2": "CY", "name": "Cyprus", "labelrank": "5", "country-abbrev": "Cyp.", "subregion": "Western Asia", "region-wb": "Europe & Central Asia", "iso-a3": "CYP", "iso-a2": "CY", "woe-id": "-90", "continent": "Asia" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[9232, -327], [9230, -327], [9229, -325], [9232, -324], [9232, -327]]], [[[9291, -290], [9318, -310], [9270, -328], [9240, -313], [9261, -299], [9270, -299], [9291, -290]]], [[[9224, -339], [9216, -390], [9095, -490], [9046, -485], [9034, -504], [8942, -502], [8881, -414], [8923, -412], [8944, -370], [8955, -373], [8960, -360], [8968, -358], [9008, -383], [9083, -327], [9139, -309], [9162, -352], [9223, -335], [9224, -339], [9224, -339]]], [[[9236, -330], [9239, -329], [9245, -331], [9242, -332], [9236, -330]]]] } }, { "type": "Feature", "id": "PT", "properties": { "hc-group": "admin0", "hc-middle-x": 0.48, "hc-middle-y": 0.36, "hc-key": "pt", "hc-a2": "PT", "name": "Portugal", "labelrank": "2", "country-abbrev": "Port.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "PRT", "iso-a2": "PT", "woe-id": "23424925", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[-896, 403], [-979, 424], [-941, 512], [-901, 573], [-905, 609], [-867, 611], [-810, 675], [-731, 789], [-719, 832], [-619, 1023], [-609, 1164], [-611, 1246], [-566, 1304], [-534, 1320], [-441, 1327], [-423, 1288], [-463, 1252], [-457, 1228], [-354, 1228], [-338, 1204], [-257, 1193], [-226, 1223], [-107, 1176], [-122, 1124], [-54, 1057], [-134, 993], [-168, 993], [-220, 941], [-249, 936], [-238, 881], [-270, 768], [-262, 740], [-328, 703], [-304, 645], [-361, 562], [-476, 588], [-438, 511], [-449, 478], [-430, 404], [-393, 365], [-423, 324], [-479, 302], [-520, 224], [-481, 131], [-444, 129], [-473, 83], [-533, 84], [-559, 40], [-621, -20], [-621, -134], [-720, -162], [-761, -157], [-805, -120], [-906, -83], [-999, -89], [-917, 33], [-889, 160], [-903, 172], [-858, 231], [-850, 282], [-874, 333], [-937, 322], [-929, 397], [-896, 403]], [[-896, 403], [-894, 402], [-893, 403], [-893, 403], [-893, 404], [-850, 411], [-856, 453], [-893, 404], [-893, 404], [-893, 404], [-896, 403]]] } }, { "type": "Feature", "id": "GR", "properties": { "hc-group": "admin0", "hc-middle-x": 0.21, "hc-middle-y": 0.40, "hc-key": "gr", "hc-a2": "GR", "name": "Greece", "labelrank": "3", "country-abbrev": "Greece", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "GRC", "iso-a2": "GR", "woe-id": "23424833", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[7604, -670], [7608, -677], [7582, -697], [7580, -676], [7604, -670]]], [[[7631, -545], [7629, -606], [7642, -663], [7609, -618], [7631, -545]]], [[[6616, -642], [6582, -647], [6584, -593], [6626, -630], [6616, -642]]], [[[7823, -305], [7805, -407], [7756, -489], [7713, -417], [7751, -352], [7823, -305]]], [[[7182, -475], [7175, -489], [7154, -487], [7169, -474], [7182, -475]]], [[[7617, -345], [7625, -359], [7626, -370], [7604, -352], [7617, -345]]], [[[7396, -360], [7364, -392], [7351, -370], [7370, -374], [7396, -360]]], [[[7712, -275], [7723, -272], [7731, -295], [7701, -292], [7712, -275]]], [[[6934, -404], [6941, -431], [6892, -453], [6893, -421], [6934, -404]]], [[[7139, -377], [7138, -400], [7105, -385], [7113, -363], [7139, -377]]], [[[7551, -257], [7495, -300], [7519, -256], [7566, -224], [7551, -257]]], [[[7286, -293], [7247, -333], [7238, -318], [7267, -285], [7286, -293]]], [[[6946, -321], [6976, -342], [6967, -360], [6944, -328], [6946, -321]]], [[[7485, -202], [7503, -208], [7503, -228], [7477, -234], [7485, -202]]], [[[7046, -318], [7057, -279], [7081, -269], [7077, -311], [7046, -318]]], [[[7438, -167], [7460, -189], [7449, -192], [7429, -173], [7438, -167]]], [[[7161, -259], [7139, -319], [7104, -279], [7140, -233], [7161, -259]]], [[[6896, -283], [6906, -283], [6912, -303], [6889, -307], [6896, -283]]], [[[6670, -285], [6660, -295], [6632, -304], [6650, -286], [6670, -285]]], [[[6880, -220], [6863, -259], [6857, -221], [6868, -204], [6880, -220]]], [[[7078, -153], [7107, -159], [7096, -177], [7075, -183], [7078, -153]]], [[[6996, -203], [6979, -218], [6972, -209], [6981, -174], [6996, -203]]], [[[7008, -125], [7047, -125], [7046, -153], [6989, -133], [7008, -125]]], [[[6842, -149], [6851, -166], [6828, -198], [6824, -172], [6842, -149]]], [[[7294, -67], [7241, -114], [7221, -109], [7237, -79], [7294, -67]]], [[[6639, -190], [6630, -189], [6618, -168], [6650, -162], [6639, -190]]], [[[7431, 3], [7459, -6], [7400, -38], [7346, -22], [7402, 12], [7431, 3]]], [[[5994, -248], [6054, -276], [6018, -305], [5965, -262], [5994, -248]]], [[[6938, -60], [6962, -58], [6965, -113], [6899, -63], [6938, -60]]], [[[6631, -102], [6637, -116], [6621, -132], [6605, -127], [6631, -102]]], [[[5926, -73], [5995, -185], [5927, -181], [5891, -111], [5913, -123], [5926, -73]]], [[[7173, 194], [7198, 187], [7214, 118], [7188, 68], [7149, 90], [7172, 121], [7124, 182], [7173, 194]]], [[[5956, -15], [5922, -30], [5914, -10], [5935, 41], [5956, -15]]], [[[6817, 208], [6846, 190], [6813, 180], [6793, 232], [6817, 208]]], [[[6561, 245], [6551, 230], [6536, 231], [6549, 254], [6561, 245]]], [[[6579, 258], [6627, 240], [6618, 227], [6600, 227], [6579, 258]]], [[[6648, 257], [6642, 262], [6651, 293], [6659, 292], [6648, 257]]], [[[7202, 424], [7264, 345], [7228, 323], [7167, 325], [7082, 354], [7082, 378], [7183, 438], [7202, 424]]], [[[5724, 291], [5711, 248], [5738, 200], [5658, 269], [5724, 291]]], [[[6940, 577], [6935, 505], [6895, 528], [6865, 505], [6853, 550], [6911, 552], [6940, 577]]], [[[6963, 721], [6969, 703], [6950, 692], [6917, 710], [6963, 721]]], [[[6760, 718], [6700, 711], [6718, 764], [6750, 754], [6760, 718]]], [[[5744, 264], [5783, 255], [5827, 318], [5801, 361], [5871, 401], [5896, 516], [5934, 546], [5929, 587], [5950, 612], [5928, 589], [5909, 607], [5912, 616], [5923, 633], [5943, 639], [5999, 661], [6044, 658], [6105, 737], [6162, 765], [6216, 761], [6280, 788], [6278, 832], [6313, 844], [6357, 845], [6390, 877], [6462, 882], [6547, 945], [6645, 975], [6671, 941], [6714, 926], [6735, 946], [6831, 918], [6884, 953], [6956, 965], [7004, 992], [7003, 1040], [6967, 1083], [7026, 1104], [7089, 1088], [7113, 1024], [7056, 973], [7081, 892], [7028, 811], [7001, 837], [6909, 825], [6792, 840], [6750, 785], [6693, 803], [6656, 791], [6651, 758], [6606, 719], [6537, 721], [6516, 691], [6698, 573], [6683, 554], [6645, 591], [6585, 607], [6539, 585], [6563, 553], [6615, 538], [6624, 490], [6572, 514], [6539, 553], [6475, 558], [6465, 536], [6562, 466], [6484, 465], [6455, 542], [6391, 557], [6335, 600], [6368, 621], [6348, 644], [6284, 580], [6307, 555], [6293, 492], [6303, 460], [6382, 390], [6406, 343], [6451, 320], [6522, 239], [6421, 274], [6413, 212], [6469, 187], [6414, 128], [6373, 132], [6413, 100], [6482, 95], [6494, 74], [6546, 82], [6561, 42], [6600, 46], [6643, 14], [6710, 7], [6747, -23], [6728, -40], [6771, -143], [6765, -175], [6694, -139], [6639, -80], [6561, -117], [6518, -163], [6560, -167], [6567, -224], [6600, -217], [6659, -253], [6559, -304], [6568, -274], [6468, -264], [6483, -304], [6544, -376], [6599, -470], [6582, -493], [6638, -568], [6536, -516], [6516, -478], [6473, -492], [6460, -548], [6474, -588], [6434, -581], [6425, -525], [6361, -440], [6312, -460], [6310, -537], [6267, -521], [6258, -476], [6217, -423], [6238, -381], [6193, -305], [6081, -240], [6125, -148], [6122, -119], [6178, -130], [6208, -82], [6250, -63], [6320, -96], [6430, -113], [6480, -142], [6472, -115], [6552, -79], [6528, -63], [6420, -38], [6387, -49], [6346, -11], [6348, -44], [6254, -40], [6153, -91], [6112, -64], [6067, -102], [6041, -37], [5962, 66], [6037, 101], [5958, 121], [5942, 72], [5926, 106], [5844, 158], [5781, 221], [5788, 250], [5744, 264]]], [[[5953, -97], [5966, -114], [5953, -98], [5953, -97], [5953, -97]]], [[[6631, 30], [6624, 62], [6509, 131], [6453, 139], [6520, 197], [6560, 161], [6601, 132], [6666, 117], [6715, 125], [6761, 87], [6757, 52], [6808, -13], [6863, -2], [6866, -56], [6825, -66], [6725, 22], [6724, 42], [6631, 30]]], [[[7250, -790], [7315, -764], [7313, -812], [7342, -826], [7437, -752], [7449, -825], [7297, -867], [7180, -916], [7094, -936], [7076, -889], [6997, -876], [6845, -893], [6778, -888], [6780, -790], [6813, -814], [6809, -762], [6836, -803], [6921, -771], [6955, -832], [7059, -791], [7119, -780], [7144, -796], [7250, -790]]], [[[5953, -97], [5936, -73], [5949, -66], [5953, -97], [5953, -97]]]] } }, { "type": "Feature", "id": "LT", "properties": { "hc-group": "admin0", "hc-middle-x": 0.60, "hc-middle-y": 0.49, "hc-key": "lt", "hc-a2": "LT", "name": "Lithuania", "labelrank": "5", "country-abbrev": "Lith.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "LTU", "iso-a2": "LT", "woe-id": "23424875", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[5326, 4758], [5306, 4834], [5272, 4895], [5254, 4987], [5276, 4994], [5291, 5038], [5404, 5112], [5500, 5110], [5529, 5132], [5570, 5111], [5594, 5133], [5661, 5141], [5729, 5127], [5783, 5137], [5842, 5202], [5891, 5137], [5981, 5144], [5992, 5129], [6081, 5080], [6104, 5054], [6159, 5044], [6157, 4946], [6218, 4942], [6193, 4890], [6147, 4887], [6131, 4831], [6080, 4791], [6092, 4704], [6071, 4634], [6100, 4633], [6118, 4585], [6086, 4576], [6065, 4618], [6026, 4598], [6009, 4557], [5972, 4554], [5971, 4502], [5952, 4504], [5908, 4464], [5875, 4477], [5784, 4444], [5756, 4450], [5735, 4513], [5628, 4561], [5615, 4546], [5595, 4571], [5594, 4700], [5549, 4740], [5472, 4718], [5326, 4758]]], [[[5268, 4759], [5285, 4824], [5279, 4758], [5279, 4758], [5268, 4759]]]] } }, { "type": "Feature", "id": "SI", "properties": { "hc-group": "admin0", "hc-middle-x": 0.38, "hc-middle-y": 0.62, "hc-key": "si", "hc-a2": "SI", "name": "Slovenia", "labelrank": "6", "country-abbrev": "Slo.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "SVN", "iso-a2": "SI", "woe-id": "23424945", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[4209, 1816], [4208, 1830], [4232, 1848], [4269, 1861], [4203, 1909], [4209, 1955], [4176, 1965], [4209, 2017], [4152, 2046], [4216, 2116], [4358, 2100], [4386, 2084], [4444, 2153], [4485, 2170], [4565, 2165], [4597, 2198], [4673, 2197], [4685, 2247], [4720, 2250], [4777, 2150], [4722, 2143], [4734, 2110], [4614, 2053], [4602, 2023], [4625, 2002], [4624, 1943], [4581, 1934], [4542, 1900], [4570, 1837], [4525, 1818], [4428, 1842], [4403, 1876], [4369, 1822], [4286, 1828], [4271, 1801], [4209, 1816]]] } }, { "type": "Feature", "id": "BA", "properties": { "hc-group": "admin0", "hc-middle-x": 0.49, "hc-middle-y": 0.42, "hc-key": "ba", "hc-a2": "BA", "name": "", "labelrank": "5", "country-abbrev": "B.H.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "BIH", "iso-a2": "BA", "woe-id": "23424761", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[5115, 1130], [5093, 1141], [5098, 1143], [5095, 1184], [5062, 1201], [5019, 1256], [5010, 1291], [4976, 1298], [4890, 1365], [4881, 1385], [4775, 1482], [4747, 1571], [4668, 1659], [4662, 1750], [4705, 1771], [4754, 1721], [4781, 1716], [4805, 1774], [4867, 1774], [4893, 1807], [4950, 1773], [4966, 1787], [5030, 1773], [5051, 1788], [5085, 1763], [5120, 1791], [5164, 1799], [5229, 1777], [5259, 1787], [5308, 1729], [5333, 1734], [5363, 1755], [5405, 1749], [5402, 1704], [5369, 1637], [5388, 1571], [5489, 1511], [5411, 1478], [5467, 1428], [5478, 1370], [5448, 1380], [5419, 1354], [5360, 1334], [5401, 1286], [5364, 1294], [5321, 1259], [5320, 1192], [5282, 1179], [5293, 1114], [5315, 1079], [5293, 1053], [5161, 1114], [5115, 1130]]] } }, { "type": "Feature", "id": "MC", "properties": { "hc-group": "admin0", "hc-middle-x": 0.47, "hc-middle-y": 0.63, "hc-key": "mc", "hc-a2": "MC", "name": "Monaco", "labelrank": "6", "country-abbrev": "Mco.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "MCO", "iso-a2": "MC", "woe-id": "23424892", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[2937, 1301], [2930, 1294], [2922, 1295], [2931, 1307], [2937, 1301]]] } }, { "type": "Feature", "id": "AL", "properties": { "hc-group": "admin0", "hc-middle-x": 0.30, "hc-middle-y": 0.65, "hc-key": "al", "hc-a2": "AL", "name": "Albania", "labelrank": "6", "country-abbrev": "Alb.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "ALB", "iso-a2": "AL", "woe-id": "23424742", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[5907, 643], [5905, 642], [5902, 648], [5906, 645], [5907, 643]]], [[[5827, 689], [5837, 642], [5854, 641], [5874, 648], [5902, 648], [5899, 643], [5909, 635], [5909, 634], [5900, 609], [5912, 616], [5909, 607], [5928, 589], [5924, 584], [5929, 587], [5934, 546], [5896, 516], [5871, 401], [5801, 361], [5827, 318], [5783, 255], [5744, 264], [5742, 309], [5697, 364], [5606, 400], [5597, 470], [5552, 520], [5567, 589], [5586, 602], [5563, 670], [5575, 704], [5543, 743], [5572, 801], [5568, 869], [5519, 873], [5511, 904], [5511, 941], [5532, 960], [5508, 1011], [5560, 1115], [5593, 1064], [5642, 1094], [5686, 1036], [5749, 1011], [5782, 938], [5778, 915], [5765, 818], [5792, 778], [5782, 752], [5827, 689]]], [[[5503, 1000], [5503, 997], [5502, 997], [5503, 1000]]]] } }, { "type": "Feature", "id": "CNM", "properties": { "hc-group": "admin0", "hc-middle-x": 0.66, "hc-middle-y": 0.61, "hc-key": "cnm", "hc-a2": "CN", "name": "", "labelrank": "9", "country-abbrev": null, "subregion": "Western Asia", "region-wb": "Europe & Central Asia", "iso-a3": "-99", "iso-a2": null, "woe-id": "-99", "continent": "Asia" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[9288, -289], [9288, -289], [9291, -290], [9270, -299], [9261, -299], [9262, -296], [9276, -291], [9288, -289]]], [[[8944, -370], [8947, -367], [8947, -367], [8952, -370], [8956, -361], [8958, -360], [8960, -360], [8955, -373], [8944, -370]]], [[[8968, -358], [8968, -358], [8973, -358], [9012, -377], [9084, -318], [9132, -299], [9160, -323], [9213, -324], [9213, -324], [9219, -325], [9223, -335], [9162, -352], [9139, -309], [9083, -327], [9008, -383], [8968, -358]]]] } }, { "type": "Feature", "id": "NC", "properties": { "hc-group": "admin0", "hc-middle-x": 0.59, "hc-middle-y": 0.61, "hc-key": "nc", "hc-a2": "NC", "name": "", "labelrank": "6", "country-abbrev": "N. Cy.", "subregion": "Western Asia", "region-wb": "Europe & Central Asia", "iso-a3": "-99", "iso-a2": "NC", "woe-id": "-90", "continent": "Asia" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[9160, -323], [9132, -299], [9084, -318], [9012, -377], [8973, -358], [9011, -353], [9001, -280], [9126, -260], [9253, -171], [9359, -64], [9360, -79], [9246, -235], [9288, -289], [9276, -291], [9262, -296], [9262, -296], [9233, -318], [9213, -324], [9213, -324], [9160, -323]]], [[[8947, -367], [8951, -364], [8956, -361], [8952, -370], [8947, -367]]]] } }, { "type": "Feature", "id": "RS", "properties": { "hc-group": "admin0", "hc-middle-x": 0.47, "hc-middle-y": 0.51, "hc-key": "rs", "hc-a2": "RS", "name": "Serbia", "labelrank": "5", "country-abbrev": "Serb.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "SRB", "iso-a2": "RS", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[5333, 1734], [5332, 1816], [5399, 1831], [5390, 1853], [5313, 1878], [5308, 1936], [5265, 2001], [5272, 2037], [5302, 2065], [5342, 2061], [5393, 2121], [5468, 2131], [5533, 2124], [5557, 2094], [5657, 2038], [5663, 1963], [5714, 1924], [5826, 1887], [5805, 1838], [5841, 1827], [5814, 1802], [5881, 1761], [5954, 1762], [5997, 1730], [6036, 1801], [6113, 1770], [6059, 1736], [6116, 1666], [6105, 1620], [6067, 1588], [6066, 1533], [6118, 1443], [6229, 1382], [6192, 1283], [6146, 1270], [6144, 1181], [6170, 1136], [6140, 1104], [6119, 1116], [5976, 1056], [5999, 1185], [5913, 1193], [5912, 1226], [5882, 1230], [5837, 1284], [5780, 1298], [5772, 1323], [5728, 1295], [5747, 1275], [5690, 1184], [5685, 1207], [5636, 1220], [5590, 1254], [5522, 1261], [5419, 1354], [5448, 1380], [5478, 1370], [5467, 1428], [5411, 1478], [5489, 1511], [5388, 1571], [5369, 1637], [5402, 1704], [5405, 1749], [5363, 1755], [5333, 1734]]] } }, { "type": "Feature", "id": "RO", "properties": { "hc-group": "admin0", "hc-middle-x": 0.45, "hc-middle-y": 0.54, "hc-key": "ro", "hc-a2": "RO", "name": "Romania", "labelrank": "3", "country-abbrev": "Rom.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "ROU", "iso-a2": "RO", "woe-id": "23424933", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[6059, 1736], [6113, 1770], [6036, 1801], [5997, 1730], [5954, 1762], [5881, 1761], [5814, 1802], [5841, 1827], [5805, 1838], [5826, 1887], [5714, 1924], [5663, 1963], [5657, 2038], [5557, 2094], [5533, 2124], [5575, 2150], [5605, 2141], [5645, 2188], [5703, 2199], [5724, 2302], [5756, 2338], [5767, 2428], [5790, 2458], [5814, 2573], [5856, 2646], [5943, 2693], [5962, 2732], [6000, 2782], [6052, 2762], [6132, 2776], [6223, 2767], [6283, 2792], [6360, 2740], [6400, 2767], [6419, 2808], [6585, 2873], [6596, 2941], [6652, 2968], [6687, 2976], [6729, 2959], [6775, 2912], [6821, 2832], [6884, 2789], [6953, 2710], [7003, 2689], [7070, 2596], [7089, 2531], [7089, 2403], [7132, 2304], [7114, 2288], [7150, 2258], [7186, 2225], [7282, 2223], [7373, 2312], [7445, 2302], [7457, 2266], [7476, 2165], [7469, 2151], [7380, 2113], [7337, 2172], [7324, 2132], [7352, 2077], [7322, 2035], [7356, 2049], [7322, 1963], [7352, 1873], [7353, 1794], [7278, 1781], [7223, 1793], [7199, 1830], [7163, 1808], [7144, 1825], [7089, 1809], [7055, 1833], [7006, 1837], [6838, 1749], [6780, 1652], [6698, 1611], [6610, 1620], [6512, 1615], [6444, 1587], [6264, 1592], [6183, 1561], [6168, 1606], [6193, 1640], [6116, 1666], [6115, 1666], [6059, 1736]]] } }, { "type": "Feature", "id": "ME", "properties": { "hc-group": "admin0", "hc-middle-x": 0.29, "hc-middle-y": 0.67, "hc-key": "me", "hc-a2": "ME", "name": "", "labelrank": "6", "country-abbrev": "Mont.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "MNE", "iso-a2": "ME", "woe-id": "20069817", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[5642, 1094], [5593, 1064], [5560, 1115], [5508, 1011], [5505, 1006], [5503, 1000], [5502, 997], [5456, 988], [5511, 941], [5511, 904], [5519, 873], [5473, 892], [5463, 922], [5396, 986], [5377, 978], [5344, 1027], [5311, 1013], [5298, 1030], [5293, 1053], [5315, 1079], [5293, 1114], [5282, 1179], [5320, 1192], [5321, 1259], [5364, 1294], [5401, 1286], [5360, 1334], [5419, 1354], [5522, 1261], [5590, 1254], [5636, 1220], [5685, 1207], [5690, 1184], [5626, 1144], [5642, 1094]]] } }, { "type": "Feature", "id": "LI", "properties": { "hc-group": "admin0", "hc-middle-x": 0.62, "hc-middle-y": 0.51, "hc-key": "li", "hc-a2": "LI", "name": "", "labelrank": "6", "country-abbrev": "Liech.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "LIE", "iso-a2": "LI", "woe-id": "23424879", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[3383, 2312], [3402, 2266], [3395, 2252], [3374, 2254], [3383, 2312]]] } }, { "type": "Feature", "id": "AT", "properties": { "hc-group": "admin0", "hc-middle-x": 0.68, "hc-middle-y": 0.50, "hc-key": "at", "hc-a2": "AT", "name": "Austria", "labelrank": "3", "country-abbrev": "Aust.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "AUT", "iso-a2": "AT", "woe-id": "23424750", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[3395, 2252], [3402, 2266], [3383, 2312], [3409, 2354], [3390, 2383], [3413, 2380], [3422, 2394], [3467, 2387], [3538, 2323], [3566, 2362], [3558, 2401], [3632, 2385], [3670, 2350], [3724, 2353], [3794, 2409], [3900, 2416], [3902, 2446], [3965, 2426], [4016, 2438], [4021, 2406], [4072, 2390], [4066, 2454], [4041, 2456], [4059, 2492], [4008, 2569], [4062, 2613], [4132, 2649], [4151, 2710], [4189, 2693], [4205, 2765], [4257, 2717], [4304, 2710], [4329, 2736], [4376, 2724], [4392, 2779], [4415, 2776], [4422, 2848], [4476, 2844], [4558, 2815], [4583, 2821], [4627, 2791], [4689, 2788], [4702, 2808], [4787, 2794], [4804, 2763], [4792, 2692], [4860, 2595], [4836, 2551], [4854, 2508], [4801, 2493], [4763, 2511], [4726, 2482], [4770, 2475], [4777, 2426], [4737, 2393], [4759, 2293], [4717, 2291], [4685, 2247], [4673, 2197], [4597, 2198], [4565, 2165], [4485, 2170], [4444, 2153], [4386, 2084], [4358, 2100], [4216, 2116], [4122, 2120], [3956, 2154], [3895, 2240], [3913, 2265], [3823, 2232], [3737, 2234], [3694, 2212], [3676, 2170], [3567, 2197], [3550, 2234], [3500, 2191], [3450, 2218], [3449, 2240], [3395, 2252]]] } }, { "type": "Feature", "id": "SK", "properties": { "hc-group": "admin0", "hc-middle-x": 0.40, "hc-middle-y": 0.46, "hc-key": "sk", "hc-a2": "SK", "name": "Slovakia", "labelrank": "6", "country-abbrev": "Svk.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "SVK", "iso-a2": "SK", "woe-id": "23424877", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[4860, 2595], [4792, 2692], [4804, 2763], [4839, 2840], [4910, 2834], [4968, 2872], [5005, 2912], [5019, 2981], [5077, 3047], [5131, 3062], [5160, 3030], [5198, 3039], [5241, 3102], [5283, 3050], [5310, 3051], [5313, 2997], [5371, 2995], [5381, 3035], [5411, 3063], [5481, 3078], [5533, 3055], [5545, 3087], [5585, 3108], [5692, 3104], [5736, 3063], [5841, 3040], [5819, 2970], [5819, 2928], [5793, 2890], [5798, 2837], [5724, 2806], [5656, 2860], [5600, 2830], [5535, 2843], [5479, 2822], [5459, 2748], [5381, 2693], [5328, 2714], [5305, 2677], [5184, 2641], [5168, 2619], [5187, 2581], [5078, 2545], [4999, 2535], [4947, 2553], [4897, 2596], [4860, 2595]]] } }, { "type": "Feature", "id": "HU", "properties": { "hc-group": "admin0", "hc-middle-x": 0.45, "hc-middle-y": 0.54, "hc-key": "hu", "hc-a2": "HU", "name": "Hungary", "labelrank": "5", "country-abbrev": "Hun.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "HUN", "iso-a2": "HU", "woe-id": "23424844", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[4777, 2150], [4720, 2250], [4685, 2247], [4717, 2291], [4759, 2293], [4737, 2393], [4777, 2426], [4770, 2475], [4726, 2482], [4763, 2511], [4801, 2493], [4854, 2508], [4836, 2551], [4860, 2595], [4897, 2596], [4947, 2553], [4999, 2535], [5078, 2545], [5187, 2581], [5168, 2619], [5184, 2641], [5305, 2677], [5328, 2714], [5381, 2693], [5459, 2748], [5479, 2822], [5535, 2843], [5600, 2830], [5656, 2860], [5724, 2806], [5798, 2837], [5824, 2842], [5848, 2799], [5872, 2803], [5901, 2766], [5928, 2776], [5962, 2732], [5943, 2693], [5856, 2646], [5814, 2573], [5790, 2458], [5767, 2428], [5756, 2338], [5724, 2302], [5703, 2199], [5645, 2188], [5605, 2141], [5575, 2150], [5533, 2124], [5468, 2131], [5393, 2121], [5342, 2061], [5302, 2065], [5272, 2037], [5227, 2026], [5180, 1971], [5138, 1979], [5070, 1968], [5008, 2009], [4959, 2009], [4924, 2054], [4877, 2075], [4851, 2116], [4777, 2150]]] } }, { "type": "Feature", "id": "AD", "properties": { "hc-group": "admin0", "hc-middle-x": 0.48, "hc-middle-y": 0.52, "hc-key": "ad", "hc-a2": "AD", "name": "", "labelrank": "6", "country-abbrev": "And.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "AND", "iso-a2": "AD", "woe-id": "23424744", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[1691, 1033], [1645, 1016], [1634, 1067], [1697, 1064], [1691, 1033]]] } }, { "type": "Feature", "id": "LU", "properties": { "hc-group": "admin0", "hc-middle-x": 0.50, "hc-middle-y": 0.58, "hc-key": "lu", "hc-a2": "LU", "name": "Luxembourg", "labelrank": "6", "country-abbrev": "Lux.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "LUX", "iso-a2": "LU", "woe-id": "23424881", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[2791, 2962], [2752, 2975], [2719, 2961], [2688, 2991], [2708, 3020], [2680, 3091], [2737, 3172], [2759, 3155], [2774, 3087], [2825, 3058], [2791, 2962]]] } }, { "type": "Feature", "id": "CH", "properties": { "hc-group": "admin0", "hc-middle-x": 0.51, "hc-middle-y": 0.49, "hc-key": "ch", "hc-a2": "CH", "name": "Switzerland", "labelrank": "4", "country-abbrev": "Switz.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "CHE", "iso-a2": "CH", "woe-id": "23424957", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[3006, 2412], [3174, 2408], [3164, 2431], [3205, 2468], [3264, 2425], [3318, 2430], [3319, 2429], [3321, 2426], [3321, 2426], [3378, 2377], [3390, 2383], [3409, 2354], [3383, 2312], [3374, 2254], [3395, 2252], [3449, 2240], [3450, 2218], [3500, 2191], [3550, 2234], [3567, 2197], [3551, 2141], [3562, 2101], [3495, 2121], [3486, 2071], [3509, 2022], [3486, 2010], [3470, 2049], [3389, 2031], [3365, 2089], [3330, 2087], [3331, 2036], [3272, 1939], [3287, 1913], [3255, 1898], [3243, 1967], [3196, 1984], [3162, 2022], [3166, 2075], [3091, 2025], [3097, 1988], [3039, 1928], [2981, 1950], [2908, 1923], [2876, 1937], [2844, 1995], [2835, 2080], [2852, 2092], [2803, 2112], [2741, 2096], [2720, 2051], [2731, 2035], [2664, 2007], [2704, 2071], [2688, 2089], [2706, 2139], [2768, 2184], [2773, 2237], [2805, 2247], [2897, 2346], [2862, 2351], [2892, 2392], [2964, 2369], [3006, 2412], [3006, 2412]]] } }, { "type": "Feature", "id": "BE", "properties": { "hc-group": "admin0", "hc-middle-x": 0.53, "hc-middle-y": 0.37, "hc-key": "be", "hc-a2": "BE", "name": "Belgium", "labelrank": "2", "country-abbrev": "Belg.", "subregion": "Western Europe", "region-wb": "Europe & Central Asia", "iso-a3": "BEL", "iso-a2": "BE", "woe-id": "23424757", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[2759, 3155], [2737, 3172], [2680, 3091], [2708, 3020], [2688, 2991], [2629, 2982], [2536, 3076], [2519, 3074], [2510, 3129], [2529, 3175], [2492, 3162], [2486, 3135], [2443, 3122], [2390, 3138], [2408, 3217], [2377, 3244], [2310, 3245], [2310, 3281], [2244, 3311], [2227, 3382], [2161, 3376], [2129, 3413], [2124, 3485], [2239, 3543], [2280, 3553], [2285, 3515], [2330, 3523], [2380, 3495], [2437, 3537], [2452, 3509], [2444, 3537], [2467, 3530], [2486, 3564], [2511, 3546], [2537, 3566], [2561, 3534], [2581, 3557], [2614, 3492], [2660, 3498], [2723, 3456], [2690, 3344], [2746, 3338], [2778, 3297], [2779, 3261], [2804, 3257], [2809, 3209], [2765, 3182], [2759, 3155]]] } }, { "type": "Feature", "id": "KV", "properties": { "hc-group": "admin0", "hc-middle-x": 0.89, "hc-middle-y": 0.48, "hc-key": "kv", "hc-a2": "KV", "name": "", "labelrank": "6", "country-abbrev": "Kos.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "-99", "iso-a2": "KV", "woe-id": "-90", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[5778, 915], [5782, 938], [5749, 1011], [5686, 1036], [5642, 1094], [5626, 1144], [5690, 1184], [5747, 1275], [5728, 1295], [5772, 1323], [5780, 1298], [5837, 1284], [5882, 1230], [5912, 1226], [5913, 1193], [5999, 1185], [5976, 1056], [5945, 1049], [5913, 1002], [5878, 1026], [5813, 977], [5816, 931], [5778, 915]]] } }, { "type": "Feature", "id": "PL", "properties": { "hc-group": "admin0", "hc-middle-x": 0.56, "hc-middle-y": 0.50, "hc-key": "pl", "hc-a2": "PL", "name": "Poland", "labelrank": "3", "country-abbrev": "Pol.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "POL", "iso-a2": "PL", "woe-id": "23424923", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[5615, 4546], [5628, 4561], [5735, 4513], [5756, 4450], [5791, 4360], [5868, 4241], [5895, 4126], [5890, 4104], [5817, 4042], [5789, 3973], [5882, 3930], [5894, 3906], [5886, 3834], [5907, 3769], [5922, 3719], [5976, 3670], [5989, 3635], [6038, 3595], [6010, 3586], [6051, 3510], [6035, 3467], [5994, 3455], [5900, 3310], [5837, 3173], [5861, 3130], [5867, 3073], [5904, 3029], [5841, 3040], [5736, 3063], [5692, 3104], [5585, 3108], [5545, 3087], [5533, 3055], [5481, 3078], [5411, 3063], [5381, 3035], [5371, 2995], [5313, 2997], [5310, 3051], [5283, 3050], [5241, 3102], [5198, 3039], [5160, 3030], [5131, 3062], [5114, 3108], [5088, 3112], [5067, 3169], [4967, 3187], [4931, 3173], [4880, 3222], [4880, 3250], [4830, 3248], [4797, 3277], [4739, 3283], [4762, 3230], [4718, 3186], [4643, 3260], [4615, 3272], [4648, 3301], [4636, 3338], [4591, 3335], [4470, 3369], [4453, 3363], [4435, 3411], [4378, 3418], [4385, 3380], [4354, 3378], [4385, 3489], [4367, 3549], [4327, 3566], [4322, 3611], [4295, 3647], [4322, 3727], [4307, 3777], [4276, 3824], [4292, 3870], [4196, 3943], [4198, 3974], [4231, 4002], [4238, 4067], [4206, 4188], [4249, 4181], [4266, 4236], [4192, 4239], [4187, 4247], [4193, 4256], [4220, 4252], [4288, 4290], [4511, 4381], [4576, 4464], [4637, 4484], [4699, 4531], [4787, 4562], [4858, 4575], [4910, 4497], [4917, 4464], [4989, 4447], [5048, 4464], [5048, 4464], [5027, 4450], [5056, 4436], [5111, 4489], [5604, 4540], [5615, 4546]]], [[[5086, 4492], [5088, 4491], [5060, 4472], [5060, 4472], [5086, 4492]]], [[[5048, 4464], [5060, 4472], [5060, 4472], [5050, 4465], [5048, 4464], [5048, 4464]]]] } }, { "type": "Feature", "id": "MK", "properties": { "hc-group": "admin0", "hc-middle-x": 0.49, "hc-middle-y": 0.49, "hc-key": "mk", "hc-a2": "MK", "name": "Macedonia", "labelrank": "6", "country-abbrev": "Mkd.", "subregion": "Southern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "MKD", "iso-a2": "MK", "woe-id": "23424890", "continent": "Europe" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[5909, 635], [5910, 635], [5909, 634], [5909, 635]]], [[[6140, 1104], [6189, 1058], [6262, 1037], [6313, 957], [6303, 916], [6313, 844], [6278, 832], [6280, 788], [6216, 761], [6162, 765], [6105, 737], [6044, 658], [5999, 661], [5943, 639], [5902, 680], [5907, 643], [5906, 645], [5902, 648], [5902, 648], [5874, 648], [5854, 641], [5866, 703], [5827, 689], [5782, 752], [5792, 778], [5765, 818], [5778, 915], [5816, 931], [5813, 977], [5878, 1026], [5913, 1002], [5945, 1049], [5976, 1056], [6119, 1116], [6140, 1104]]]] } }, { "type": "Feature", "id": "LV", "properties": { "hc-group": "admin0", "hc-middle-x": 0.68, "hc-middle-y": 0.47, "hc-key": "lv", "hc-a2": "LV", "name": "Latvia", "labelrank": "5", "country-abbrev": "Lat.", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "LVA", "iso-a2": "LV", "woe-id": "23424874", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[6371, 5238], [6337, 5217], [6307, 5156], [6308, 5118], [6209, 5104], [6192, 5064], [6159, 5044], [6104, 5054], [6081, 5080], [5992, 5129], [5981, 5144], [5891, 5137], [5842, 5202], [5783, 5137], [5729, 5127], [5661, 5141], [5594, 5133], [5570, 5111], [5529, 5132], [5500, 5110], [5404, 5112], [5291, 5038], [5276, 4994], [5254, 4987], [5233, 5037], [5222, 5208], [5266, 5271], [5258, 5343], [5288, 5426], [5332, 5447], [5414, 5508], [5433, 5460], [5517, 5412], [5549, 5343], [5626, 5314], [5663, 5335], [5716, 5410], [5714, 5443], [5669, 5588], [5699, 5617], [5801, 5677], [5861, 5642], [5926, 5637], [5934, 5617], [6022, 5561], [6071, 5605], [6151, 5595], [6177, 5602], [6181, 5574], [6241, 5547], [6248, 5510], [6240, 5414], [6262, 5427], [6284, 5395], [6340, 5347], [6371, 5279], [6371, 5238]]] } }, { "type": "Feature", "id": "BY", "properties": { "hc-group": "admin0", "hc-middle-x": 0.48, "hc-middle-y": 0.57, "hc-key": "by", "hc-a2": "BY", "name": "Belarus", "labelrank": "4", "country-abbrev": "Bela.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "BLR", "iso-a2": "BY", "woe-id": "23424765", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[6159, 5044], [6192, 5064], [6209, 5104], [6308, 5118], [6307, 5156], [6337, 5217], [6371, 5238], [6400, 5217], [6449, 5241], [6489, 5207], [6517, 5241], [6576, 5237], [6584, 5189], [6610, 5166], [6663, 5224], [6715, 5246], [6759, 5240], [6818, 5198], [6840, 5206], [6861, 5155], [6852, 5115], [6907, 5053], [6884, 5017], [6889, 4976], [6966, 4950], [6960, 4909], [6987, 4904], [7024, 4849], [7118, 4826], [7129, 4751], [7183, 4772], [7254, 4763], [7266, 4719], [7320, 4704], [7290, 4620], [7246, 4572], [7180, 4585], [7126, 4570], [7114, 4511], [7171, 4478], [7227, 4334], [7278, 4286], [7228, 4275], [7196, 4244], [7144, 4237], [7114, 4151], [7106, 4084], [7149, 4017], [7140, 3984], [7103, 3994], [7053, 4033], [7005, 4004], [6961, 4007], [6918, 3960], [6865, 4022], [6825, 3992], [6813, 3942], [6780, 3978], [6737, 3959], [6704, 3988], [6687, 3955], [6639, 3956], [6634, 3914], [6616, 3948], [6542, 3930], [6519, 3969], [6462, 3957], [6378, 3967], [6262, 3963], [6159, 3947], [6082, 3911], [6025, 3898], [6008, 3848], [5970, 3801], [5926, 3810], [5907, 3769], [5886, 3834], [5894, 3906], [5882, 3930], [5789, 3973], [5817, 4042], [5890, 4104], [5895, 4126], [5868, 4241], [5791, 4360], [5756, 4450], [5784, 4444], [5875, 4477], [5908, 4464], [5952, 4504], [5971, 4502], [5972, 4554], [6009, 4557], [6026, 4598], [6065, 4618], [6086, 4576], [6118, 4585], [6100, 4633], [6071, 4634], [6092, 4704], [6080, 4791], [6131, 4831], [6147, 4887], [6193, 4890], [6218, 4942], [6157, 4946], [6159, 5044]]] } }, { "type": "Feature", "id": "IS", "properties": { "hc-group": "admin0", "hc-middle-x": 0.59, "hc-middle-y": 0.68, "hc-key": "is", "hc-a2": "IS", "name": "Iceland", "labelrank": "3", "country-abbrev": "Iceland", "subregion": "Northern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "ISL", "iso-a2": "IS", "woe-id": "23424845", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[23, 7765], [-31, 7764], [-42, 7780], [-86, 7762], [-64, 7754], [-101, 7722], [-209, 7727], [-271, 7767], [-318, 7818], [-367, 7843], [-388, 7915], [-443, 7984], [-435, 8008], [-470, 7988], [-517, 8017], [-554, 8023], [-582, 8046], [-631, 8058], [-594, 8126], [-590, 8089], [-546, 8080], [-466, 8107], [-487, 8122], [-442, 8153], [-483, 8140], [-497, 8153], [-458, 8196], [-397, 8218], [-488, 8200], [-493, 8230], [-466, 8281], [-602, 8368], [-616, 8355], [-649, 8375], [-644, 8415], [-596, 8393], [-542, 8384], [-532, 8401], [-506, 8378], [-474, 8390], [-473, 8368], [-433, 8366], [-370, 8331], [-345, 8373], [-387, 8362], [-439, 8405], [-423, 8419], [-332, 8436], [-332, 8465], [-371, 8459], [-387, 8509], [-413, 8504], [-455, 8548], [-556, 8542], [-556, 8561], [-613, 8605], [-567, 8624], [-538, 8578], [-544, 8617], [-519, 8656], [-469, 8575], [-488, 8630], [-478, 8675], [-451, 8648], [-466, 8697], [-455, 8712], [-432, 8685], [-436, 8718], [-402, 8730], [-378, 8700], [-381, 8676], [-344, 8653], [-330, 8618], [-337, 8579], [-309, 8641], [-344, 8686], [-333, 8728], [-353, 8755], [-336, 8773], [-272, 8752], [-251, 8712], [-259, 8681], [-233, 8670], [-219, 8634], [-229, 8605], [-208, 8600], [-197, 8559], [-209, 8522], [-269, 8453], [-246, 8455], [-266, 8427], [-254, 8402], [-265, 8355], [-201, 8434], [-164, 8447], [-167, 8384], [-110, 8440], [-96, 8526], [-87, 8540], [-45, 8536], [-48, 8465], [-33, 8447], [-39, 8415], [-19, 8396], [-2, 8460], [31, 8489], [61, 8471], [71, 8495], [101, 8497], [121, 8449], [109, 8419], [128, 8404], [123, 8338], [146, 8358], [140, 8395], [160, 8464], [199, 8439], [214, 8374], [237, 8373], [282, 8419], [307, 8391], [363, 8386], [381, 8410], [391, 8477], [452, 8463], [449, 8428], [472, 8410], [453, 8383], [483, 8328], [504, 8358], [527, 8353], [569, 8373], [592, 8356], [537, 8346], [535, 8321], [502, 8309], [508, 8287], [554, 8273], [551, 8240], [502, 8190], [566, 8182], [553, 8170], [604, 8087], [624, 8078], [583, 8028], [604, 8005], [589, 7946], [569, 7931], [532, 7974], [550, 7914], [516, 7902], [505, 7876], [444, 7877], [405, 7807], [384, 7815], [347, 7800], [289, 7807], [204, 7798], [142, 7765], [77, 7752], [64, 7775], [45, 7750], [23, 7765]]] } }, { "type": "Feature", "id": "MD", "properties": { "hc-group": "admin0", "hc-middle-x": 0.47, "hc-middle-y": 0.30, "hc-key": "md", "hc-a2": "MD", "name": "Moldova", "labelrank": "6", "country-abbrev": "Mda.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "MDA", "iso-a2": "MD", "woe-id": "23424885", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[7150, 2258], [7114, 2288], [7132, 2304], [7089, 2403], [7089, 2531], [7070, 2596], [7003, 2689], [6953, 2710], [6884, 2789], [6821, 2832], [6775, 2912], [6729, 2959], [6687, 2976], [6652, 2968], [6685, 3015], [6749, 3021], [6803, 3068], [6850, 3073], [6926, 3031], [6981, 3041], [7015, 3026], [7070, 3029], [7112, 2987], [7141, 3008], [7170, 2984], [7174, 2884], [7248, 2829], [7273, 2849], [7303, 2774], [7302, 2743], [7384, 2725], [7404, 2644], [7448, 2613], [7405, 2591], [7369, 2620], [7355, 2583], [7319, 2610], [7279, 2560], [7258, 2609], [7222, 2574], [7235, 2519], [7256, 2502], [7259, 2448], [7223, 2426], [7228, 2391], [7190, 2327], [7203, 2283], [7150, 2258]]] } }, { "type": "Feature", "id": "CZ", "properties": { "hc-group": "admin0", "hc-middle-x": 0.39, "hc-middle-y": 0.51, "hc-key": "cz", "hc-a2": "CZ", "name": "Czech Republic", "labelrank": "5", "country-abbrev": "Cz. Rep.", "subregion": "Eastern Europe", "region-wb": "Europe & Central Asia", "iso-a3": "CZE", "iso-a2": "CZ", "woe-id": "23424810", "continent": "Europe" }, "geometry": { "type": "Polygon", "coordinates": [[[5131, 3062], [5077, 3047], [5019, 2981], [5005, 2912], [4968, 2872], [4910, 2834], [4839, 2840], [4804, 2763], [4787, 2794], [4702, 2808], [4689, 2788], [4627, 2791], [4583, 2821], [4558, 2815], [4476, 2844], [4422, 2848], [4415, 2776], [4392, 2779], [4376, 2724], [4329, 2736], [4304, 2710], [4257, 2717], [4205, 2765], [4163, 2815], [4139, 2811], [4079, 2860], [4043, 2910], [4004, 2918], [3923, 3034], [3947, 3082], [3894, 3121], [3860, 3197], [3900, 3155], [3940, 3221], [4030, 3255], [4070, 3282], [4109, 3288], [4136, 3323], [4269, 3379], [4256, 3423], [4293, 3419], [4318, 3372], [4354, 3378], [4385, 3380], [4378, 3418], [4435, 3411], [4453, 3363], [4470, 3369], [4591, 3335], [4636, 3338], [4648, 3301], [4615, 3272], [4643, 3260], [4718, 3186], [4762, 3230], [4739, 3283], [4797, 3277], [4830, 3248], [4880, 3250], [4880, 3222], [4931, 3173], [4967, 3187], [5067, 3169], [5088, 3112], [5114, 3108], [5131, 3062]]] } }]
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  "title": "Republic of Serbia",
  "version": "1.1.2",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:32634"
    }
  },
  "hc-transform": {
    "default": {
      "crs": "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs",
      "scale": 0.00159754921225,
      "jsonres": 15.5,
      "jsonmarginX": -999,
      "jsonmarginY": 9851.0,
      "xoffset": 332850.278472,
      "yoffset": 5114255.13063
    }
  },
  "features": [{
    "type": "Feature",
    "id": "RS.JC",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.66,
      "hc-key": "rs-jc",
      "hc-a2": "JC",
      "labelrank": "9",
      "hasc": "RS.JC",
      "alt-name": "South Bačka",
      "woe-id": "29389212",
      "subregion": null,
      "fips": "RB02",
      "postal-code": "JC",
      "name": "Južno-Bački",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Južno-Bački",
      "longitude": "19.647",
      "woe-name": "Južno-Bački",
      "latitude": "45.3888",
      "woe-label": "Juzhna Bachka, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[15, 7103], [44, 7189], [24, 7245], [-13, 7263], [-41, 7315], [-429, 7424], [-501, 7462], [-550, 7523], [-561, 7606], [-660, 7620], [-731, 7655], [-783, 7735], [-680, 7780], [-672, 7840], [-726, 7900], [-738, 7951], [-695, 8016], [-668, 7973], [-621, 7989], [-548, 7952], [-507, 7901], [-423, 7908], [-381, 7883], [-360, 7834], [-237, 7858], [-207, 7898], [-166, 7847], [-84, 7853], [-28, 7838], [-36, 7992], [44, 8028], [36, 8104], [125, 8140], [197, 8097], [247, 8122], [286, 8212], [360, 8232], [356, 8343], [413, 8439], [600, 8323], [692, 8360], [704, 8450], [736, 8512], [748, 8618], [732, 8658], [811, 8695], [875, 8699], [946, 8740], [1009, 8747], [1112, 8730], [1199, 8690], [1315, 8686], [1373, 8667], [1433, 8602], [1390, 8583], [1414, 8465], [1407, 8406], [1330, 8270], [1424, 8265], [1452, 8224], [1398, 8120], [1425, 8059], [1604, 7888], [1648, 7825], [1593, 7694], [1617, 7651], [1712, 7543], [1657, 7450], [1688, 7396], [1783, 7317], [1815, 7181], [1811, 7144], [1756, 7111], [1734, 6994], [1627, 7090], [1555, 7116], [1320, 7093], [1167, 7134], [1140, 7087], [1155, 7052], [1104, 7020], [1023, 7006], [908, 7022], [788, 7022], [752, 7077], [723, 7050], [607, 7010], [414, 7004], [295, 7039], [229, 7082], [145, 7107], [80, 7031], [15, 7103]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.BG",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.47,
      "hc-key": "rs-bg",
      "hc-a2": "BG",
      "labelrank": "9",
      "hasc": "RS.BG",
      "alt-name": "Belgrade",
      "woe-id": "29389217",
      "subregion": null,
      "fips": "RB02",
      "postal-code": "BG",
      "name": "Grad Beograd",
      "country": "Republic of Serbia",
      "type-en": "City",
      "region": null,
      "longitude": "20.4001",
      "woe-name": "Grad Beograd",
      "latitude": "44.6408",
      "woe-label": "Beograd, RS, Serbia",
      "type": "Grad"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1968, 6683], [2048, 6609], [2071, 6562], [2160, 6501], [2161, 6461], [2216, 6397], [2316, 6345], [2358, 6295], [2348, 6211], [2429, 6187], [2412, 6020], [2421, 5955], [2497, 5897], [2591, 5765], [2676, 5688], [2737, 5678], [2690, 5558], [2759, 5399], [2677, 5362], [2623, 5316], [2676, 5214], [2722, 5192], [2788, 5126], [2823, 5053], [2783, 4993], [2706, 5014], [2660, 4994], [2612, 4885], [2662, 4816], [2720, 4798], [2678, 4750], [2690, 4669], [2619, 4734], [2529, 4771], [2448, 4736], [2396, 4785], [2390, 4853], [2364, 4879], [2233, 4829], [2229, 4912], [2122, 4949], [2040, 5005], [1976, 4961], [1956, 4905], [2018, 4844], [1956, 4747], [1933, 4663], [1876, 4654], [1809, 4560], [1741, 4561], [1715, 4517], [1580, 4645], [1537, 4746], [1566, 4799], [1544, 4834], [1563, 4893], [1613, 4978], [1616, 5098], [1599, 5173], [1558, 5221], [1547, 5323], [1520, 5349], [1470, 5249], [1418, 5222], [1360, 5306], [1311, 5298], [1260, 5255], [1160, 5293], [1113, 5347], [1117, 5415], [1098, 5495], [1124, 5625], [1267, 5759], [1363, 5807], [1389, 5951], [1345, 5974], [1341, 6013], [1420, 6052], [1449, 6180], [1504, 6311], [1577, 6313], [1652, 6371], [1820, 6410], [1755, 6544], [1782, 6589], [1839, 6634], [1886, 6700], [1852, 6826], [1852, 6826], [1892, 6829], [1961, 6783], [1961, 6783], [1961, 6783], [1968, 6683]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.JN",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.50,
      "hc-key": "rs-jn",
      "hc-a2": "JN",
      "labelrank": "9",
      "hasc": "RS.JN",
      "alt-name": "South Banat",
      "woe-id": "29389222",
      "subregion": null,
      "fips": "RB02",
      "postal-code": "JN",
      "name": "Južno-Banatski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.9652",
      "woe-name": "Južno-Banatski",
      "latitude": "45.0065",
      "woe-label": "Juzhni Banat, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1968, 6683], [1961, 6783], [1961, 6783], [1961, 6783], [2033, 6877], [2030, 6917], [2077, 6962], [2058, 7011], [2133, 7157], [2239, 7120], [2285, 7195], [2311, 7205], [2397, 7180], [2530, 7099], [2589, 7022], [2614, 7040], [2632, 7111], [2701, 7164], [2745, 7177], [2835, 7258], [2786, 7296], [2974, 7428], [3153, 7441], [3172, 7484], [3264, 7442], [3318, 7392], [3359, 7396], [3411, 7435], [3442, 7412], [3540, 7277], [3640, 7217], [3722, 7215], [3929, 7151], [4034, 7081], [4100, 7002], [4102, 6931], [4033, 6897], [4002, 6858], [4006, 6816], [3963, 6688], [3849, 6647], [3830, 6573], [3889, 6565], [3892, 6518], [3938, 6487], [4032, 6471], [4149, 6421], [4194, 6351], [4161, 6275], [4027, 6243], [3913, 6248], [3861, 6230], [3811, 6139], [3844, 6124], [3765, 6120], [3668, 6088], [3576, 6041], [3510, 5990], [3461, 5906], [3360, 5898], [3293, 5847], [3212, 5835], [3119, 5821], [2911, 5699], [2799, 5667], [2737, 5678], [2676, 5688], [2591, 5765], [2497, 5897], [2421, 5955], [2412, 6020], [2429, 6187], [2348, 6211], [2358, 6295], [2316, 6345], [2216, 6397], [2161, 6461], [2160, 6501], [2071, 6562], [2048, 6609], [1968, 6683]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.SD",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.54,
      "hc-key": "rs-sd",
      "hc-a2": "SD",
      "labelrank": "9",
      "hasc": "RS.SD",
      "alt-name": "Central Banat",
      "woe-id": "29389197",
      "subregion": null,
      "fips": "RB02",
      "postal-code": "SD",
      "name": "Srednje-Banatski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.5398",
      "woe-name": "Srednje-Banatski",
      "latitude": "45.4421",
      "woe-label": "Srednji Banat, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1892, 6829], [1852, 6826], [1852, 6826], [1757, 6969], [1734, 6994], [1756, 7111], [1811, 7144], [1815, 7181], [1783, 7317], [1688, 7396], [1657, 7450], [1712, 7543], [1617, 7651], [1593, 7694], [1648, 7825], [1604, 7888], [1425, 8059], [1398, 8120], [1452, 8224], [1424, 8265], [1330, 8270], [1407, 8406], [1414, 8465], [1390, 8583], [1433, 8602], [1526, 8651], [1495, 8754], [1533, 8786], [1644, 8767], [1793, 8781], [1888, 8774], [1907, 8689], [1967, 8572], [2030, 8531], [1996, 8466], [1957, 8465], [1887, 8418], [1881, 8476], [1849, 8427], [1895, 8377], [1850, 8348], [1834, 8293], [1913, 8251], [2043, 8294], [2231, 8289], [2172, 8401], [2188, 8463], [2274, 8539], [2346, 8526], [2408, 8544], [2421, 8665], [2455, 8706], [2430, 8770], [2454, 8789], [2539, 8645], [2588, 8618], [2638, 8646], [2688, 8710], [2727, 8670], [2714, 8591], [2716, 8448], [2666, 8266], [2673, 8221], [2754, 8059], [2749, 8021], [2677, 7957], [2689, 7919], [2784, 7873], [2875, 7752], [3000, 7638], [3074, 7539], [3172, 7484], [3153, 7441], [2974, 7428], [2786, 7296], [2835, 7258], [2745, 7177], [2701, 7164], [2632, 7111], [2614, 7040], [2589, 7022], [2530, 7099], [2397, 7180], [2311, 7205], [2285, 7195], [2239, 7120], [2133, 7157], [2058, 7011], [2077, 6962], [2030, 6917], [2033, 6877], [1972, 6809], [1961, 6783], [1961, 6783], [1961, 6783], [1961, 6783], [1961, 6783], [1892, 6829]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.PI",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.55,
      "hc-middle-y": 0.48,
      "hc-key": "rs-pi",
      "hc-a2": "PI",
      "labelrank": "9",
      "hasc": "RS.PI",
      "alt-name": "Pirot",
      "woe-id": "29389200",
      "subregion": null,
      "fips": "BU47",
      "postal-code": "PI",
      "name": "Pirotski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "22.5488",
      "woe-name": "Pirotski",
      "latitude": "43.1029",
      "woe-label": "Pirot, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[6466, 2236], [6555, 2218], [6616, 2184], [6763, 2043], [6789, 2006], [6823, 1895], [6928, 1776], [6993, 1727], [7126, 1693], [7134, 1627], [7115, 1534], [7080, 1443], [7041, 1379], [6964, 1315], [6941, 1243], [6832, 1121], [6727, 1081], [6701, 1023], [6668, 888], [6632, 824], [6510, 780], [6357, 818], [6302, 810], [6264, 775], [6182, 794], [6089, 792], [5998, 829], [5962, 876], [5886, 928], [5955, 946], [5958, 992], [5726, 1098], [5675, 1098], [5570, 1153], [5566, 1178], [5643, 1236], [5675, 1279], [5628, 1321], [5652, 1367], [5750, 1422], [5684, 1534], [5608, 1534], [5503, 1612], [5380, 1672], [5442, 1823], [5474, 1830], [5477, 1889], [5443, 1916], [5423, 2041], [5484, 2061], [5561, 2046], [5661, 1997], [5773, 2004], [5807, 2022], [5826, 2124], [5822, 2172], [5946, 2118], [5982, 2115], [6040, 2072], [6093, 2084], [6129, 2135], [6200, 2049], [6314, 2031], [6306, 2066], [6395, 2142], [6466, 2236]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.BO",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.48,
      "hc-key": "rs-bo",
      "hc-a2": "BO",
      "labelrank": "9",
      "hasc": "RS.BO",
      "alt-name": "Bor",
      "woe-id": "29389206",
      "subregion": null,
      "fips": "RO26",
      "postal-code": "BO",
      "name": "Borski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "22.2686",
      "woe-name": "Borski",
      "latitude": "44.3824",
      "woe-label": "Bor, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[5177, 5483], [5195, 5428], [5257, 5378], [5279, 5298], [5313, 5266], [5400, 5243], [5472, 5283], [5690, 5689], [5730, 5755], [5849, 5799], [5936, 5891], [6050, 5867], [6189, 5719], [6257, 5666], [6324, 5634], [6479, 5618], [6610, 5490], [6565, 5403], [6484, 5374], [6442, 5384], [6328, 5446], [6248, 5435], [6219, 5406], [6203, 5313], [6162, 5273], [6062, 5250], [6049, 5151], [6098, 5092], [6108, 4988], [6144, 4909], [6198, 4838], [6265, 4783], [6341, 4750], [6461, 4723], [6478, 4686], [6472, 4553], [6485, 4512], [6401, 4470], [6319, 4360], [6308, 4238], [6322, 4098], [6299, 4055], [6183, 4035], [6124, 3931], [6049, 3923], [6025, 3958], [6014, 4034], [6047, 4058], [6079, 4123], [6051, 4174], [5978, 4191], [5897, 4260], [5807, 4234], [5671, 4248], [5580, 4331], [5502, 4177], [5551, 4131], [5551, 4072], [5600, 3983], [5600, 3918], [5545, 3876], [5459, 3706], [5444, 3607], [5392, 3583], [5372, 3522], [5253, 3589], [5223, 3678], [5188, 3731], [5123, 3687], [5012, 3731], [4926, 3820], [4875, 3838], [4804, 3822], [4761, 3838], [4674, 3834], [4708, 3956], [4747, 3982], [4762, 4037], [4835, 4047], [4907, 4108], [5012, 4125], [5044, 4163], [5010, 4248], [5035, 4282], [5036, 4390], [5017, 4487], [4949, 4435], [4912, 4472], [4907, 4615], [4878, 4663], [4821, 4691], [4751, 4677], [4746, 4752], [4710, 4799], [4710, 4843], [4745, 4878], [4771, 4952], [4820, 4945], [4878, 5026], [4933, 5029], [4962, 5074], [4947, 5140], [4980, 5220], [4970, 5274], [5016, 5297], [5048, 5363], [5139, 5460], [5177, 5483]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.ZL",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.47,
      "hc-key": "rs-zl",
      "hc-a2": "ZL",
      "labelrank": "9",
      "hasc": "RS.ZL",
      "alt-name": "Zlatibor",
      "woe-id": "29389216",
      "subregion": null,
      "fips": "BK00",
      "postal-code": "ZL",
      "name": "Zlatiborski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "19.7284",
      "woe-name": "Zlatiborski",
      "latitude": "43.6263",
      "woe-label": "Zlatibor, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1232, 1171], [1163, 1241], [1043, 1328], [983, 1426], [938, 1425], [867, 1363], [732, 1364], [685, 1382], [608, 1466], [550, 1574], [492, 1551], [360, 1585], [284, 1640], [224, 1723], [149, 1787], [73, 1934], [-43, 2060], [-125, 2188], [-158, 2212], [-430, 2342], [-482, 2388], [-513, 2462], [-513, 2541], [-471, 2603], [-427, 2602], [-353, 2755], [-257, 2752], [-164, 2806], [-98, 2741], [-39, 2617], [4, 2699], [104, 2669], [94, 2784], [107, 2856], [159, 2906], [157, 2978], [112, 3132], [74, 3223], [-126, 3448], [-229, 3622], [-288, 3701], [-378, 3770], [-350, 3812], [-358, 3866], [-330, 3907], [-259, 3920], [-184, 3873], [-108, 3808], [56, 3823], [169, 3809], [265, 3829], [348, 3888], [400, 3970], [361, 4045], [324, 4015], [199, 4126], [259, 4188], [385, 4212], [403, 4267], [484, 4249], [516, 4214], [645, 4156], [712, 4058], [722, 4014], [782, 4039], [760, 4129], [710, 4176], [736, 4200], [814, 4155], [884, 4219], [977, 4197], [992, 4122], [1066, 4078], [1113, 4070], [1129, 4114], [1177, 4147], [1280, 4094], [1296, 4055], [1268, 3925], [1303, 3881], [1265, 3808], [1294, 3746], [1344, 3721], [1359, 3674], [1329, 3616], [1382, 3557], [1460, 3520], [1368, 3507], [1335, 3465], [1329, 3412], [1404, 3293], [1385, 3236], [1393, 3143], [1470, 3093], [1483, 3044], [1450, 2972], [1492, 2921], [1449, 2845], [1407, 2869], [1309, 2883], [1310, 2784], [1224, 2775], [1134, 2707], [1087, 2648], [1047, 2634], [958, 2697], [962, 2626], [927, 2589], [968, 2520], [1043, 2493], [1057, 2462], [1137, 2442], [1160, 2327], [1241, 2176], [1284, 2121], [1325, 2035], [1319, 1974], [1367, 1929], [1615, 1980], [1669, 1927], [1631, 1876], [1600, 1771], [1541, 1721], [1540, 1679], [1598, 1618], [1665, 1581], [1695, 1537], [1618, 1523], [1558, 1492], [1460, 1490], [1407, 1429], [1416, 1389], [1322, 1349], [1285, 1297], [1232, 1171]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.ZC",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.51,
      "hc-key": "rs-zc",
      "hc-a2": "ZC",
      "labelrank": "9",
      "hasc": "RS.ZC",
      "alt-name": "West Bačka",
      "woe-id": "29389204",
      "subregion": null,
      "fips": "HR10",
      "postal-code": "ZC",
      "name": "Zapadno-Backi",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Zapadno-Bački",
      "longitude": "19.2283",
      "woe-name": "Zapadno-Backi",
      "latitude": "45.7092",
      "woe-label": "Zapadna Bachka, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[413, 8439], [356, 8343], [360, 8232], [286, 8212], [247, 8122], [197, 8097], [125, 8140], [36, 8104], [44, 8028], [-36, 7992], [-28, 7838], [-84, 7853], [-166, 7847], [-207, 7898], [-237, 7858], [-360, 7834], [-381, 7883], [-423, 7908], [-507, 7901], [-548, 7952], [-621, 7989], [-668, 7973], [-695, 8016], [-580, 7997], [-523, 8050], [-544, 8090], [-628, 8128], [-690, 8208], [-758, 8175], [-803, 8133], [-839, 8133], [-910, 8229], [-890, 8356], [-845, 8393], [-778, 8489], [-789, 8529], [-874, 8596], [-890, 8631], [-903, 8757], [-999, 8882], [-983, 9014], [-897, 9022], [-888, 9062], [-946, 9117], [-879, 9171], [-889, 9214], [-771, 9202], [-735, 9185], [-733, 9264], [-687, 9296], [-604, 9296], [-600, 9377], [-569, 9429], [-524, 9446], [-481, 9429], [-454, 9374], [-412, 9348], [-244, 9327], [-191, 9336], [-144, 9430], [-121, 9446], [-73, 9368], [-44, 9358], [-33, 9276], [-63, 9210], [-33, 9132], [-27, 9007], [98, 8874], [141, 8741], [225, 8678], [307, 8730], [400, 8661], [359, 8614], [370, 8572], [439, 8533], [460, 8470], [413, 8439]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.SC",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.47,
      "hc-key": "rs-sc",
      "hc-a2": "SC",
      "labelrank": "9",
      "hasc": "RS.SC",
      "alt-name": "North Bačka",
      "woe-id": "29389196",
      "subregion": null,
      "fips": "HU19",
      "postal-code": "SC",
      "name": "Severno-Backi",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Severno-Bački",
      "longitude": "19.5801",
      "woe-name": "Severno-Backi",
      "latitude": "45.9326",
      "woe-label": "Severna Bachka, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[946, 8740], [875, 8699], [811, 8695], [732, 8658], [748, 8618], [736, 8512], [704, 8450], [692, 8360], [600, 8323], [413, 8439], [460, 8470], [439, 8533], [370, 8572], [359, 8614], [400, 8661], [307, 8730], [225, 8678], [141, 8741], [98, 8874], [-27, 9007], [-33, 9132], [-63, 9210], [-33, 9276], [-44, 9358], [-73, 9368], [-121, 9446], [-70, 9466], [34, 9475], [85, 9547], [147, 9567], [217, 9650], [268, 9677], [247, 9747], [275, 9778], [368, 9828], [555, 9851], [636, 9835], [793, 9731], [826, 9723], [986, 9787], [998, 9757], [943, 9689], [957, 9627], [930, 9502], [857, 9416], [837, 9333], [847, 9147], [768, 9101], [822, 9014], [857, 8894], [899, 8893], [940, 8802], [946, 8740]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.SN",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.36,
      "hc-middle-y": 0.39,
      "hc-key": "rs-sn",
      "hc-a2": "SN",
      "labelrank": "9",
      "hasc": "RS.SN",
      "alt-name": "North Banat",
      "woe-id": "29389203",
      "subregion": null,
      "fips": "HU19",
      "postal-code": "SN",
      "name": "Severno-Banatski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.2047",
      "woe-name": "Severno-Banatski",
      "latitude": "45.9589",
      "woe-label": "Severni Banat, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[2454, 8789], [2430, 8770], [2455, 8706], [2421, 8665], [2408, 8544], [2346, 8526], [2274, 8539], [2188, 8463], [2172, 8401], [2231, 8289], [2043, 8294], [1913, 8251], [1834, 8293], [1850, 8348], [1895, 8377], [1849, 8427], [1881, 8476], [1887, 8418], [1957, 8465], [1996, 8466], [2030, 8531], [1967, 8572], [1907, 8689], [1888, 8774], [1793, 8781], [1644, 8767], [1533, 8786], [1495, 8754], [1526, 8651], [1433, 8602], [1373, 8667], [1315, 8686], [1199, 8690], [1112, 8730], [1009, 8747], [946, 8740], [940, 8802], [899, 8893], [857, 8894], [822, 9014], [768, 9101], [847, 9147], [837, 9333], [857, 9416], [930, 9502], [957, 9627], [943, 9689], [998, 9757], [986, 9787], [1093, 9814], [1215, 9801], [1294, 9755], [1397, 9785], [1447, 9779], [1505, 9737], [1554, 9759], [1588, 9745], [1691, 9655], [1810, 9504], [1872, 9336], [1933, 9267], [2044, 9208], [2145, 9114], [2253, 9088], [2318, 9044], [2381, 8929], [2428, 8894], [2454, 8789]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.BR",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.47,
      "hc-key": "rs-br",
      "hc-a2": "BR",
      "labelrank": "9",
      "hasc": "RS.BR",
      "alt-name": "Braničevo",
      "woe-id": "29389198",
      "subregion": null,
      "fips": "RO12",
      "postal-code": "BR",
      "name": "Branicevski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Braničevski",
      "longitude": "21.5363",
      "woe-name": "Branicevski",
      "latitude": "44.4632",
      "woe-label": "Branichevo, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[5177, 5483], [5139, 5460], [5048, 5363], [5016, 5297], [4970, 5274], [4980, 5220], [4947, 5140], [4962, 5074], [4933, 5029], [4878, 5026], [4820, 4945], [4771, 4952], [4745, 4878], [4710, 4843], [4710, 4799], [4746, 4752], [4751, 4677], [4821, 4691], [4878, 4663], [4907, 4615], [4912, 4472], [4949, 4435], [5017, 4487], [5036, 4390], [5035, 4282], [5010, 4248], [5044, 4163], [5012, 4125], [4907, 4108], [4835, 4047], [4762, 4037], [4723, 4062], [4673, 4050], [4609, 4100], [4515, 4082], [4416, 4163], [4303, 4163], [4246, 4181], [4222, 4236], [4105, 4352], [4061, 4344], [3999, 4387], [3919, 4348], [3840, 4367], [3869, 4435], [3821, 4461], [3784, 4555], [3718, 4608], [3670, 4509], [3590, 4528], [3557, 4587], [3455, 4640], [3405, 4638], [3377, 4653], [3377, 4709], [3420, 4745], [3357, 4870], [3399, 5020], [3428, 5046], [3484, 5048], [3430, 5104], [3457, 5237], [3429, 5227], [3376, 5312], [3416, 5366], [3416, 5400], [3371, 5496], [3307, 5501], [3312, 5554], [3270, 5620], [3295, 5652], [3240, 5706], [3255, 5764], [3219, 5782], [3212, 5835], [3293, 5847], [3360, 5898], [3461, 5906], [3510, 5990], [3576, 6041], [3668, 6088], [3765, 6120], [3844, 6124], [3881, 6097], [3915, 6025], [3947, 6010], [4114, 5992], [4234, 6003], [4307, 5960], [4355, 5817], [4428, 5746], [4524, 5717], [4625, 5719], [4713, 5738], [4818, 5779], [4851, 5773], [5029, 5682], [5112, 5653], [5177, 5483]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.SM",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.67,
      "hc-middle-y": 0.44,
      "hc-key": "rs-sm",
      "hc-a2": "SM",
      "labelrank": "9",
      "hasc": "RS.SM",
      "alt-name": "Srem",
      "woe-id": "29389205",
      "subregion": null,
      "fips": "HR18",
      "postal-code": "SM",
      "name": "Sremski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "19.6739",
      "woe-name": "Sremski",
      "latitude": "45.0381",
      "woe-label": "Srem, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1734, 6994], [1757, 6969], [1852, 6826], [1852, 6826], [1886, 6700], [1839, 6634], [1782, 6589], [1755, 6544], [1820, 6410], [1652, 6371], [1577, 6313], [1504, 6311], [1449, 6180], [1420, 6052], [1341, 6013], [1345, 5974], [1389, 5951], [1363, 5807], [1267, 5759], [1124, 5625], [1059, 5600], [1021, 5645], [1041, 5676], [1198, 5756], [1144, 5776], [1009, 5776], [878, 5883], [781, 5934], [681, 5937], [632, 5972], [596, 6091], [615, 6153], [702, 6322], [710, 6386], [548, 6441], [491, 6382], [397, 6385], [321, 6352], [269, 6358], [207, 6398], [157, 6356], [119, 6369], [100, 6421], [26, 6470], [8, 6420], [-43, 6395], [-134, 6420], [-72, 6346], [-125, 6355], [-163, 6393], [-215, 6383], [-301, 6404], [-375, 6387], [-403, 6440], [-428, 6435], [-606, 6311], [-741, 6277], [-782, 6359], [-786, 6414], [-732, 6443], [-668, 6389], [-616, 6399], [-565, 6473], [-509, 6513], [-533, 6575], [-574, 6561], [-598, 6609], [-576, 6701], [-597, 6878], [-617, 6939], [-665, 6999], [-636, 7049], [-528, 7035], [-485, 7043], [-476, 7087], [-513, 7181], [-447, 7177], [-391, 7102], [-313, 7083], [-231, 7092], [-184, 7124], [-160, 7092], [15, 7103], [80, 7031], [145, 7107], [229, 7082], [295, 7039], [414, 7004], [607, 7010], [723, 7050], [752, 7077], [788, 7022], [908, 7022], [1023, 7006], [1104, 7020], [1155, 7052], [1140, 7087], [1167, 7134], [1320, 7093], [1555, 7116], [1627, 7090], [1734, 6994]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.MR",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.33,
      "hc-key": "rs-mr",
      "hc-a2": "MR",
      "labelrank": "9",
      "hasc": "RS.MR",
      "alt-name": "Moravica|Morava",
      "woe-id": "29389210",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "MR",
      "name": "Moravicki",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Moravički",
      "longitude": "20.2653",
      "woe-name": "Moravicki",
      "latitude": "43.7127",
      "woe-label": "Moravica, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1669, 1927], [1615, 1980], [1367, 1929], [1319, 1974], [1325, 2035], [1284, 2121], [1241, 2176], [1160, 2327], [1137, 2442], [1057, 2462], [1043, 2493], [968, 2520], [927, 2589], [962, 2626], [958, 2697], [1047, 2634], [1087, 2648], [1134, 2707], [1224, 2775], [1310, 2784], [1309, 2883], [1407, 2869], [1449, 2845], [1492, 2921], [1450, 2972], [1483, 3044], [1470, 3093], [1393, 3143], [1385, 3236], [1404, 3293], [1329, 3412], [1335, 3465], [1368, 3507], [1460, 3520], [1382, 3557], [1329, 3616], [1359, 3674], [1344, 3721], [1294, 3746], [1265, 3808], [1303, 3881], [1268, 3925], [1296, 4055], [1280, 4094], [1404, 4061], [1414, 4124], [1476, 4134], [1504, 4163], [1613, 4163], [1730, 4193], [1755, 4235], [1809, 4259], [1826, 4307], [1890, 4332], [1912, 4404], [1948, 4416], [1999, 4518], [2017, 4441], [2071, 4287], [2173, 4231], [2225, 4126], [2228, 4069], [2337, 4004], [2419, 3906], [2383, 3864], [2336, 3882], [2291, 3823], [2279, 3766], [2199, 3706], [2235, 3631], [2311, 3577], [2385, 3464], [2265, 3358], [2266, 3296], [2204, 3247], [2204, 3170], [2180, 3140], [2121, 3135], [2035, 3097], [2016, 3054], [2063, 3022], [2074, 2933], [2058, 2878], [1999, 2901], [1918, 2881], [1857, 2830], [1887, 2782], [1875, 2694], [1827, 2619], [1750, 2571], [1843, 2483], [1942, 2352], [1927, 2266], [1947, 2199], [1929, 2165], [1961, 2139], [1979, 2062], [1961, 2020], [1911, 2003], [1873, 1937], [1803, 1881], [1790, 1821], [1704, 1872], [1669, 1927]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.NS",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.58,
      "hc-key": "rs-ns",
      "hc-a2": "NS",
      "labelrank": "9",
      "hasc": "RS.NS",
      "alt-name": "Nišava",
      "woe-id": "29389223",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "NS",
      "name": "Nišavski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "21.9087",
      "woe-name": "Nišavski",
      "latitude": "43.3388",
      "woe-label": "Nishava, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[5822, 2172], [5826, 2124], [5807, 2022], [5773, 2004], [5661, 1997], [5561, 2046], [5484, 2061], [5423, 2041], [5443, 1916], [5477, 1889], [5474, 1830], [5442, 1823], [5380, 1672], [5503, 1612], [5608, 1534], [5684, 1534], [5750, 1422], [5652, 1367], [5628, 1321], [5585, 1273], [5469, 1276], [5423, 1329], [5311, 1394], [5204, 1508], [5140, 1527], [5027, 1476], [4961, 1558], [4864, 1493], [4762, 1486], [4736, 1513], [4758, 1544], [4671, 1658], [4706, 1717], [4680, 1784], [4549, 1785], [4550, 1691], [4520, 1685], [4457, 1732], [4405, 1742], [4368, 1780], [4397, 1832], [4349, 1866], [4301, 1966], [4332, 2064], [4285, 2046], [4124, 2057], [4082, 2113], [4173, 2156], [4204, 2200], [4252, 2213], [4276, 2258], [4227, 2368], [4232, 2433], [4273, 2529], [4221, 2584], [4168, 2689], [4101, 2714], [4119, 2790], [4146, 2828], [4104, 2845], [4112, 2899], [4078, 2940], [4082, 2984], [4155, 3023], [4136, 3083], [4086, 3109], [4069, 3163], [4234, 3276], [4298, 3290], [4364, 3281], [4427, 3312], [4543, 3185], [4486, 3128], [4534, 3084], [4504, 3037], [4514, 2948], [4548, 2870], [4639, 2763], [4642, 2725], [4696, 2688], [4763, 2696], [4875, 2668], [4908, 2587], [4967, 2521], [5114, 2556], [5048, 2613], [5050, 2680], [5094, 2678], [5187, 2584], [5186, 2541], [5255, 2458], [5319, 2461], [5429, 2395], [5476, 2383], [5567, 2405], [5695, 2325], [5751, 2380], [5819, 2340], [5849, 2288], [5822, 2172]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.PD",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.43,
      "hc-key": "rs-pd",
      "hc-a2": "PD",
      "labelrank": "9",
      "hasc": "RS.PD",
      "alt-name": "Podunavlje|Danube",
      "woe-id": "29389211",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "PD",
      "name": "Podunavski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.9527",
      "woe-name": "Podunavski",
      "latitude": "44.4765",
      "woe-label": "Podunavlje, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[2737, 5678], [2799, 5667], [2911, 5699], [3119, 5821], [3212, 5835], [3219, 5782], [3255, 5764], [3240, 5706], [3295, 5652], [3270, 5620], [3312, 5554], [3307, 5501], [3371, 5496], [3416, 5400], [3416, 5366], [3376, 5312], [3429, 5227], [3457, 5237], [3430, 5104], [3484, 5048], [3428, 5046], [3399, 5020], [3357, 4870], [3420, 4745], [3377, 4709], [3377, 4653], [3405, 4638], [3473, 4539], [3431, 4520], [3446, 4426], [3404, 4426], [3446, 4387], [3415, 4354], [3311, 4404], [3242, 4399], [3095, 4487], [3088, 4561], [3009, 4528], [2936, 4517], [2823, 4564], [2777, 4558], [2791, 4630], [2763, 4657], [2690, 4669], [2678, 4750], [2720, 4798], [2662, 4816], [2612, 4885], [2660, 4994], [2706, 5014], [2783, 4993], [2823, 5053], [2788, 5126], [2722, 5192], [2676, 5214], [2623, 5316], [2677, 5362], [2759, 5399], [2690, 5558], [2737, 5678]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.PM",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.55,
      "hc-middle-y": 0.54,
      "hc-key": "rs-pm",
      "hc-a2": "PM",
      "labelrank": "9",
      "hasc": "RS.PM",
      "alt-name": "Pomoravlje",
      "woe-id": "29389221",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "PM",
      "name": "Pomoravski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "21.3631",
      "woe-name": "Pomoravski",
      "latitude": "43.9757",
      "woe-label": "Pomoravlje, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[4762, 4037], [4747, 3982], [4708, 3956], [4674, 3834], [4683, 3786], [4623, 3723], [4579, 3648], [4580, 3589], [4493, 3555], [4473, 3488], [4512, 3436], [4427, 3312], [4364, 3281], [4298, 3290], [4234, 3276], [4069, 3163], [3960, 3095], [3894, 3104], [3871, 3204], [3886, 3221], [3806, 3223], [3705, 3193], [3659, 3220], [3686, 3318], [3688, 3392], [3659, 3412], [3622, 3357], [3633, 3273], [3616, 3215], [3569, 3194], [3494, 3129], [3418, 3154], [3413, 3062], [3436, 2989], [3329, 3058], [3260, 3062], [3117, 3102], [3054, 3102], [2990, 3176], [2957, 3319], [3005, 3312], [3042, 3363], [3134, 3410], [3169, 3450], [3140, 3552], [3186, 3594], [3227, 3590], [3226, 3662], [3264, 3703], [3221, 3771], [3268, 3825], [3316, 3830], [3344, 3907], [3304, 3966], [3248, 3980], [3403, 4086], [3416, 4132], [3384, 4181], [3424, 4271], [3415, 4354], [3446, 4387], [3404, 4426], [3446, 4426], [3431, 4520], [3473, 4539], [3405, 4638], [3455, 4640], [3557, 4587], [3590, 4528], [3670, 4509], [3718, 4608], [3784, 4555], [3821, 4461], [3869, 4435], [3840, 4367], [3919, 4348], [3999, 4387], [4061, 4344], [4105, 4352], [4222, 4236], [4246, 4181], [4303, 4163], [4416, 4163], [4515, 4082], [4609, 4100], [4673, 4050], [4723, 4062], [4762, 4037]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.RN",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.43,
      "hc-key": "rs-rn",
      "hc-a2": "RN",
      "labelrank": "9",
      "hasc": "RS.RN",
      "alt-name": "Rasina",
      "woe-id": "29389199",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "RN",
      "name": "Pomoravski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Rasinski",
      "longitude": "21.1638",
      "woe-name": "Pomoravski",
      "latitude": "43.5211",
      "woe-label": "Rasina, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[4069, 3163], [4086, 3109], [4136, 3083], [4155, 3023], [4082, 2984], [4078, 2940], [4112, 2899], [4104, 2845], [4146, 2828], [4119, 2790], [4101, 2714], [4168, 2689], [4221, 2584], [4273, 2529], [4232, 2433], [4227, 2368], [4276, 2258], [4252, 2213], [4204, 2200], [4173, 2156], [4082, 2113], [4037, 2110], [3983, 2155], [3890, 2139], [3816, 2163], [3720, 2135], [3545, 2053], [3536, 1981], [3472, 1928], [3443, 1839], [3402, 1794], [3286, 1748], [3204, 1799], [3157, 1781], [3076, 1790], [3035, 1687], [3049, 1581], [3000, 1541], [2964, 1481], [2815, 1568], [2818, 1683], [2868, 1697], [2815, 1776], [2758, 1813], [2749, 1906], [2815, 2012], [2801, 2043], [2797, 2153], [2735, 2148], [2685, 2169], [2661, 2214], [2703, 2363], [2702, 2412], [2660, 2500], [2729, 2486], [2801, 2517], [2874, 2457], [2939, 2457], [3030, 2491], [2978, 2571], [2956, 2651], [2971, 2717], [3041, 2775], [2960, 2861], [2896, 2872], [2970, 2949], [2973, 3098], [3054, 3102], [3117, 3102], [3260, 3062], [3329, 3058], [3436, 2989], [3413, 3062], [3418, 3154], [3494, 3129], [3569, 3194], [3616, 3215], [3633, 3273], [3622, 3357], [3659, 3412], [3688, 3392], [3686, 3318], [3659, 3220], [3705, 3193], [3806, 3223], [3886, 3221], [3871, 3204], [3894, 3104], [3960, 3095], [4069, 3163]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.RS",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.45,
      "hc-key": "rs-rs",
      "hc-a2": "RS",
      "labelrank": "9",
      "hasc": "RS.RS",
      "alt-name": "Raška",
      "woe-id": "29389224",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "RS",
      "name": "Raški",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.5783",
      "woe-name": "Raški",
      "latitude": "43.3811",
      "woe-label": "Rashka, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[2957, 3319], [2990, 3176], [3054, 3102], [2973, 3098], [2970, 2949], [2896, 2872], [2960, 2861], [3041, 2775], [2971, 2717], [2956, 2651], [2978, 2571], [3030, 2491], [2939, 2457], [2874, 2457], [2801, 2517], [2729, 2486], [2660, 2500], [2702, 2412], [2703, 2363], [2661, 2214], [2685, 2169], [2735, 2148], [2797, 2153], [2801, 2043], [2815, 2012], [2749, 1906], [2758, 1813], [2677, 1817], [2628, 1795], [2470, 1677], [2360, 1657], [2330, 1610], [2399, 1423], [2473, 1402], [2465, 1335], [2422, 1244], [2325, 1121], [2257, 1128], [2208, 1048], [2153, 1020], [2083, 1010], [2048, 965], [2030, 888], [2107, 825], [2126, 766], [2081, 705], [1983, 665], [1815, 630], [1836, 736], [1833, 804], [1800, 849], [1676, 913], [1571, 990], [1513, 1016], [1357, 1044], [1232, 1171], [1285, 1297], [1322, 1349], [1416, 1389], [1407, 1429], [1460, 1490], [1558, 1492], [1618, 1523], [1695, 1537], [1665, 1581], [1598, 1618], [1540, 1679], [1541, 1721], [1600, 1771], [1631, 1876], [1669, 1927], [1704, 1872], [1790, 1821], [1803, 1881], [1873, 1937], [1911, 2003], [1961, 2020], [1979, 2062], [1961, 2139], [1929, 2165], [1947, 2199], [1927, 2266], [1942, 2352], [1843, 2483], [1750, 2571], [1827, 2619], [1875, 2694], [1887, 2782], [1857, 2830], [1918, 2881], [1999, 2901], [2058, 2878], [2074, 2933], [2063, 3022], [2016, 3054], [2035, 3097], [2121, 3135], [2180, 3140], [2204, 3170], [2204, 3247], [2266, 3296], [2265, 3358], [2385, 3464], [2452, 3398], [2519, 3273], [2577, 3233], [2623, 3234], [2682, 3270], [2672, 3365], [2725, 3386], [2815, 3377], [2858, 3410], [2929, 3372], [2957, 3319]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.TO",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.42,
      "hc-key": "rs-to",
      "hc-a2": "TO",
      "labelrank": "9",
      "hasc": "RS.TO",
      "alt-name": "Toplica",
      "woe-id": "29389219",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "TO",
      "name": "Toplički",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Toplički",
      "longitude": "21.3637",
      "woe-name": "Toplicki",
      "latitude": "43.1198",
      "woe-label": "Toplica, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[4082, 2113], [4124, 2057], [4285, 2046], [4332, 2064], [4301, 1966], [4349, 1866], [4397, 1832], [4368, 1780], [4405, 1742], [4457, 1732], [4520, 1685], [4550, 1691], [4549, 1785], [4680, 1784], [4706, 1717], [4671, 1658], [4758, 1544], [4736, 1513], [4762, 1486], [4779, 1444], [4702, 1369], [4575, 1318], [4518, 1255], [4436, 1253], [4358, 1182], [4243, 1170], [4153, 1090], [4050, 1024], [4096, 913], [4046, 859], [4047, 802], [4015, 711], [3966, 666], [3947, 701], [3841, 718], [3736, 782], [3667, 788], [3610, 855], [3595, 1027], [3563, 1088], [3530, 1094], [3474, 1058], [3421, 1115], [3390, 1260], [3327, 1349], [3192, 1356], [3150, 1372], [2964, 1481], [3000, 1541], [3049, 1581], [3035, 1687], [3076, 1790], [3157, 1781], [3204, 1799], [3286, 1748], [3402, 1794], [3443, 1839], [3472, 1928], [3536, 1981], [3545, 2053], [3720, 2135], [3816, 2163], [3890, 2139], [3983, 2155], [4037, 2110], [4082, 2113]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.KB",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.58,
      "hc-key": "rs-kb",
      "hc-a2": "KB",
      "labelrank": "9",
      "hasc": "RS.KB",
      "alt-name": "Kolubara",
      "woe-id": "29389220",
      "subregion": null,
      "fips": "BK00",
      "postal-code": "KB",
      "name": "Kolubarski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "19.9249",
      "woe-name": "Kolubarski",
      "latitude": "44.3209",
      "woe-label": "Kolubara, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1117, 5415], [1113, 5347], [1160, 5293], [1260, 5255], [1311, 5298], [1360, 5306], [1418, 5222], [1470, 5249], [1520, 5349], [1547, 5323], [1558, 5221], [1599, 5173], [1616, 5098], [1613, 4978], [1563, 4893], [1544, 4834], [1566, 4799], [1537, 4746], [1580, 4645], [1715, 4517], [1741, 4561], [1809, 4560], [1876, 4654], [1933, 4663], [1985, 4635], [1999, 4518], [1948, 4416], [1912, 4404], [1890, 4332], [1826, 4307], [1809, 4259], [1755, 4235], [1730, 4193], [1613, 4163], [1504, 4163], [1476, 4134], [1414, 4124], [1404, 4061], [1280, 4094], [1177, 4147], [1129, 4114], [1113, 4070], [1066, 4078], [992, 4122], [977, 4197], [884, 4219], [814, 4155], [736, 4200], [710, 4176], [760, 4129], [782, 4039], [722, 4014], [712, 4058], [645, 4156], [516, 4214], [484, 4249], [403, 4267], [334, 4338], [289, 4447], [228, 4486], [103, 4528], [28, 4578], [38, 4627], [108, 4732], [162, 4781], [141, 4827], [93, 4834], [86, 4882], [127, 4889], [169, 4948], [190, 5030], [153, 5066], [305, 5100], [350, 5045], [396, 5035], [456, 5063], [539, 5075], [696, 5006], [734, 4934], [846, 4938], [872, 4980], [828, 5042], [900, 5070], [887, 5166], [915, 5198], [877, 5306], [891, 5343], [989, 5402], [1024, 5378], [1117, 5415]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.MA",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.34,
      "hc-middle-y": 0.42,
      "hc-key": "rs-ma",
      "hc-a2": "MA",
      "labelrank": "9",
      "hasc": "RS.MA",
      "alt-name": "Mačva",
      "woe-id": "29389202",
      "subregion": null,
      "fips": "BK00",
      "postal-code": "MA",
      "name": "Mačvanski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Mačvanski",
      "longitude": "19.4948",
      "woe-name": "Mačvanski",
      "latitude": "44.5988",
      "woe-label": "Machva, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[1124, 5625], [1098, 5495], [1117, 5415], [1024, 5378], [989, 5402], [891, 5343], [877, 5306], [915, 5198], [887, 5166], [900, 5070], [828, 5042], [872, 4980], [846, 4938], [734, 4934], [696, 5006], [539, 5075], [456, 5063], [396, 5035], [350, 5045], [305, 5100], [153, 5066], [190, 5030], [169, 4948], [127, 4889], [86, 4882], [93, 4834], [141, 4827], [162, 4781], [108, 4732], [38, 4627], [28, 4578], [103, 4528], [228, 4486], [289, 4447], [334, 4338], [403, 4267], [385, 4212], [259, 4188], [199, 4126], [122, 4226], [90, 4298], [55, 4272], [-101, 4407], [-115, 4499], [-172, 4609], [-227, 4643], [-291, 4628], [-461, 4678], [-536, 4742], [-577, 4837], [-594, 4945], [-575, 5002], [-523, 5076], [-518, 5151], [-546, 5274], [-540, 5317], [-470, 5338], [-429, 5391], [-426, 5455], [-381, 5506], [-285, 5662], [-240, 5769], [-178, 5823], [-138, 5902], [-62, 6232], [-36, 6255], [-72, 6346], [-134, 6420], [-43, 6395], [8, 6420], [26, 6470], [100, 6421], [119, 6369], [157, 6356], [207, 6398], [269, 6358], [321, 6352], [397, 6385], [491, 6382], [548, 6441], [710, 6386], [702, 6322], [615, 6153], [596, 6091], [632, 5972], [681, 5937], [781, 5934], [878, 5883], [1009, 5776], [1144, 5776], [1198, 5756], [1041, 5676], [1021, 5645], [1059, 5600], [1124, 5625]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.SU",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.52,
      "hc-key": "rs-su",
      "hc-a2": "SU",
      "labelrank": "9",
      "hasc": "RS.SU",
      "alt-name": "Šumadija",
      "woe-id": "29389225",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "SU",
      "name": "Šumadijski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": null,
      "longitude": "20.8116",
      "woe-name": "Šumadijski",
      "latitude": "44.0985",
      "woe-label": "Shumadija, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[2690, 4669], [2763, 4657], [2791, 4630], [2777, 4558], [2823, 4564], [2936, 4517], [3009, 4528], [3088, 4561], [3095, 4487], [3242, 4399], [3311, 4404], [3415, 4354], [3424, 4271], [3384, 4181], [3416, 4132], [3403, 4086], [3248, 3980], [3304, 3966], [3344, 3907], [3316, 3830], [3268, 3825], [3221, 3771], [3264, 3703], [3226, 3662], [3227, 3590], [3186, 3594], [3140, 3552], [3169, 3450], [3134, 3410], [3042, 3363], [3005, 3312], [2957, 3319], [2929, 3372], [2858, 3410], [2815, 3377], [2725, 3386], [2672, 3365], [2682, 3270], [2623, 3234], [2577, 3233], [2519, 3273], [2452, 3398], [2385, 3464], [2311, 3577], [2235, 3631], [2199, 3706], [2279, 3766], [2291, 3823], [2336, 3882], [2383, 3864], [2419, 3906], [2337, 4004], [2228, 4069], [2225, 4126], [2173, 4231], [2071, 4287], [2017, 4441], [1999, 4518], [1985, 4635], [1933, 4663], [1956, 4747], [2018, 4844], [1956, 4905], [1976, 4961], [2040, 5005], [2122, 4949], [2229, 4912], [2233, 4829], [2364, 4879], [2390, 4853], [2396, 4785], [2448, 4736], [2529, 4771], [2619, 4734], [2690, 4669]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.PC",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.44,
      "hc-key": "rs-pc",
      "hc-a2": "PC",
      "labelrank": "9",
      "hasc": "RS.PC",
      "alt-name": "Pčinja",
      "woe-id": "29389215",
      "subregion": null,
      "fips": "MK59",
      "postal-code": "PC",
      "name": "Pcinjski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Pčinjski",
      "longitude": "22.0252",
      "woe-name": "Pcinjski",
      "latitude": "42.5543",
      "woe-label": "Pchinja, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[6036, 621], [6034, 591], [6084, 474], [6143, 410], [6066, 249], [6081, 211], [6037, -51], [6242, -227], [6267, -307], [6235, -465], [6215, -510], [6136, -548], [6105, -589], [6074, -691], [6045, -730], [5923, -746], [5885, -767], [5808, -752], [5745, -693], [5736, -626], [5708, -617], [5655, -673], [5376, -795], [5305, -809], [5170, -779], [5061, -724], [5013, -729], [4945, -790], [4808, -803], [4583, -943], [4523, -999], [4416, -978], [4292, -969], [4271, -893], [4191, -773], [4193, -707], [4236, -661], [4356, -623], [4398, -583], [4396, -453], [4418, -380], [4499, -298], [4599, -129], [4619, -65], [4603, -11], [4632, 72], [4697, 113], [4691, 198], [4650, 224], [4735, 302], [4731, 365], [4792, 428], [4807, 479], [4946, 511], [5092, 528], [5128, 550], [5143, 605], [5213, 573], [5324, 618], [5376, 620], [5402, 587], [5386, 553], [5444, 539], [5512, 566], [5517, 534], [5686, 421], [5748, 420], [5802, 471], [5897, 521], [5944, 583], [6036, 621]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.JA",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.36,
      "hc-middle-y": 0.48,
      "hc-key": "rs-ja",
      "hc-a2": "JA",
      "labelrank": "9",
      "hasc": "RS.JA",
      "alt-name": "Jablanica",
      "woe-id": "29389208",
      "subregion": null,
      "fips": "MK97",
      "postal-code": "JA",
      "name": "Jablanicki",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Jablanički",
      "longitude": "21.9611",
      "woe-name": "Jablanički",
      "latitude": "42.964",
      "woe-label": "Jablanica, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[5628, 1321], [5675, 1279], [5643, 1236], [5566, 1178], [5570, 1153], [5675, 1098], [5726, 1098], [5958, 992], [5955, 946], [5886, 928], [5962, 876], [5998, 829], [6089, 792], [6182, 794], [6264, 775], [6186, 769], [6137, 704], [6036, 621], [5944, 583], [5897, 521], [5802, 471], [5748, 420], [5686, 421], [5517, 534], [5512, 566], [5444, 539], [5386, 553], [5402, 587], [5376, 620], [5324, 618], [5213, 573], [5143, 605], [5128, 550], [5092, 528], [4946, 511], [4807, 479], [4792, 428], [4731, 365], [4735, 302], [4650, 224], [4534, 244], [4447, 203], [4383, 225], [4286, 334], [4240, 349], [4036, 376], [3962, 373], [3907, 397], [3967, 608], [3966, 666], [4015, 711], [4047, 802], [4046, 859], [4096, 913], [4050, 1024], [4153, 1090], [4243, 1170], [4358, 1182], [4436, 1253], [4518, 1255], [4575, 1318], [4702, 1369], [4779, 1444], [4762, 1486], [4864, 1493], [4961, 1558], [5027, 1476], [5140, 1527], [5204, 1508], [5311, 1394], [5423, 1329], [5469, 1276], [5585, 1273], [5628, 1321]]]
    }
  }, {
    "type": "Feature",
    "id": "RS.ZJ",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.40,
      "hc-middle-y": 0.54,
      "hc-key": "rs-zj",
      "hc-a2": "ZJ",
      "labelrank": "9",
      "hasc": "RS.ZJ",
      "alt-name": "Zaječar",
      "woe-id": "29389213",
      "subregion": null,
      "fips": "RB00",
      "postal-code": "ZJ",
      "name": "Zajecarski",
      "country": "Republic of Serbia",
      "type-en": "District",
      "region": "Zaječarski",
      "longitude": "22.1524",
      "woe-name": "Zaječarski",
      "latitude": "43.6834",
      "woe-label": "Zajechar, RS, Serbia",
      "type": "Okrug"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [[[6049, 3923], [5942, 3892], [5919, 3854], [5911, 3697], [5882, 3634], [5879, 3552], [5828, 3343], [5855, 3269], [5908, 3208], [5914, 3082], [5944, 3013], [5988, 2961], [6047, 2930], [6082, 2874], [6101, 2777], [6097, 2663], [6122, 2613], [6182, 2431], [6277, 2375], [6320, 2324], [6404, 2309], [6466, 2236], [6395, 2142], [6306, 2066], [6314, 2031], [6200, 2049], [6129, 2135], [6093, 2084], [6040, 2072], [5982, 2115], [5946, 2118], [5822, 2172], [5849, 2288], [5819, 2340], [5751, 2380], [5695, 2325], [5567, 2405], [5476, 2383], [5429, 2395], [5319, 2461], [5255, 2458], [5186, 2541], [5187, 2584], [5094, 2678], [5050, 2680], [5048, 2613], [5114, 2556], [4967, 2521], [4908, 2587], [4875, 2668], [4763, 2696], [4696, 2688], [4642, 2725], [4639, 2763], [4548, 2870], [4514, 2948], [4504, 3037], [4534, 3084], [4486, 3128], [4543, 3185], [4427, 3312], [4512, 3436], [4473, 3488], [4493, 3555], [4580, 3589], [4579, 3648], [4623, 3723], [4683, 3786], [4674, 3834], [4761, 3838], [4804, 3822], [4875, 3838], [4926, 3820], [5012, 3731], [5123, 3687], [5188, 3731], [5223, 3678], [5253, 3589], [5372, 3522], [5392, 3583], [5444, 3607], [5459, 3706], [5545, 3876], [5600, 3918], [5600, 3983], [5551, 4072], [5551, 4131], [5502, 4177], [5580, 4331], [5671, 4248], [5807, 4234], [5897, 4260], [5978, 4191], [6051, 4174], [6079, 4123], [6047, 4058], [6014, 4034], [6025, 3958], [6049, 3923]]]
    }
  }]
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mixin = {
  methods: {
    getIconForArticleType: function getIconForArticleType(articleType) {
      var icon = 'fa-';

      switch (articleType) {
        case 'key':
          return icon + 'file-text';
        case 'video':
          return icon + 'video-camera';
        case 'blog':
          return icon + 'comment';
        case 'infographic':
          return icon + 'pie-chart';
        default:
          return icon + 'file-text';
      }
    },

    formatDate: function formatDate(dateString, language) {
      if (!language) {
        language = this.$lang;
      }

      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var monthNamesRS = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'];

      var date = new Date(dateString);
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var month = language === 'en' ? monthNames[date.getMonth()] : monthNamesRS[date.getMonth()];

      return day + '. ' + month + ' ' + date.getFullYear();
    },

    checkArticlePublishDate: function checkArticlePublishDate(publishDate) {
      var now = new Date();
      var when = new Date(publishDate);
      return when < now;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.mixin(mixin);
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LandingView__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LandingView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LandingView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_AboutView__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_AboutView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_AboutView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_KeyArticlesView__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_KeyArticlesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_KeyArticlesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_InitiatorsView__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_InitiatorsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_InitiatorsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_ManagementView__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_ManagementView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_ManagementView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_AboutAuthorsView__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_AboutAuthorsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_AboutAuthorsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_AuthorsView__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_AuthorsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_AuthorsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_BlogView__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_BlogView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_BlogView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_ContactView__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_ContactView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_ContactView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_InfographicsView__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_InfographicsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_InfographicsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_VideoView__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_VideoView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_VideoView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_ArticleView__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_ArticleView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_ArticleView__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_2__components_LandingView___default.a }, { path: '/:slug', name: 'article', props: true, component: __WEBPACK_IMPORTED_MODULE_13__components_pages_ArticleView___default.a }, {
    path: '/articles/:id',
    name: 'articleById',
    props: { id: true, fromId: true },
    component: __WEBPACK_IMPORTED_MODULE_13__components_pages_ArticleView___default.a
  }, { path: '/authors', name: 'authors', component: __WEBPACK_IMPORTED_MODULE_8__components_pages_AuthorsView___default.a }, { path: '/key-articles', name: 'key_articles', component: __WEBPACK_IMPORTED_MODULE_4__components_pages_KeyArticlesView___default.a }, { path: '/blog', name: 'blog', component: __WEBPACK_IMPORTED_MODULE_9__components_pages_BlogView___default.a }, { path: '/video', name: 'video', component: __WEBPACK_IMPORTED_MODULE_12__components_pages_VideoView___default.a }, { path: '/infographics', name: 'infographics', component: __WEBPACK_IMPORTED_MODULE_11__components_pages_InfographicsView___default.a }, { path: '/about', name: 'about', component: __WEBPACK_IMPORTED_MODULE_3__components_pages_AboutView___default.a }, { path: '/about/initiators', name: 'initiators', component: __WEBPACK_IMPORTED_MODULE_5__components_pages_InitiatorsView___default.a }, { path: '/about/management', name: 'management', component: __WEBPACK_IMPORTED_MODULE_6__components_pages_ManagementView___default.a }, { path: '/about/authors', name: 'aboutAuthors', component: __WEBPACK_IMPORTED_MODULE_7__components_pages_AboutAuthorsView___default.a }, { path: '/contact', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_10__components_pages_ContactView___default.a }]
}));

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(62);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    if (id) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('authors/' + id + '?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('authors?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang);
    }
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_Footer__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_SearchComponent__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_SearchComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_SearchComponent__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      titleTemplate: 'MONS - %s'
    };
  },

  components: {
    FooterView: __WEBPACK_IMPORTED_MODULE_2__components_ui_Footer___default.a,
    SearchComponent: __WEBPACK_IMPORTED_MODULE_3__components_ui_SearchComponent___default.a
  },
  data: function data() {
    return {
      chapters: [],
      currentChapter: undefined,
      currentLanguage: 'sr',
      scrollPosition: null,
      title: this.$t('title.landing')
    };
  },
  created: function created() {
    this.getChapters();

    window.addEventListener('scroll', this.handleScroll);
    this.$on('chapterChanged', function (value) {
      this.chapterChanged(value);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      this.scrollPosition = window.scrollY;
    },
    chapterChanged: function chapterChanged(chapterId) {
      if (this.chapters.length === 0) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.chapters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var chapter = _step.value;

          if (chapter.id === chapterId) {
            this.currentChapter = chapter;
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log("Didn't find any");
    },
    languageChanged: function languageChanged(language) {
      this.currentLanguage = language;
    },
    getChapters: function getChapters() {
      var _this = this;

      this.$http.get('chapters', {
        params: {
          lang: this.$lang
        }
      }).then(function (response) {
        _this.chapters = response.body;
        _this.currentChapter = _this.chapters[0];
      }, function (response) {
        console.error(response.body);
      });
    },
    openSelect: function openSelect() {
      var e = document.createEvent('MouseEvents');
      e.initMouseEvent('mousedown');
      document.getElementById('lang-select').dispatchEvent(e);
    },
    changeLanguage: function changeLanguage() {
      if (this.currentLanguage === 'sr') {
        this.currentLanguage = 'en';
      } else {
        this.currentLanguage = 'sr';
      }
    }
  },

  events: {
    chapterChanged: function chapterChanged(chapterId) {
      if (this.chapters.length === 0) {
        return;
      }

      for (var chapter in this.chapters) {
        if (chapter.id === chapterId) {
          this.currentChapter = chapter;
          return;
        }
      }
    }
  },

  watch: {
    currentLanguage: function currentLanguage() {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.lang = this.currentLanguage;
      this.title = this.$t('title.landing');
      this.getChapters();
    }
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui__ = __webpack_require__(118);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__ui__["c" /* CoverImage */],
    ArticleCard: __WEBPACK_IMPORTED_MODULE_0__ui__["d" /* ArticleCard */],
    ChapterPicker: __WEBPACK_IMPORTED_MODULE_0__ui__["e" /* ChapterPicker */]
  },
  props: {
    chapter: Object,
    language: String,
    chapters: Array
  },
  data: function data() {
    return {
      articles: null,
      relatedResearch: null,
      title: this.$t('navigation.home')
    };
  },
  created: function created() {
    if (this.chapter != null) {
      this.getArticles();
    }

    this.$on('articleSelected', function (articleId) {
      var div = document.querySelectorAll('[data-id="' + articleId + '"]');
      console.log(div);
      div[0].scrollIntoView();
      window.scrollBy(0, -100);
    });
  },

  watch: {
    chapter: function chapter() {
      this.getArticles();
    },
    language: function language() {
      this.getArticles();
    }
  },
  methods: {
    getArticles: function getArticles() {
      var _this = this;

      this.$http.get('chapters/' + this.chapter.id + '/articles?lang=' + this.$lang).then(function (response) {
        _this.articles = response.body;
      }, function (response) {
        console.error(response.body);
      });
    },
    isOddIndex: function isOddIndex(index) {
      return index % 2 === 0;
    },
    getClassesForArticle: function getClassesForArticle(index) {
      var classes = index === 0 ? 'first ' : '';
      classes += !this.isOddIndex(index) ? 'offset-md-6' : '';

      return classes;
    }
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(81);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutAuthorsView',
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: this.$t('navigation.aboutAuthors')
    };
  },

  components: { CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a },
  props: {
    language: String
  },
  computed: {
    authors: function authors() {
      return __WEBPACK_IMPORTED_MODULE_1__locales__["a" /* default */][this.language].pages.aboutAuthors.content;
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutView',
  components: { CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: this.$t('navigation.about')
    };
  },

  props: {
    language: String
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ArticlesService__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui__ = __webpack_require__(118);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleView',
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{ property: 'og:type', content: 'article' }, {
        property: 'og:url',
        content: 'http://mons.rs' + this.$route.fullPath
      }, { property: 'og:title', content: this.title }, {
        property: 'og:description',
        content: this.translation != null ? this.translation.description : ''
      }, {
        property: 'og:image',
        content: this.article != null ? this.article.image : this.$route + '/static/placeholders/placeholder-logo.jpg'
      }]
    };
  },

  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a,
    GraphView: __WEBPACK_IMPORTED_MODULE_2__ui__["a" /* GraphView */],
    MapsView: __WEBPACK_IMPORTED_MODULE_2__ui__["b" /* MapsView */]
  },
  props: {
    language: String,
    fromId: Boolean
  },
  computed: {
    translation: function translation() {
      if (this.article == null) {
        return null;
      }

      return this.article.articleTranslations[0];
    },
    chartOptions: function chartOptions() {
      return JSON.parse(this.translation.chartOptions);
    },
    chartData: function chartData() {
      return JSON.parse(this.translation.chartData);
    },
    graphExists: function graphExists() {
      if (this.chartOptions && this.chartData) {
        if (this.chartOptions.chart.type !== 'map') {
          return true;
        }
      }
      return false;
    },
    hasPreviousArticle: function hasPreviousArticle() {
      return this.article.previousArticle;
    },
    hasNextArticle: function hasNextArticle() {
      return this.article.nextArticle;
    },
    mapExists: function mapExists() {
      if (this.chartOptions && this.chartData) {
        if (this.chartOptions.chart.type === 'map') {
          return true;
        }
      }
      return false;
    }
  },
  data: function data() {
    return {
      article: null,
      title: ''
    };
  },

  created: function created() {
    if (this.translation !== null && this.translation.slug === ' ') {
      this.getArticleForId(this.article.id);
    } else {
      this.getArticle();
    }
  },
  watch: {
    language: function language() {
      this.getArticleForId(this.article.id);
    },
    article: function article() {
      this.title = this.translation.title;
      this.$emit('languageChanged', this.translation.language);
    },
    $route: function $route() {
      this.getArticle();
    }
  },
  methods: {
    getArticle: function getArticle() {
      var _this = this;

      var slug = this.$route.params.slug;
      __WEBPACK_IMPORTED_MODULE_1__services_ArticlesService__["a" /* default */].get(slug).then(function (response) {
        _this.article = response.body;
        if (new Date(_this.article.publishDate).getTime() > new Date().getTime()) {}
        _this.setupContent();
      }, function (response) {
        console.error(response.body);
      });
    },
    getArticleForId: function getArticleForId(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_ArticlesService__["a" /* default */].getForId(id).then(function (response) {
        _this2.article = response.body;
        if (_this2.translation !== null && _this2.translation.slug !== ' ') {
          _this2.$router.replace({
            name: 'article',
            params: { slug: _this2.translation.slug }
          });
        }
        if (new Date(_this2.article.publishDate).getTime() > new Date().getTime()) {}
        _this2.setupContent();
      }, function (response) {
        console.error(response.body);
      });
    },
    setupContent: function setupContent() {
      if (this.$refs.content === null || this.$refs.content === undefined) {
        return;
      }
    },

    print: function print() {
      window.print();
    }
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_AuthorCard__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_AuthorCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_AuthorCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthorsService__ = __webpack_require__(175);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthorsView',
  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a,
    AuthorCard: __WEBPACK_IMPORTED_MODULE_1__components_ui_AuthorCard___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  props: {
    language: String
  },
  data: function data() {
    return {
      authors: null,
      title: this.$t('navigation.authors')
    };
  },
  created: function created() {
    this.getAuthors();
  },

  methods: {
    getAuthors: function getAuthors() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_AuthorsService__["a" /* default */].get(false).then(function (response) {
        _this.authors = response.body;
      }, function (response) {
        console.error(response.body);
      });
    }
  },
  watch: {
    language: function language() {
      this.getAuthors();
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BlogView',
  components: {
    ArticleCard: __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default.a,
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      articles: null,
      title: this.$t('navigation.blog')
    };
  },

  props: {
    language: String
  },
  created: function created() {
    this.getBlogPosts();
  },

  methods: {
    getBlogPosts: function getBlogPosts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__["a" /* default */].getByType('blog').then(function (response) {
        _this.articles = response.body;
      }, function (response) {
        console.error(response.body);
      });
    }
  },
  watch: {
    language: function language() {
      this.getBlogPosts();
    }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactView',
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: this.$t('navigation.contact')
    };
  },

  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a
  },
  props: {
    language: String
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfographicsView',
  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a,
    ArticleCard: __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      articles: null,
      title: this.$t('navigation.infographics')
    };
  },

  props: {
    language: String
  },
  created: function created() {
    this.getInfographics();
  },

  methods: {
    getInfographics: function getInfographics() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__["a" /* default */].getByType('infographic').then(function (response) {
        _this.articles = response.body;
      }, function (response) {
        console.error(response.body);
      });
    }
  },
  watch: {
    language: function language() {
      this.getInfographics();
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InitiatorsView',
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: this.$t('navigation.initiators')
    };
  },

  components: { CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a },
  props: {
    language: String
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KeyArticlesView',
  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a,
    ArticleCard: __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  props: {
    language: String
  },
  data: function data() {
    return {
      articles: null,
      title: this.$t('navigation.key_articles')
    };
  },
  created: function created() {
    this.getKeyArticles();
  },

  methods: {
    getKeyArticles: function getKeyArticles() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__["a" /* default */].getByType('key').then(function (response) {
        _this.articles = response.body;
      }, function (response) {
        console.error(response.body);
      });
    }
  },
  watch: {
    language: function language() {
      this.getKeyArticles();
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(81);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ManagementView',
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: this.$t('navigation.management')
    };
  },

  components: { CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a },
  props: {
    language: String
  },
  computed: {
    sections: function sections() {
      return __WEBPACK_IMPORTED_MODULE_1__locales__["a" /* default */][this.language].pages.management.sections;
    }
  }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoView',
  components: {
    CoverImage: __WEBPACK_IMPORTED_MODULE_0__components_ui_CoverImage___default.a,
    ArticleCard: __WEBPACK_IMPORTED_MODULE_1__components_ui_ArticleCard___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  props: {
    language: String
  },
  data: function data() {
    return {
      articles: null,
      title: this.$t('navigation.video')
    };
  },
  created: function created() {
    this.getVideos();
  },

  methods: {
    getVideos: function getVideos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_ArticlesService__["a" /* default */].getByType('video').then(function (response) {
        _this.articles = response.body;
      }, function (response) {
        console.error(response.body);
      });
    }
  },
  watch: {
    language: function language() {
      this.getVideos();
    }
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleCard',

  props: {
    article: {
      type: Object,
      required: true
    },
    orientation: {
      validator: function validator(value) {
        return value === 'left' || value === 'right';
      },
      default: function _default() {
        return 'left';
      }
    },
    published: {
      type: Boolean,
      default: false
    },
    inFeed: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    translation: function translation() {
      return this.article.articleTranslations[0];
    },
    articleDate: function articleDate() {
      return this.formatDate(this.article.publishDate);
    }
  }

});

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-0be37176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthorCard',
  props: {
    author: {
      type: Object,
      required: true
    }
  },
  computed: {
    translation: function translation() {
      return this.author.authorTranslations[0];
    }
  }
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter-picker',
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    name: String,
    items: Array,
    language: String,
    initialItem: Object
  },
  data: function data() {
    return {
      selectedChapter: undefined,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        preventClicks: false,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  mounted: function mounted() {
    if (this.items.length > 0) {
      this.selectedChapter = this.items[0].id;
    }
  },
  methods: {
    selectChapter: function selectChapter(chapterId) {
      this.selectedChapter = this.$refs.mySwiper.swiper.clickedSlide.getAttribute('id');
    }
  },
  watch: {
    initialItem: function initialItem() {
      this.selectedChapter = this.initialItem.id;
    },
    items: function items() {},
    selectedChapter: function selectedChapter() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === this.selectedChapter) {
          this.$refs.mySwiper.swiper.slideTo(this.items.length - i - 1);
          break;
        }
      }

      this.$parent.$emit('chapterChanged', this.selectedChapter);
    }
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter-select',
  props: {
    name: String,
    items: Array,
    language: String
  },
  data: function data() {
    return {
      selectedChapter: undefined
    };
  },
  methods: {
    openSelect: function openSelect() {
      var e = document.createEvent('MouseEvents');
      e.initMouseEvent('mousedown');
      document.getElementById('chapter-select').dispatchEvent(e);
    }
  },
  watch: {
    items: function items() {
      this.selectedChapter = this.items[0].id;
    },
    selectedChapter: function selectedChapter() {
      this.$parent.$emit('chapterChanged', this.selectedChapter);
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoverImage',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    editorGender: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'medium',
      validator: function validator(value) {
        var styles = ['large', 'medium', 'small', 'landing'];
        return styles.indexOf(value) > -1;
      }
    }
  },
  data: function data() {
    return {
      genderLabel: ''
    };
  },
  mounted: function mounted() {
    this.updateGenderLabel();
  },

  watch: {
    editorGender: function editorGender() {
      this.updateGenderLabel();
    }
  },
  methods: {
    updateGenderLabel: function updateGenderLabel() {
      switch (this.editorGender) {
        case 'm':
          this.genderLabel = 'label.editor';
          break;
        case 'f':
          this.genderLabel = 'label.editor_female';
          break;
        case 'o':
          this.genderLabel = 'label.editors';
          break;
        case 'of':
          this.genderLabel = 'label.editors_female';
          break;
        default:
          this.genderLabel = 'label.editor';
          break;
      }
    }
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FooterView',
  computed: {
    year: function year() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GraphView',
  data: function data() {
    return {
      hchart: undefined,
      divisions: [],
      selectedField: '',
      selectedDivision: ''
    };
  },
  props: {
    chartData: undefined,
    chartOptions: undefined
  },
  mounted: function mounted() {
    this.selectedField = this.chartData.fields[0];
  },
  watch: {
    selectedDivision: function selectedDivision() {
      this.updateSeries(this.chartData.values, this.selectedField, this.selectedDivision);
    },
    selectedField: function selectedField() {
      this.divisions = this.getKeys(this.chartData.values[this.selectedField]);
      console.log('Divisions: ' + this.divisions);
      this.selectedDivision = this.divisions[0];
      this.updateSeries(this.chartData.values, this.selectedField, this.selectedDivision);
    },
    chartData: function chartData() {
      if (this.hchart !== undefined) {
        this.selectedField = this.chartData.fields[0];
        this.hchart.update(this.chartOptions);
      }
    }
  },
  methods: {
    getKeys: function getKeys(data) {
      var retVal = [];
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          retVal.push(key);
        }
      }
      console.log('Get keys: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(retVal));
      return retVal;
    },
    getSeries: function getSeries(data, categories) {
      var retVal = [];
      for (var i = 0; i < categories.length; i++) {
        var dataArr = [];
        for (var val in data) {
          if (data.hasOwnProperty(val)) {
            dataArr.push(data[val][categories[i]]);
          }
        }
        var tempSeries = {
          name: categories[i],
          data: dataArr
        };
        if (this.chartOptions.additionalOptions != null) {
          if (this.chartOptions.additionalOptions.seriesColors != null) {
            tempSeries.color = this.chartOptions.additionalOptions.seriesColors[categories[i]];
          }
        }
        retVal.push(tempSeries);
      }
      return retVal;
    },
    updateSeries: function updateSeries(data, selectedField, selectedDivision) {
      if (selectedDivision === undefined) {
        selectedDivision = 0;
      }
      console.log('categories \n');
      var categories = this.getKeys(data[selectedField][selectedDivision]);
      console.log('subcategories now \n');
      var subcategories = this.getKeys(data[selectedField][selectedDivision][categories[0]]);
      var series = this.getSeries(data[selectedField][selectedDivision], subcategories);
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(series));
      var length;

      if (this.hchart === undefined) {
        this.hchart = new __WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.Chart('containerChart', this.chartOptions);
      } else {
        length = this.hchart.series.length;
        for (var i = length - 1; i >= 0; i--) {
          this.hchart.series[i].remove(false);
        }
      }
      this.hchart.setTitle({ text: selectedField }, { text: selectedDivision });
      this.hchart.xAxis[0].setCategories(categories, false);
      length = series.length;
      for (i = 0; i < length; i++) {
        this.hchart.addSeries(series[i], false);
      }
      this.hchart.redraw();
    }
  }
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_highmaps__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_highmaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_highmaps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_map_europe__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_map_serbia__ = __webpack_require__(172);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapsView',
  data: function data() {
    return {
      hmap: {},
      series: [],
      mapData: {},
      selectedField: undefined
    };
  },
  props: {
    chartData: undefined,
    chartOptions: undefined
  },
  mounted: function mounted() {
    this.mapData['europe'] = __WEBPACK_IMPORTED_MODULE_2__assets_map_europe__["a" /* default */];
    this.mapData['serbia'] = __WEBPACK_IMPORTED_MODULE_3__assets_map_serbia__["a" /* default */];

    var MapData = this.mapData[this.chartData['mapType']];

    console.log(this.mapData['europe']);

    for (var country in this.chartData.values) {
      if (this.chartData.values.hasOwnProperty(country)) {
        if (this.chartData.values[country]['hc-key'] === 'eu') {
          MapData["features"].push({
            "type": "Feature",
            "id": "eu",
            "properties": {
              "hc-key": "eu",
              "name": "European Union (28 countries)"
            },
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[-3500, 6000], [0, 6000], [0, 6500], [-3500, 6500]]]
            }
          });

          break;
        }
      }
    }

    if (this.chartOptions) {
      var defaultConfig = {
        chart: {
          height: '100%',
          spacing: [12, 12, 12, 12],
          margin: [null],
          plotBorderColor: '#ffffff',
          map: MapData
        },
        exporting: {
          enabled: false
        },
        title: {
          align: 'left',
          style: { color: '#8D223B', fontSize: '1.25rem', fontWeight: 'bold', lineHeight: '1.5' }
        },
        tootlip: {
          backgroundColor: '#ffffff',
          borderRadius: '3',
          borderWidth: '0',
          style: { color: '#262626', boxShadow: '0 0 6px rgba(0,0,0,0.3)' }
        },
        series: [{
          mapData: MapData,
          borderColor: '#cccccc',
          states: {
            hover: {
              color: '#8D223B'
            }
          },
          dataLabels: {
            allowOverlap: true,
            enabled: true,
            crop: false,
            format: '{point.name}'
          },
          name: 'Value'
        }],
        colorAxis: {
          minColor: '#f5fff2',
          maxColor: '#618A51',
          gridLineColor: '#ffffff'
        },
        credits: {
          enabled: false
        },
        yAxis: {
          maxPadding: 0.05,
          labels: {
            step: 1
          }
        }
      };

      this.chartOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartOptions, defaultConfig);
    }

    this.hmap = new __WEBPACK_IMPORTED_MODULE_1_highcharts_highmaps___default.a.Map('containerMap', this.chartOptions);
    this.selectedField = this.chartData.fields[0];
  },
  watch: {
    selectedField: function selectedField() {
      this.setData(this.selectedField);
    }
  },
  methods: {
    setData: function setData(field) {
      this.hmap.series[0].setData(this.getValuesForFieldInData(field, this.chartData.values));
      this.hmap.series[0].name = field;
      this.hmap.series[0].update({
        tooltip: {
          pointFormatter: function pointFormatter() {
            return this.name + ': ' + this.value + (this.misc ? '*' : '');
          }
        }
      }, true);
      this.updateTitle(field);
    },

    getValuesForFieldInData: function getValuesForFieldInData(field, values) {
      var arr = [];
      for (var key in values) {
        if (values.hasOwnProperty(key)) {
          var mapDataItem = {
            'hc-key': values[key]['hc-key'],
            'name': key,
            'value': parseFloat(values[key][field])
          };

          arr.push(mapDataItem);
        }
      }
      return arr;
    },

    updateTitle: function updateTitle(field) {
      this.hmap.setTitle({
        text: field
      });
    }
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ArticlesService__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  data: function data() {
    return {
      searchQuery: '',
      searchResults: [],
      searchResultsShown: false
    };
  },

  computed: {
    searchResultsExist: function searchResultsExist() {
      return this.searchResults != null && this.searchResults.length > 0;
    }
  },
  methods: {
    showArticle: function showArticle(slug) {
      this.searchQuery = '';
      this.searchResults = [];
      this.$refs.search.value = '';
      this.$router.push({ name: 'article', params: { slug: slug } });
    },
    focusLost: function focusLost() {
      var _this = this;

      setTimeout(function () {
        _this.hideSearchResults();
      }, 250);
    },
    hideSearchResults: function hideSearchResults() {
      this.searchResultsShown = false;
    },
    showSearchResults: function showSearchResults() {
      this.searchResultsShown = true;
    }
  },
  watch: {
    searchQuery: function searchQuery() {
      var _this2 = this;

      if (this.searchQuery.length === 0) {
        this.searchResults = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_ArticlesService__["a" /* default */].search(this.searchQuery).then(function (response) {
        console.log(response);
        _this2.searchResults = response.body;
        _this2.showSearchResults();
      }).catch(function (err) {
        console.error(err);
      });
    }
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vis__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vis__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'timeline',
  props: {
    chapter: Object,
    language: String
  },
  data: function data() {
    return {
      timeline: null,
      articles: [],
      items: null
    };
  },

  mounted: function mounted() {
    var container = this.$refs['timelinePresenter'];
    this.items = new __WEBPACK_IMPORTED_MODULE_1_vis___default.a.DataSet([]);
    var options = {
      zoomable: false,
      align: 'left',
      margin: {
        item: { vertical: 0 },
        axis: 0
      },
      timeAxis: { scale: 'day', step: 7 },
      orientation: { axis: 'top', item: 'top' },
      order: function order(left, right) {
        return new Date(left.publishDate) > new Date(right.publishDate) ? left : right;
      }
    };
    this.timeline = new __WEBPACK_IMPORTED_MODULE_1_vis___default.a.Timeline(container, this.items, options);
    this.timeline.on('select', this.selectArticle);
    this.getArticles();
  },
  watch: {
    chapter: function chapter() {
      this.getArticles();
    },
    language: function language() {
      this.getArticles();
    }
  },
  methods: {
    getArticles: function getArticles(success, fail) {
      var _this = this;

      if (!this.chapter) {
        return;
      }
      this.$http.get('chapters/' + this.chapter.id + '/articles?lang=' + this.$lang).then(function (response) {
        _this.setUpItemsWith(response.body);
      }, function (response) {
        console.error(response.body);
        _this.items.clear();
      });
    },
    setUpItemsWith: function setUpItemsWith(articles) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(articles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var article = _step.value;

          article.content = '<div class="timeline-item"> ' + '<div class="item-icon"><i class="fa ' + this.getIconForArticleType(article.articleType.name) + '"></i></div>' + '</div>';
          article.start = new Date(article.publishDate);
          article.title = article.articleTranslations[0].title + '<br/>' + this.formatDate(article.publishDate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.articles = articles;

      this.items.clear();
      this.items.add(this.articles);

      this.timeline.setItems(this.items);
      this.timeline.fit();
    },
    selectArticle: function selectArticle(properties) {
      console.log(properties.items);
      if (properties.items[0]) {
        this.$parent.$emit('articleSelected', properties.items[0]);
      }
    }
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(62);


/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(slug) {
    if (slug) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('articles/slug/' + slug);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('articles?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang);
    }
  },
  getByType: function getByType(type) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('articles/type/' + type + '?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang);
  },
  getForId: function getForId(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get('articles/' + id + '?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang);
  },
  search: function search(query) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('articles/search?lang=' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.lang, { query: query });
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzIuNjcgNDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bG9nbzwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTQxLjMzLDI1LjMycTAsNy40LTYuNDgsOS42NGExNC41MSwxNC41MSwwLDAsMS00Ljg2Ljc5LDE3LjE5LDE3LjE5LDAsMCwxLTEwLjEzLTMuM2wzLjI0LTYuMXEzLjQxLDMuMTEsNi42OCwzLjExYTQuMzcsNC4zNywwLDAsMCwyLjQ5LS42OSwyLjQ5LDIuNDksMCwwLDAsMS4yLTIuMjEsMi41MywyLjUzLDAsMCwwLTEuMzItMi4xNywxMy4wNiwxMy4wNiwwLDAsMC0zLjMxLTEuMzJxLTIuODItLjgzLTMuNTQtMS4xNWE4LjE4LDguMTgsMCwwLDEtMi0xLjE1UTEyMSwxOC44NSwxMjEsMTVhOS40Nyw5LjQ3LDAsMCwxLDkuOTItOS44NiwxOS42NywxOS42NywwLDAsMSw5LjI0LDIuMzdsLTMsNS45YTgsOCwwLDAsMC01LTJBMy45MywzLjkzLDAsMCwwLDEzMCwxMmEyLjE3LDIuMTcsMCwwLDAtMS4wOSwxLjksMi4zOSwyLjM5LDAsMCwwLDEuNDMsMiwyNC42OSwyNC42OSwwLDAsMCwzLjg0LDEuMzMsMTEsMTEsMCwwLDEsNS43MiwzLjM0LDcuMyw3LjMsMCwwLDEsMS40Nyw0LjcyTTExNSwzNWgtNy41N2wtMTQtMTcuODdWMzVIODZWNS44aDcuNTdsMTQsMTcuODRWNS44SDExNVYzNVpNNDUuMzUsMzVIMzcuNzlMMzUuNjQsMTguMTgsMjguNiwzNWgtM0wxOC44NywxOC4xOCwxNi40LDM1SDguODRMMTMuNzgsNS44SDIxLjNsNS44OSwxNS41N0wzMy40Miw1LjhINDFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC42NyAtNSkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01Ni43MywyNC4yNkExLjM1LDEuMzUsMCwxLDAsNTgsMjMuMTlhNy4yMyw3LjIzLDAsMCwxLDkuNzYtOS40M2wxLjEyLTEuMjNjLTcuNzItNC4yOS0xNiw0LjE2LTEyLjE1LDExLjc0bTEuODMtLjEzYTAuNjUsMC42NSwwLDAsMS0xLC44MkEwLjY1LDAuNjUsMCwxLDEsNTguNTYsMjQuMTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC42NyAtNSkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MC40NSwxNC44NmExLjM1LDEuMzUsMCwwLDAsLjcyLDIuNDEsNy4yMyw3LjIzLDAsMCwxLTkuNzUsOS40N0w2MC4zLDI4YzcuNSw0LjE3LDE2LTMuODQsMTIuMjQtMTEuNTdhMS4zNSwxLjM1LDAsMCwwLTIuMDktMS41M20wLjMxLDEuNDZhMC42NSwwLjY1LDAsMCwxLDEtLjc5QTAuNjUsMC42NSwwLDAsMSw3MC43NiwxNi4zMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjY3IC01KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY0LDE3LjkyYTIuNDEsMi40MSwwLDEsMCwyLjY2LDMuNkEyLjQxLDIuNDEsMCwwLDAsNjQsMTcuOTJtMS4xMSwzYTAuOCwwLjgsMCwwLDEtMS0xLjI3QTAuOCwwLjgsMCwwLDEsNjUuMDgsMjAuODhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC42NyAtNSkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03OS40NiwxNi44NGExNS4yNywxNS4yNywwLDAsMC0yNi41NC02LjQyLDEuMzUsMS4zNSwwLDEsMCwxLjM4Ljg2LDEzLjY2LDEzLjY2LDAsMCwxLDIzLjU2LDUuOCwxLjgzLDEuODMsMCwwLDAsLjM3LDMuMiwxMy44MywxMy44MywwLDAsMS0uMTYsMi4wNUw3OS41OSwyM2ExNS4zNiwxNS4zNiwwLDAsMCwuMjUtMi44MiwxLjgzLDEuODMsMCwwLDAtLjM4LTMuMzJNNTIuNTMsMTIuMTZhMC42NSwwLjY1LDAsMCwxLDEtLjc5QTAuNjUsMC42NSwwLDAsMSw1Mi41MywxMi4xNlpNNzkuNiwxOS40OGExLjEzLDEuMTMsMCwwLDEtMS4zOC0xLjc5QTEuMTMsMS4xMywwLDAsMSw3OS42LDE5LjQ4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguNjcgLTUpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzAuOTUsMTBhMTIsMTIsMCwwLDAtMTguMiw4LjA5LDEuMzUsMS4zNSwwLDEsMCwxLjYxLjE0QTEwLjQzLDEwLjQzLDAsMCwxLDcwLDExLjMxYTEuODMsMS44MywwLDAsMCwyLjQ1LDIsMTAuNDIsMTAuNDIsMCwwLDEsMS43NiwyLjhsMS42My0uMjZhMTIsMTIsMCwwLDAtMi4yOC0zLjczQTEuODMsMS44MywwLDAsMCw3MC45NSwxME01NC4wOSwxOS40YTAuNjUsMC42NSwwLDEsMS0xLS42N0EwLjY1LDAuNjUsMCwwLDEsNTQuMDksMTkuNFptMTYuNTctNy42NGExLjEzLDEuMTMsMCwwLDEsMi4yNS0uMjRBMS4xMywxLjEzLDAsMCwxLDcwLjY2LDExLjc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguNjcgLTUpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzUuMTYsMjguODZBMTMuNjYsMTMuNjYsMCwwLDEsNTEuNiwyNC40NCwxLjgzLDEuODMsMCwwLDAsNTEsMjEuMjdhMTMuNzksMTMuNzksMCwwLDEsLjEyLTMuMWwtMS41My0uNjRhMTUuMjksMTUuMjksMCwwLDAtLjE5LDRBMS43OCwxLjc4LDAsMCwwLDQ4LjYyLDIzLDEuODMsMS44MywwLDAsMCw1MCwyNC44YTE1LjI3LDE1LjI3LDAsMCwwLDI2LjQyLDUsMS4zNSwxLjM1LDAsMSwwLTEuMjktMU00OS41NiwyMy43MWExLjEzLDEuMTMsMCwwLDEsMS43OS0xLjM4QTEuMTMsMS4xMywwLDAsMSw0OS41NiwyMy43MVpNNzYuODUsMjlBMC42NSwwLjY1LDAsMSwxLDc3LDI4LjA4LDAuNjUsMC42NSwwLDAsMSw3Ni44NSwyOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjY3IC01KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU4LjM5LDMwLjU3YTEyLDEyLDAsMCwwLDE4LTgsMS4zNSwxLjM1LDAsMSwwLTEuNTgtLjM0LDEwLjQzLDEwLjQzLDAsMCwxLTE1LjQ5LDcuMDUsMS44MywxLjgzLDAsMCwwLTIuNDktMkExMC40MywxMC40MywwLDAsMSw1NSwyNC4zNGwtMS42My4yNmExMiwxMiwwLDAsMCwyLjQxLDMuODcsMS44MywxLjgzLDAsMCwwLDIuNjEsMi4xbTE2Ljg0LTkuNDJhMC42NSwwLjY1LDAsMSwxLDEsLjY5QTAuNjUsMC42NSwwLDAsMSw3NS4yMiwyMS4xNVpNNTguNjYsMjguODNhMS4xMywxLjEzLDAsMCwxLTIuMjQuMjhBMS4xMywxLjEzLDAsMSwxLDU4LjY2LDI4LjgzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguNjcgLTUpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjYuNjEsMTVhNS41MSw1LjUxLDAsMCwwLTQuMTEsMCw1LjYyLDUuNjIsMCwxLDAsNi43OSwyLjEzQTEuODMsMS44MywwLDAsMCw2Ni42MSwxNW0xLjQ3LDcuMjRhNCw0LDAsMSwxLTIuMzQtNS44NSwxLjgzLDEuODMsMCwwLDAsMi4zNywxLjkyQTQsNCwwLDAsMSw2OC4wNywyMi4yNFptLTAuMzktNC41NWExLjEzLDEuMTMsMCwxLDEsMS0xLjNBMS4xMywxLjEzLDAsMCwxLDY3LjY4LDE3LjY5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTguNjcgLTUpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTM5LjQsNDQuOTJoMC43N1YzOS43OUgxMzkuNHY1LjEzWm0tMi45MywwQTIuMTUsMi4xNSwwLDAsMCwxMzcsNDVhMS4xLDEuMSwwLDAsMCwxLjM1LTEuMTRWMzkuNzloLTAuNzd2NGEwLjUyLDAuNTIsMCwwLDEtLjYzLjUzLDEuNzcsMS43NywwLDAsMS0uNTMtMC4wOHYwLjczWm0tMS40NCwwaDAuNzdWMzkuNzlIMTM1djUuMTNabS0xLjc0LTMuNjlhMC42NiwwLjY2LDAsMCwxLS43Ni43MWgtMVY0MC40OWgxQTAuNjcsMC42NywwLDAsMSwxMzMuMjksNDEuMjJabS0xLjc2LDEuMzVoMWEwLjc0LDAuNzQsMCwwLDEsLjg5LjgxLDAuNzYsMC43NiwwLDAsMS0uOS44MmgtMVY0Mi41OFptLTAuNzcsMi4zNGgxLjc3YzEuMzMsMCwxLjc0LS42NiwxLjc0LTEuNWExLjE2LDEuMTYsMCwwLDAtLjc3LTEuMiwxLjEsMS4xLDAsMCwwLC42Mi0xYzAtLjc5LTAuMzgtMS40LTEuNjMtMS40aC0xLjcydjUuMTNabS0zLjQ4LTQuNDNoMWEwLjgyLDAuODIsMCwwLDEsMCwxLjY0aC0xVjQwLjQ5Wm0wLDIuMzRoMS4wN2wwLjkzLDIuMDloMC45bC0xLjA3LTIuMjRhMS4yNSwxLjI1LDAsMCwwLC44My0xLjM3YzAtLjkzLTAuNDItMS41My0xLjc1LTEuNTNoLTEuNjd2NS4xM2gwLjc3VjQyLjgzWm0tMy4xNy0uOWMtMC42OC0uMDktMS0wLjE4LTEtMC43NHMwLjI3LS43NywxLjA3LTAuNzdhMy40MSwzLjQxLDAsMCwxLDEuMzUuMjdWNDBhMy4yNiwzLjI2LDAsMCwwLTEuMzktLjI1Yy0xLjQsMC0xLjgyLjczLTEuODIsMS40OSwwLDAuOTQuNDksMS4yNywxLjc0LDEuNDMsMC42OSwwLjA5LjkzLDAuMjMsMC45MywwLjc5cy0wLjI3Ljg2LTEuMiwwLjg2YTMuNDksMy40OSwwLDAsMS0xLjQ3LS4zM3YwLjc3YTMuOSwzLjksMCwwLDAsMS41Mi4yOWMxLjM3LDAsMi0uNjYsMi0xLjYzUzEyNS4xNyw0Mi4wOCwxMjQuMTEsNDEuOTRaTTExOC40MSw0NWExLjY1LDEuNjUsMCwwLDAsMS44Ni0xLjdWMzkuNzlIMTE5LjV2My40NWExLjEsMS4xLDAsMCwxLTIuMTksMFYzOS43OWgtMC43N1Y0My4zQTEuNjUsMS42NSwwLDAsMCwxMTguNDEsNDVabS00LjE2LTMuMDloLTIuMTNWNDAuNDloMi4zNXYtMC43aC0zLjEydjUuMTNoMy4xMnYtMC43aC0yLjM1di0xLjZoMi4xM3YtMC43Wm0tNS43MywzYTIuMTUsMi4xNSwwLDAsMCwuNTguMDgsMS4xLDEuMSwwLDAsMCwxLjM1LTEuMTRWMzkuNzloLTAuNzd2NGEwLjUyLDAuNTIsMCwwLDEtLjYzLjUzLDEuNzcsMS43NywwLDAsMS0uNTMtMC4wOHYwLjczWm0tMS40NCwwaDAuNzdWMzkuNzloLTAuNzd2NS4xM1ptLTQuMTktMi41NmMwLDEuNjguNTksMi42NSwyLjExLDIuNjVhMi45MSwyLjkxLDAsMCwwLDEuMi0uMjJWNDRhMi43NiwyLjc2LDAsMCwxLTEuMTYuMjNjLTEsMC0xLjM3LS42Ni0xLjM3LTEuOTNzMC40LTEuOTMsMS4zNy0xLjkzYTIuNzcsMi43NywwLDAsMSwxLjE2LjIzVjM5LjkyYTIuOTEsMi45MSwwLDAsMC0xLjItLjIyQzEwMy40OCwzOS43MSwxMDIuODksNDAuNjcsMTAyLjg5LDQyLjM1Wm0tMS43NS42OEg5OS44M2wwLjY2LTIuMjdabTAuNTMsMS44OGgwLjgzbC0xLjYzLTUuMTlIMTAwLjFsLTEuNjMsNS4xOUg5OS4zbDAuMzYtMS4yNWgxLjY0Wk05Ni4xOSw0NWExLjY1LDEuNjUsMCwwLDAsMS44Ni0xLjdWMzkuNzlIOTcuMjl2My40NWExLjEsMS4xLDAsMCwxLTIuMTksMFYzOS43OUg5NC4zM1Y0My4zQTEuNjUsMS42NSwwLDAsMCw5Ni4xOSw0NVptLTIuNDMtNC41MXYtMC43SDkwLjMzdjAuN2gxLjMzdjQuNDNoMC43N1Y0MC40OWgxLjMzWm0tNC45MSw0LjQzaDAuNzdWMzkuNzlIODguODV2NS4xM1ptLTIuNTEtM2MtMC42OC0uMDktMS0wLjE4LTEtMC43NHMwLjI3LS43NywxLjA3LTAuNzdhMy40LDMuNCwwLDAsMSwxLjM1LjI3VjQwYTMuMjQsMy4yNCwwLDAsMC0xLjM5LS4yNWMtMS40LDAtMS44Mi43My0xLjgyLDEuNDksMCwwLjk0LjQ5LDEuMjcsMS43NCwxLjQzLDAuNjksMC4wOS45MywwLjIzLDAuOTMsMC43OVM4Nyw0NC4yOCw4Niw0NC4yOGEzLjQ4LDMuNDgsMCwwLDEtMS40Ny0uMzN2MC43N2EzLjg5LDMuODksMCwwLDAsMS41Mi4yOWMxLjM3LDAsMS45NS0uNjYsMS45NS0xLjYzUzg3LjQxLDQyLjA4LDg2LjM0LDQxLjk0Wm0tNCwwSDgwLjJWNDAuNDloMi4zNXYtMC43SDc5LjQ0djUuMTNoMy4xMnYtMC43SDgwLjJ2LTEuNmgyLjEzdi0wLjdabS0zLjczLDNWMzkuNzlINzcuODRsMCwzLjY1LTIuMjMtMy42NWgtMC43djUuMTNINzUuN2wwLTMuNjUsMi4yMywzLjY1aDAuN1ptLTYuNDgtNS4xM0g3MS4zNXY1LjEzaDN2LTAuN0g3Mi4xMlYzOS43OVpNNjkuNCw0M0g2OC4wOWwwLjY2LTIuMjdabTAuNTMsMS44OGgwLjgzbC0xLjYzLTUuMTlINjguMzZsLTEuNjMsNS4xOWgwLjgzbDAuMzYtMS4yNWgxLjY0Wm0tNS43OCwwYTIuMTYsMi4xNiwwLDAsMCwuNTguMDgsMS4xLDEuMSwwLDAsMCwxLjM1LTEuMTRWMzkuNzlINjUuMzF2NGEwLjUyLDAuNTIsMCwwLDEtLjYzLjUzLDEuNzcsMS43NywwLDAsMS0uNTMtMC4wOHYwLjczWm0tMS40NCwwaDAuNzdWMzkuNzlINjIuNzF2NS4xM1ptLTQuMTktMi41NmMwLDEuNjguNiwyLjY1LDIuMTEsMi42NWEyLjkyLDIuOTIsMCwwLDAsMS4yLS4yMlY0NGEyLjc3LDIuNzcsMCwwLDEtMS4xNi4yM2MtMSwwLTEuMzctLjY2LTEuMzctMS45M3MwLjQtMS45MywxLjM3LTEuOTNhMi43OCwyLjc4LDAsMCwxLDEuMTYuMjNWMzkuOTJhMi45MSwyLjkxLDAsMCwwLTEuMi0uMjJDNTkuMTEsMzkuNzEsNTguNTEsNDAuNjcsNTguNTEsNDIuMzVabS0yLjY4LTJjMSwwLDEuMTkuNzMsMS4xOSwycy0wLjIyLDEuOTUtMS4xOSwxLjk1LTEuMTktLjczLTEuMTktMS45NVM1NC44Nyw0MC40LDU1Ljg0LDQwLjRabTAsNC42YzEuNjUsMCwyLTEuMiwyLTIuNjVzLTAuMzMtMi42NS0yLTIuNjUtMiwxLjItMiwyLjY1UzU0LjE5LDQ1LDU1Ljg0LDQ1Wm0tNC4zMS0zLjA2Yy0wLjY4LS4wOS0xLTAuMTgtMS0wLjc0czAuMjctLjc3LDEuMDctMC43N0EzLjQxLDMuNDEsMCwwLDEsNTMsNDAuN1Y0MGEzLjI1LDMuMjUsMCwwLDAtMS4zOS0uMjVjLTEuNCwwLTEuODIuNzMtMS44MiwxLjQ5LDAsMC45NC40OSwxLjI3LDEuNzQsMS40MywwLjY5LDAuMDkuOTMsMC4yMywwLjkzLDAuNzlzLTAuMjcuODYtMS4yLDAuODZhMy40OSwzLjQ5LDAsMCwxLTEuNDctLjMzdjAuNzdhMy44OSwzLjg5LDAsMCwwLDEuNTIuMjljMS4zNywwLDEuOTUtLjY2LDEuOTUtMS42M1M1Mi42LDQyLjA4LDUxLjUzLDQxLjk0Wk00Ni4wNiw0NWEzLjgyLDMuODIsMCwwLDAsMS42MS0uMzFWNDIuMDlINDZ2MC42OWgwLjkxdjEuNGEyLjM2LDIuMzYsMCwwLDEtLjczLjFjLTEsMC0xLjQyLS42Ny0xLjQyLTEuOTNzMC4zNi0xLjkzLDEuNDItMS45M2EzLjQsMy40LDAsMCwxLDEuMzcuM1Y0MGEzLjM5LDMuMzksMCwwLDAtMS40Ny0uMjdjLTEuNTUsMC0yLjExLDEtMi4xMSwyLjY1UzQ0LjUzLDQ1LDQ2LjA2LDQ1Wm0tMi44NS0uMDhWMzkuNzlINDIuNDRsMCwzLjY1LTIuMjMtMy42NWgtMC43djUuMTNINDAuM2wwLTMuNjUsMi4yMywzLjY1aDAuN1ptLTUuMzgsMGgwLjc3VjM5Ljc5SDM3LjgzdjUuMTNabS0zLjU5LTQuNDNoMWEwLjgyLDAuODIsMCwwLDEsMCwxLjY0aC0xVjQwLjQ5Wm0wLDIuMzRIMzUuM2wwLjkzLDIuMDloMC45bC0xLjA3LTIuMjRhMS4yNiwxLjI2LDAsMCwwLC44NC0xLjM3YzAtLjkzLTAuNDItMS41My0xLjc1LTEuNTNIMzMuNDd2NS4xM2gwLjc3VjQyLjgzWk0zMC43Myw0MC40YzEsMCwxLjE5LjczLDEuMTksMlMzMS43LDQ0LjMsMzAuNzMsNDQuM3MtMS4xOS0uNzMtMS4xOS0xLjk1UzI5Ljc2LDQwLjQsMzAuNzMsNDAuNFptMCw0LjZjMS42NSwwLDItMS4yLDItMi42NXMtMC4zMy0yLjY1LTItMi42NS0yLDEuMi0yLDIuNjVTMjkuMDgsNDUsMzAuNzMsNDVabS0yLjMxLTQuNTF2LTAuN0gyNXYwLjdoMS4zM3Y0LjQzaDAuNzdWNDAuNDloMS4zM1ptLTQuOTEsNC40M2gwLjc3VjM5Ljc5SDIzLjUxdjUuMTNabS0wLjk0LDBWMzkuNzlIMjEuODFsMCwzLjY1TDE5LjYsMzkuNzlIMTguOXY1LjEzaDAuNzZsMC0zLjY1LDIuMjMsMy42NWgwLjdaTTE2LjE2LDQwLjRjMSwwLDEuMTkuNzMsMS4xOSwycy0wLjIyLDEuOTUtMS4xOSwxLjk1UzE1LDQzLjU3LDE1LDQyLjM1LDE1LjE4LDQwLjQsMTYuMTYsNDAuNFptMCw0LjZjMS42NSwwLDItMS4yLDItMi42NXMtMC4zMy0yLjY1LTItMi42NS0yLDEuMi0yLDIuNjVTMTQuNTEsNDUsMTYuMTYsNDVabS0zLjQ3LTMuOTQsMCwzLjg2aDAuNzdWMzkuNzloLTFMMTEsNDMuMjhsLTEuMzktMy41aC0xdjUuMTNIOS40M2wwLTMuODYsMS4yOCwzLjE1SDExLjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC42NyAtNSkiLz48L3N2Zz4="

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(443)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-1c9ac193",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-7b136444",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  "data-v-4ed53b04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)
__webpack_require__(457)
__webpack_require__(458)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  "data-v-c026c432",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(438)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  "data-v-0e036f39",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(442)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  "data-v-1b8d662a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-5b3e2b11",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  "data-v-208feb82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-0919fe6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-2c8f86ad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-71f6638c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  "data-v-0f6f856c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-447555ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(451)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-6070caf2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-f0c25c1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  "data-v-611b1dee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(440)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  "data-v-14e79f93",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.initiators.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-12 page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.initiators.content'))
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-image",
    class: _vm.type,
    style: ({
      'background-image': 'url(' + _vm.src + ')'
    })
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.type === 'landing') ? _c('h1', {
    staticClass: "mons-title"
  }, [_vm._v(_vm._s(_vm.$t('title.landing')))]) : _vm._e(), _vm._v(" "), (_vm.type === 'landing') ? _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.theme')))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.type === 'landing') ? _c('div', {
    staticClass: "editor col-12"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.genderLabel)))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))])]) : _vm._e(), _vm._v(" "), (_vm.subtitle && _vm.type !== 'landing') ? _c('h2', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "title": 'Authors',
      "subtitle": 'Meet the people behind the platform',
      "src": 'static/bg-about.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.authors), function(author) {
    return _c('author-card', {
      key: author,
      staticClass: "col-4 author",
      attrs: {
        "author": author
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": "static/bg-video.jpg",
      "title": "Video"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [(_vm.articles === null) ? _c('div', {
    staticClass: "empty row"
  }, [_vm._v("There are no articles yet")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.articles), function(article) {
    return _c('article-card', {
      key: article,
      attrs: {
        "article": article,
        "orientation": 'left',
        "published": _vm.checkArticlePublishDate(article.publishDate)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 offset-md-1"
  }, [_c('h3', {
    staticClass: "row section-title"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    ref: "search",
    staticClass: "input text",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('label.search'),
      "v-model": _vm.searchQuery
    },
    on: {
      "blur": function($event) {
        _vm.focusLost()
      },
      "focus": function($event) {
        _vm.searchResults.length > 0 ? _vm.showSearchResults() : _vm.hideSearchResults()
      },
      "keyup": function($event) {
        _vm.$data.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "search-results",
    class: _vm.searchResultsShown ? 'shown' : ''
  }, _vm._l((_vm.searchResults), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "row",
      on: {
        "click": function($event) {
          _vm.showArticle(article.articleTranslations[0].slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner col-lg-8 col-md-12"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(article.articleType.name))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(article.publishDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(article.articleTranslations[0].title))])]), _vm._v(" "), _c('div', {
      staticClass: "image col-4 hidden-sm-down",
      style: ('background: url(' + (article.image != null ? article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;')
    })])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.home')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.about')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'key_articles'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.key_articles')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.blog')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.video')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'infographics'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.infographics')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.contact')))])], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('center', [_c('p', [_vm._v("Copyright " + _vm._s(_vm.year) + " MONS")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "col-md-6 offset-md-3",
    attrs: {
      "src": "/static/logo.svg",
      "alt": "MONS",
      "height": "50"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/monitoring.mons/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/monitoring_MONS",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-blog.jpg',
      "title": 'Blog',
      "description": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [(_vm.articles === null) ? _c('div', {
    staticClass: "empty row"
  }, [_vm._v("There are no articles yet")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.articles), function(article) {
    return _c('article-card', {
      key: article,
      attrs: {
        "article": article,
        "orientation": 'left',
        "published": _vm.checkArticlePublishDate(article.publishDate)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 offset-md-1 sidebar"
  }, [_c('h3', {
    staticClass: "row section-title"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.chapter) ? _c('cover-image', {
    staticClass: "no-margin",
    attrs: {
      "src": _vm.chapter.image,
      "title": _vm.chapter.chapterTranslations[0].title,
      "subtitle": _vm.chapter.chapterTranslations[0].editor,
      "type": 'landing',
      "editorGender": _vm.chapter.chapterTranslations[0].editorGender
    }
  }) : _vm._e(), _vm._v(" "), _c('chapter-picker', {
    attrs: {
      "name": 'chapter',
      "items": _vm.chapters,
      "language": _vm.language,
      "initialItem": _vm.chapter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles container-fluid"
  }, [_c('div', {
    attrs: {
      "id": "line"
    }
  }), _vm._v(" "), _vm._l((_vm.articles), function(article, index) {
    return _c('div', {
      key: article.id,
      staticClass: "row"
    }, [_c('article-card', {
      staticClass: "col-md-6",
      class: _vm.getClassesForArticle(index),
      attrs: {
        "data-id": article.id,
        "article": article,
        "published": _vm.checkArticlePublishDate(article.publishDate),
        "orientation": _vm.isOddIndex(index) ? 'left' : 'right',
        "inFeed": true
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.relatedResearch) ? _c('div', {
    staticClass: "container-fluid text-center section white",
    attrs: {
      "id": "related"
    }
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("Related research")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid text-center section",
    attrs: {
      "id": "newsletter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.newsletter')))]), _vm._v(" "), _c('p', {
    staticClass: "col-12"
  }, [_vm._v(_vm._s(_vm.$t('text.newsletter')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group col-md-6 offset-md-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('placeholder.email')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section white",
    attrs: {
      "id": "built"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.chapter.position < 15) ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.built')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [(_vm.chapter.position < 15) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [(_vm.language === 'en') ? _c('img', {
    attrs: {
      "src": "static/logos/secons.png",
      "alt": "SeConS"
    }
  }) : _c('img', {
    attrs: {
      "src": "static/logos/secons-sr.png",
      "alt": "SeConS"
    }
  })])])])]) : _c('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [(_vm.language === 'en') ? _c('img', {
    attrs: {
      "src": "static/logos/secons.png",
      "alt": "SeConS"
    }
  }) : _c('img', {
    attrs: {
      "src": "static/logos/secons-sr.png",
      "alt": "SeConS"
    }
  })])])]), _vm._v(" "), ([9, 11, 12, 13].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [(_vm.chapter != null && _vm.chapter.position === 9) ? _c('a', {
    attrs: {
      "href": "http://www.fes-serbia.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/fes.png",
      "alt": "Friedrich Ebert Stiftung"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 11) ? _c('a', {
    attrs: {
      "href": "http://www.osce.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/osce.png",
      "alt": "OSCE"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 12) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.chapter != null && _vm.chapter.position === 13) ? _c('a', {
    attrs: {
      "href": "http://www.fosserbia.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/fos.png",
      "alt": "FOS Srbija"
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), ([14].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), ([15].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$t('chapters.15')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), ([16].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$t('chapters.16')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), ([17].indexOf(_vm.chapter.position) !== -1) ? _c('div', [_c('div', {
    staticClass: "row mb-4"
  }, [_c('h4', {
    staticClass: "section-title text-center col-12"
  }, [_vm._v(_vm._s(_vm.$t('title.supported')))])]), _vm._v(" "), _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-12"
  }, [(this.language === 'en') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/logo-unicef-en.png",
      "alt": "UNICEF"
    }
  }) : _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/logo-unicef.png",
      "alt": "UNICEF"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('chapters.17')) + "\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fren.org.rs",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/fren.png",
      "alt": "FREN"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/ppma.png",
      "alt": "ppma"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('a', {
    attrs: {
      "href": "https://erasmusplus.rs/category/obrazovanje/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logos/erasmus.png",
      "alt": "ppma"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-4"
  }, [_c('a', {
    attrs: {
      "href": "https://cpz.rs/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/cpz.png",
      "alt": "Centar za podršku ženama"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-5 text-center",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_c('span', [_c('p', [_vm._v("\n              Teme predstavljene u ovom broju rezultat su istraživanja koje se realizuje u okviru\n              projekta „Uspostavljanje informacionog sistema za prevenciju vršnjačkog nasilja – 3.\n              faza“, koji sprovodi Udruženje građanki i građana “Centar za podršku ženama”, a\n              finansira Ministarstvo omladine i sporta Republike Srbije.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Stavovi izraženi u ovom materijalu isključiva su odgovornost autora i njegovih\n              saradnika i ne predstavljaju zvaničan stav Ministarstva omladine i sporta.\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/nemacka-saradnja.png",
      "alt": "Nemačka saradnja"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/sdc.png",
      "alt": "SDC"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mt-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/giz.png",
      "alt": "GIZ"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row logos"
  }, [_c('div', {
    staticClass: "col-12 mt-12"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/c-16-logos-1.png",
      "alt": "Partneri logoi 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-16"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/logos/c-16-logos-2.png",
      "alt": "Partneri logi 2"
    }
  })])])
}]}

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": "static/bg-infographics.jpg",
      "title": _vm.$t('title.infographics')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [(_vm.articles === null) ? _c('div', {
    staticClass: "empty row"
  }, [_vm._v("There are no articles yet")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.articles), function(article) {
    return _c('article-card', {
      key: article,
      attrs: {
        "article": article,
        "orientation": 'left',
        "published": _vm.checkArticlePublishDate(article.publishDate)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 offset-md-1"
  }, [_c('h3', {
    staticClass: "row section-title"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": "static/bg-articles.jpg",
      "title": _vm.$t('title.key_articles')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [(_vm.articles === null) ? _c('div', {
    staticClass: "empty row"
  }, [_vm._v("There are no articles yet")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.articles), function(article) {
    return _c('article-card', {
      key: article,
      attrs: {
        "article": article,
        "orientation": 'left',
        "published": _vm.checkArticlePublishDate(article.publishDate)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 offset-md-1"
  }, [_c('h3', {
    staticClass: "row section-title"
  })])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "timeline"
    }
  }, [_c('div', {
    ref: "timelinePresenter"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "chapterPicker",
    staticClass: "chapter-picker"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptions
    },
    on: {
      "click": _vm.selectChapter
    }
  }, [_vm._l((_vm.items.slice().reverse()), function(item, index) {
    return _c('swiper-slide', {
      key: index + 1,
      staticClass: "chapter-item",
      class: _vm.selectedChapter === item.id ? 'selected' : '',
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "supertitle"
    }, [_vm._v("MONS " + _vm._s(index + 1) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.chapterTranslations[0].title))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.about.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.about.content'))
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": "static/bg-about.jpg",
      "title": _vm.$t('title.contact'),
      "subtitle": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "row"
  }, [_vm._v("SeConS")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.address')) + ": " + _vm._s(_vm.$t('text.address_secons')))]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.phone')) + ": +381 11 4505 818")]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.fax')) + ": +381 11 4505 831")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "row"
  }, [_vm._v("FREN")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.address')) + ": " + _vm._s(_vm.$t('text.address_fren')))]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.phone')) + ": +381 11 3021 069")]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.fax')) + ": +381 69 80 421")]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "mailto:office@secons.net"
    }
  }, [_vm._v("office@secons.net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [_vm._v("www.secons.net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "mailto:office@fren.org.rs"
    }
  }, [_vm._v("office@fren.org.rs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fren.org.rs",
      "target": "_blank"
    }
  }, [_vm._v("www.fren.org.rs")])])
}]}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "content",
    class: _vm.inFeed ? 'feed-item ' + _vm.orientation : _vm.orientation
  }, [(_vm.published) ? _c('div', {
    staticClass: "published container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 cover-image",
    style: ('background: url(' + (_vm.article.image != null ? _vm.article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;')
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8 inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "date col-6"
  }, [_vm._v(_vm._s(_vm.articleDate))]), _vm._v(" "), _c('div', {
    staticClass: "article-type col-6 float-right"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.getIconForArticleType(_vm.article.articleType.name)
  })])]), _vm._v(" "), _c('p', {
    staticClass: "article-type"
  }, [_vm._v(_vm._s(_vm.$t('label.' + _vm.article.articleType.name)))]), _vm._v(" "), (_vm.article.author) ? _c('h4', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.article.author.name + ' ' + _vm.article.author.surname))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [(_vm.translation.slug !== ' ') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'article',
        params: {
          slug: _vm.translation.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.title))]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.title))])], 1), _vm._v(" "), (_vm.article.articleType.name === 'video') ? _c('div', {
    staticClass: "video"
  }, [_vm._v(_vm._s(_vm.translation.body))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.translation.description))]), _vm._v(" "), (_vm.translation.slug !== ' ') ? _c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'article',
        params: {
          slug: _vm.translation.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.read_all')))]) : _c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.read_all')))])], 1)])]) : _c('div', {
    staticClass: "unpublished"
  }, [_c('div', {
    staticClass: "subtitle text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.publish_date')))]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, [_vm._v(_vm._s(_vm.articleDate))]), _vm._v(" "), _c('div', {
    staticClass: "article-type-icon text-center"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.getIconForArticleType(_vm.article.articleType.name),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "article-type text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.' + _vm.article.articleType.name)))]), _vm._v(" "), _c('h3', {
    staticClass: "title text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.translation.title) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.translation.description))])])]), _vm._v(" "), (_vm.inFeed) ? _c('div', {
    staticClass: "line",
    class: _vm.orientation
  }, [_c('span', {
    staticClass: "theLine"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedChapter),
      expression: "selectedChapter"
    }],
    staticClass: "elastic",
    attrs: {
      "id": "chapter-select",
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedChapter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s('MONS ' + (_vm.items.length - index) + ': ' + item.chapterTranslations[0].title))])
  })), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.openSelect
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view"
  }, [_c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "containerMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filters col-md-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.filter')))]), _vm._v(" "), _vm._l((_vm.chartData.fields), function(field, index) {
    return _c('div', {
      key: index,
      staticClass: "filter"
    }, [_c('label', {
      attrs: {
        "for": index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedField),
        expression: "selectedField"
      }],
      attrs: {
        "type": "radio",
        "id": index
      },
      domProps: {
        "value": field,
        "checked": _vm._q(_vm.selectedField, field)
      },
      on: {
        "__c": function($event) {
          _vm.selectedField = field
        }
      }
    }), _vm._v(" " + _vm._s(field) + "\n      ")])])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.management.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      key: index,
      staticClass: "row section"
    }, [_c('h2', {
      staticClass: "col-12"
    }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].title')))]), _vm._v(" "), _vm._l((section.people), function(person, yndex) {
      return _c('div', {
        key: yndex,
        staticClass: "col-lg-3 person"
      }, [_c('div', {
        staticClass: "content"
      }, [_c('img', {
        attrs: {
          "src": _vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].img'),
          "alt": _vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].name')
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "signature"
      }, [(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].title')) ? _c('p', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].title')))]) : _vm._e(), _vm._v(" "), _c('h3', {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].name')))])])])])
    })], 2)
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "col-12 content no-gutters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "col-12 no-gutters",
    attrs: {
      "src": _vm.author.image,
      "alt": _vm.author.name + ' ' + _vm.author.surname
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row text"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.author.name) + " " + _vm._s(_vm.author.surname))]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translation.title))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.aboutAuthors.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.authors), function(author, index) {
    return _c('div', {
      key: index,
      staticClass: "row author"
    }, [_c('h2', {
      staticClass: "col-12"
    }, [_vm._v(_vm._s(_vm.$t('pages.aboutAuthors.content[' + index + '].name')))]), _vm._v(" "), _c('p', {
      staticClass: "col-12"
    }, [_vm._v(_vm._s(_vm.$t('pages.aboutAuthors.content[' + index + '].bio')))])])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "fixed-top",
    class: {
      'transparent': _vm.scrollPosition < 100,
      'bg-primary': _vm.scrollPosition > 100
    },
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "status-bar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-2 offset-md-9 offset-lg-10"
  }, [_c('div', {
    staticClass: "wrap float-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "languages"
  }, [(_vm.currentLanguage === 'sr') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLanguage($event)
      }
    }
  }, [_vm._v("English")]) : _vm._e(), _vm._v(" "), (_vm.currentLanguage === 'en') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLanguage($event)
      }
    }
  }, [_vm._v("Srpski")]) : _vm._e()])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-inverse"
  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      },
      "tag": "a"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(470),
      "alt": "MONS platforma"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('div', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.home')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    class: this.$route.path.includes('/about') ? 'router-link-active' : '',
    attrs: {
      "href": "#",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("MONS")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'about'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.about')))]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'initiators'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.initiators')))]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'aboutAuthors'
      },
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.aboutAuthors')))])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'key_articles'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.key_articles')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.blog')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.video')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'infographics'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.infographics')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('navigation.contact')))])], 1), _vm._v(" "), _c('search-component', {
    class: {
      'transparent': _vm.scrollPosition < 100,
      '': _vm.scrollPosition > 100
    },
    attrs: {
      "id": "search"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "chapter": _vm.currentChapter,
      "language": _vm.currentLanguage,
      "chapters": _vm.chapters
    },
    on: {
      "chapterChanged": _vm.chapterChanged,
      "languageChanged": _vm.languageChanged
    }
  })], 1)], 1), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/monitoring.mons/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/monitoring_MONS",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('section', {
    attrs: {
      "id": "article"
    }
  }, [_c('cover-image', {
    attrs: {
      "src": (_vm.article.shouldShowCover && _vm.article.image) ? _vm.article.image : '/static/placeholders/placeholder-logo.jpg',
      "title": '',
      "description": '',
      "type": 'medium'
    }
  }), _vm._v(" "), _c('article', {
    staticClass: "article container",
    class: _vm.article.image == null ? 'no-image' : ''
  }, [(_vm.article.author) ? _c('h4', {
    staticClass: "author text-center"
  }, [_vm._v(_vm._s(_vm.article.author.name + ' ' + _vm.article.author.surname))]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "title row text-center"
  }, [_vm._v(_vm._s(_vm.translation.title))]), _vm._v(" "), _c('p', {
    staticClass: "date row text-center"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.article.publishDate, 'en')))]), _vm._v(" "), _c('div', {
    staticClass: "article-options"
  }, [_c('i', {
    staticClass: "fa fa-print article-option",
    on: {
      "click": _vm.print
    }
  }), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": 'http://mons.rs' + this.$route.path,
      "title": _vm.translation.title,
      "description": _vm.translation.description,
      "hashtags": 'mons'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('network', {
            staticClass: "article-option",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })]), _vm._v(" "), _c('network', {
            staticClass: "article-option",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content row",
    attrs: {
      "name": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translation.content)
    }
  }), _vm._v(" "), (_vm.graphExists) ? _c('graph-view', {
    attrs: {
      "chartData": _vm.chartData,
      "chartOptions": _vm.chartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mapExists) ? _c('maps-view', {
    attrs: {
      "chartData": _vm.chartData,
      "chartOptions": _vm.chartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.article && (_vm.article.previousArticle || _vm.article.nextArticle)) ? _c('div', {
    staticClass: "row"
  }, [(_vm.hasPreviousArticle) ? _c('div', {
    staticClass: "button article-nav col-4"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.previousArticle
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left"
  }), _vm._v("\n          " + _vm._s(_vm.$t('button.previous_article')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasNextArticle) ? _c('div', {
    staticClass: "button article-nav col-4 text-right",
    class: _vm.hasPreviousArticle ? 'push-4' : 'push-8'
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.nextArticle
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.next_article')) + "\n          "), _c('i', {
    staticClass: "fa fa-caret-right"
  })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "lightbox"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "modal-image",
    attrs: {
      "src": "",
      "alt": "",
      "id": "lightbox-image"
    }
  })])])])])
}]}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "filters inline"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.filter')))]), _vm._v(" "), _vm._l((_vm.divisions), function(division, index) {
    return _c('div', {
      key: index,
      staticClass: "filter"
    }, [_c('label', {
      attrs: {
        "for": 'division-' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDivision),
        expression: "selectedDivision"
      }],
      attrs: {
        "type": "radio",
        "id": 'division-' + index
      },
      domProps: {
        "value": division,
        "checked": _vm._q(_vm.selectedDivision, division)
      },
      on: {
        "__c": function($event) {
          _vm.selectedDivision = division
        }
      }
    }), _vm._v(" " + _vm._s(division) + "\n      ")])])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "containerChart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 offset-md-3 filters"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.options')))]), _vm._v(" "), _vm._l((_vm.chartData.fields), function(field, index) {
    return _c('div', {
      key: index,
      staticClass: "filter"
    }, [_c('label', {
      attrs: {
        "for": 'field-' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedField),
        expression: "selectedField"
      }],
      attrs: {
        "type": "radio",
        "id": 'field-' + index
      },
      domProps: {
        "value": field,
        "checked": _vm._q(_vm.selectedField, field)
      },
      on: {
        "__c": function($event) {
          _vm.selectedField = field
        }
      }
    }), _vm._v(" " + _vm._s(field) + "\n      ")])])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(170);
module.exports = __webpack_require__(169);


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  "data-v-5decef04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  sr: {
    navigation: {
      home: 'Početna',
      about: 'O MONS-u',
      key_articles: 'Članci',
      initiators: 'Pokretači MONS platforme',
      management: 'MONS tim',
      aboutAuthors: 'Prvi uređivački tim',
      authors: 'Autori',
      blog: 'Blog',
      video: 'Video',
      infographics: 'Infografici',
      contact: 'Kontakt'
    },

    description: {
      about: '',
      authors: '',
      blog: '',
      video: '',
      infographics: '',
      contact: ''
    },

    label: {
      publish_date: 'Datum objavljivanja',
      email: 'E-mail',
      subject: 'Naslov',
      message: 'Poruka',
      phone: 'Telefon',
      fax: 'Faks',
      address: 'Adresa',
      filter: 'Filteri',
      options: 'Opcije',
      editor: 'Urednik broja',
      editors: 'Urednici broja',
      editor_female: 'Urednica broja',
      editors_female: 'Urednice broja',
      theme: 'Tema broja',
      key: 'Članak',
      video: 'Video',
      blog: 'Blog',
      infographic: 'Infografik',
      search: 'Pretraži'
    },

    title: {
      site: 'MONS',
      landing: 'Platforma za monitoring socijalne situacije u Srbiji',
      contact_form: 'Pošalji poruku',
      contact: 'Kontakt',
      timeline: 'Raspored objavljivanja',
      newsletter: 'Doapada Vam se sadržaj?',
      built: 'Pokretači platforme',
      supported: 'Uz podršku',
      key_articles: 'Članci',
      infographics: 'Infografici'
    },

    placeholder: {
      email: 'petar.petrovic@email.rs',
      subject: 'Naslov poruke'
    },

    button: {
      read_all: 'Detaljnije',
      send: 'Pošalji',
      previous_article: 'Prethodni članak',
      next_article: 'Sledeći članak'
    },

    pages: {
      aboutAuthors: {
        title: 'Prvi uređivački tim',
        content: [{
          name: 'prof. dr Jelena Žarkovic Rakić',
          bio: 'Prof. dr Jelena Žarkovic Rakić je vanredna profesorka Ekonomskog fakulteta Univerziteta u Beogradu i direktorka Fondacije za razvoj ekonomske nauke (FREN). Bavi se istraživanjima iz oblasti ekonomije javnog sektora i ekonomije rada, posebno podsticajnim efektima poreske i socijalne politike ka prihvatanju zaposlenja, kao i problematikom nejednakosti i siromaštva. Učestvovala je kao rukovodilac i istraživač u značajnom broju domaćih i međunarodnih projekata regionalnog karaktera. Objavljuje radove u renomiranim akademskim časopisima u zemlji i inostranstvu, od kojih neki imaju veoma visoku citiranost.'
        }, {
          name: 'prof. dr Marija Babović',
          bio: 'Prof dr. Marija Babović je redovna profesorka Filozofskog fakulteta Univerziteta u Beogradu i programska direktorka SeConS grupe za razvojnu inicijativu. Glavna oblast njenog akademskog interesovanja je ekonomska sociologija, a istraživanja i analize politika koje sprovodi fokusiraju se na na probleme socio-ekonomskog razvoja, rodne ravnopravnosti i socijalne integracije različitih društvenih grupa. Pored velikog iskustva u naučno-istraživačkom radu i primenjenim istraživanjima, ima iskustva i u novinarstvu. Bila je urednica naučnog časopisa Sociologija od 2013. do 2015. godine. '
        }, {
          name: 'prof. dr Mihail Arandarenko',
          bio: 'Prof. dr Mihail Arandarenko je redovni profesor na predmetu Ekonomija rada na Ekonomskom fakultetu Univerziteta u Beogradu i predsednik Upravnog odbora Fondacije za razvoj ekonomske nauke (FREN). Doktorirao je na Univerzitetu u Beogradu, nakon čega je u periodu od 1999 do 2000. bio postdoktorant na Collegium Budimpešta - Institutu za napredna istraživanja. Bio je gostujući profesor saradnik na Londonskoj školi ekonomije u periodu 2014-2015. Objavio je veliki broj radova, uključujući i dve monografije. Njegove oblasti istraživanja obuhvataju tržište rada, programe zapošljavanja, industrijske odnose i socijalnu politiku. Dobio je brojne domaće i međunarodne grantove za istraživanja u oblasti tržišta rada.'
        }, {
          name: 'prof. dr Slobodan Cvejić',
          bio: 'Prof. dr Slobodan Cvejić je redovni profesor Filozofskog fakulteta Univerziteta u Beogradu i direktor istraživanja SeConS grupe za razvojnu inicijativu. Ključne oblasti njegovog akademskog interesovanja i ekspertize su ekonomska sociologija i metodologija društvenih istraživanja. Najviše istraživanja i aktivnosti usmerenih na analizu politika ima u poljima društvene nejednakosti, ekonomskog i društvenog razvoja i društvenog uključivanja. Prof. dr Cvejić učestvuje u brojnim istraživačkim i projektima kreiranja politika u zemlji i inostranstvu. Urednik je naučnog časopisa Sociologija.'
        }, {
          name: 'prof. dr Gorana Krstić',
          bio: 'Prof. dr Gorana Krstić je vanredna profesorka Ekonomskog fakulteta Univerziteta u Beogradu i članica Upravnog odbora Fondacije za razvoj ekonomske nauke (FREN). Bavi se istraživanjima iz oblasti tržišta rada, posebno uloge neformalnog sektora, siromaštva i nejednakosti u zemljama u tranziciji, kao i efektima socijalne politike na smanjenje siromaštva i nejednakosti. Većina projekata u kojima je učestvovala su regionalni i rađeni su za potrebe međunarodnih organizacija. Objavila je veliki broj radova u zemlji i inostranstvu koji su publikovani u renomiranim naučnim časopisima, od kojih neki imaju veoma visoku citiranost. Dobitnica je grantova za individualna, kao i za institucionalna istraživanja kojima je rukovodila.'
        }, {
          name: 'doc. dr Danilo Vuković',
          bio: 'Doc. dr Danilo Vuković je docent Pravnog fakulteta Univerziteta u Beogradu i član Nadzornog odbora SeConS grupe za razvojnu inicijativu. Oblasti njegovog akademskog interesovanja su empirijska sociologija prava, socijalna politika u postsocijalističkom kontekstu i građansko društvo. U svojstvu istraživača Londonske škole za ekonomiju i političke nauke (LSE) sproveo je istraživanje o odgovornosti vlasti i vladavini prava u Kambodži. Ima veliko iskustvo u saradnji sa državnim institucijama, privatnim i konsultantskim sektorom u regionu, posebno u oblastima socijalne zaštite, mladih i civilnog društva. '
        }, {
          name: 'dr Lara Lebedinski',
          bio: 'Dr Lara Lebedinski je viša istraživačica u Fondaciji za razvoj ekonomske nauke FREN i spoljna saradnica na Institutu ekonomskih nauka. Doktorirala je ekonomiju na univerzitetu Bokoni u Italiji. Glavne oblasti njenog akademskog rada kao i aktivnosti usmerenih na analizu politika su ekonomija obrazovanja i tržište rada. Tokom svoje karijere radila je kao konsultantkinja za UNICEF i Ministarstvo prosvete, nauke i tehnološkog razvoja.'
        }]
      },

      about: {
        title: 'O MONS-u',
        content: '<p><b>Monitoring socijalne situacije u Srbiji (MONS)</b> je online platforma koju su zajednički pokrenuli Fondacija za razvoj ekonomske nauke FREN i SeConS grupa za razvojnu inicijativu, kako bi adekvatnije predstavili  rezultate društveno-ekonomskih istraživanja i povećali njihov značaj i uticaj na procese donošenja javnih politika.</p>' + '<p>Platforma je pokrenuta u cilju uspostavljanja dijaloga između predstavnika akademske zajednice, civilnog sektora, kreatora politika i donosilaca odluka o značajnim društvenim i ekonomskim pitanjima u Srbiji. <b>MONS osvetljava važne teme koje nisu na „javnoj agendi“, a pitanjima koja su već u fokusu javnosti pristupa na novi i drugačiji način.</b></p>' + '<p>MONS kvartalno predstavlja po jednu socio-ekonomsku temu, koju eksperti i ekspertkinje iz date oblasti sveobuhvatno analiziraju, koristeći relevantne i pouzdane izvore podataka. Platforma na kojoj se znanje deli sa njenim posetiocima je interaktivna i <b>omogućava svim zainteresovanim akterima da se putem bloga uključe i doprinesu još boljem razumevanju tema.</b></p>' + '<p>Platforma je namenjena i predstavnicima medija koji informisanje javnosti i interpretaciju društvene stvarnosti nastoje da utemelje u naučno dokazanim činjenicama.</p>' + '<p>MONS projekat je pokrenut i zaključno sa brojem 9 sprovođen uz finansijsku i tehničku podršku projekta <a href="http://www.perform.network" target="_blank">PERFORM</a> (Performing and Responsive Social Sciences) Švajcarske agencije za razvoj i saradnju (SDC) koji sprovode Helvetas Swiss Intercooperation i Univerzitet u Friburgu. PERFORM se fokusira na jačanje istraživačke zajednice u društvenim naukama, na olakšavanje izgradnje sistemskih veza između istraživanja i domena javnih politika, kao i na stvaranje okruženja pogodnog za istraživanja u društvenim naukama. Ostale brojeve podržavaju institucije i organizacije koje takođe prepoznaju interes u podršci istraživačkim aktivnostima u oblasti društvenih istraživanja i javnih politika.</p>' + '<p>Stavovi izneti u okviru MONS projekta ne odražavaju mišljenja i stavove institucija koje pružaju podršku realizaciji Projekta.</p>'
      },

      initiators: {
        title: 'Pokretači MONS platforme',
        content: '<p><b>SeConS grupa za razvojnu inicijativu</b> je nezavisna organizacija stručnjaka, osnovana sa ciljem da doprinese dugoročnom socio-ekonomskom razvoju i poboljšanju životnih uslova pojedinaca i društvenih grupa u Srbiji i regionu. Nastala je 2005. godine kao inicijativa grupe sociologa i sociološkinja koji su se godinama bavili pitanjima društvenog razvoja na univerzitetima i u organizacijama civilnog društva u zemlji i inostranstvu. SeConS danas okuplja interdisciplinarne eksperte i ekspertkinje, koji sprovode empirijska istraživanja, analiziraju politike i procese, izazove i specifične društvene i ekonomske kontekste, gradeći pouzdanu bazu za dalju izradu metodologija, preporuka i mera koje doprinose razvoju i implementaciji nacionalnih, regionalnih i lokalnih politika. SeConS obrazuje, osnažuje i obučava druge organizacije i predstavnike institucija, a kvalitet rada i ekspertiza SeConS-a prepoznati su i izvan granica zemlje.</p>' + '<p><b>Fondacija za razvoj ekonomske nauke FREN</b> osnovana je 2005. godine od strane Ekonomskog fakulteta Univerziteta u Beogradu sa ciljem promocije istraživanja koja su zasnovana na najnovijoj metodologiji i relevantnim podacima. FREN sprovodi nezavisne analize javnih politika na temelju dokaza, kako bi javnost i donosioci odluka bili informisani o raspoloživim opcijama prilikom formulisanja politika i njihovim posledicama. Zahvaljujući kvalitetu i relevantnosti sprovedenih istraživanja, FREN se pozicionirao kao jedan od vodećih think tank-ova u Srbiji i regionu. Ciljevi FREN-a su unapređenje istraživanja u sferi ekonomske i socijalne politike u Srbiji i regionu, omogućavanje pristupa visoko kvalitetnim statističkim i analitičkim podacima za donosioce odluka, kao i širenje savremenog načina razmišljanja o ekonomiji i socijalnoj politici u profesionalnim krugovima i široj javnosti. FREN-ov tim čini više od 40 istraživača i eksperata.</p>'
      },

      management: {
        title: 'MONS tim',
        sections: [{
          title: 'Uređivački odbor',
          people: [{
            name: 'prof. dr Jelena Žarković Rakić',
            title: '',
            img: 'https://api.mons.rs/img/team/jelena.jpg'
          }, {
            name: 'prof. dr Marija Babović',
            title: '',
            img: 'https://api.mons.rs/img/team/marija.jpg'
          }, {
            name: 'prof. dr Mihail Arandarenko',
            title: '',
            img: 'https://api.mons.rs/img/team/arandarenko.jpg'
          }, {
            name: 'prof. dr Slobodan Cvejić',
            title: '',
            img: 'https://api.mons.rs/img/team/cvejic.jpg'
          }, {
            name: 'prof. dr Gorana Krstić',
            title: '',
            img: 'https://api.mons.rs/img/team/krstic.jpg'
          }, {
            name: 'doc. dr Danilo Vuković',
            title: '',
            img: 'https://api.mons.rs/img/team/danilo.jpg'
          }, {
            name: 'dr Lara Lebedinski',
            title: '',
            img: 'https://api.mons.rs/img/team/lara.jpg'
          }]
        }, {
          title: 'Organizacioni tim',
          people: [{
            name: 'Snežana Bajčeta',
            title: 'Koordinatorka komunikacija',
            img: 'https://api.mons.rs/img/team/snezana.jpg'
          }, {
            name: 'Danijela Šever Radovanović',
            title: 'Saradnica za komunikacije',
            img: 'https://api.mons.rs/img/team/danijela.jpg'
          }, {
            name: 'Aleksandar Radivojević',
            title: 'Tehnički urednik',
            img: 'https://api.mons.rs/img/team/aleksandar.jpg'
          }]
        }, {
          title: 'Istraživači asistenti',
          people: [{
            name: 'Nemanja Vuksanović',
            title: 'Istraživač',
            img: 'https://api.mons.rs/img/team/nemanja.jpg'
          }, {
            name: 'Dragan Aleksić',
            title: 'Istraživač',
            img: 'https://api.mons.rs/img/team/dragan.jpg'
          }, {
            name: 'Jovana Obradović',
            title: 'istraživačica',
            img: 'https://api.mons.rs/img/team/jovana.jpg'
          }, {
            name: 'Stefan Stefanović',
            title: 'istraživač',
            img: 'https://api.mons.rs/img/team/stefan.jpg'
          }, {
            name: 'Dragana Savić',
            title: 'istraživačica',
            img: 'https://api.mons.rs/img/team/dragana.jpg'
          }]
        }, {
          title: 'Stažisti',
          people: [{
            name: 'Katarina Veličković',
            title: 'Stažistkinja',
            img: 'https://api.mons.rs/img/team/katarina.jpg'
          }]
        }]
      }
    },

    text: {
      newsletter: 'Prijavite se i budite obavešteni čim izađe novi sadržaj!',
      address_fren: 'Kamenička 6/III 11000 Beograd, Srbija',
      address_secons: 'Alekse Nenadovića 29a, 11000 Beograd, Srbija'
    },

    chapters: {
      15: 'Publikacija je proizvedena u okviru projekta „Reforma javnih finansija - Agenda 2030” koji podržavaju vlade Švajcarske i Nemačke, a sprovodi Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH. Ova publikacija ne predstavlja nužno zvaničan stav vlada Švajcarske i Nemačke ili GIZ.',
      16: 'Ovaj broj MONS-a nastao je u okviru Projekta „Jačanje otpornosti starijih osoba i osoba sa invaliditetom tokom COVID-19 i budućih katastrofa“ koji koordinira Crveni krst Srbije, a podržavaju Evropska unija, Austrijska razvojna agencija i Austrijski Crveni krst.  Ova publikacija izrađena je uz pomoć Evropske unije. Sadržaj ove publikacije je isključiva odgovornost autora i ni na koji način se ne može smatrati da odražava stavove Evropske unije.',
      17: 'Ovaj broj MONS-a je proizveden u saradnji sa UNICEF-om. Sadržaj ne predstavlja nužno zvanične stavove UNICEF-a.'
    }
  },

  en: {
    navigation: {
      home: 'Home',
      about: 'About MONS',
      key_articles: 'Articles',
      initiators: 'Initiators of MONS platform',
      management: 'MONS team',
      aboutAuthors: 'First Editorial Team',
      authors: 'Authors',
      blog: 'Blog',
      video: 'Video',
      infographics: 'Infographics',
      contact: 'Contact'
    },

    description: {
      about: '',
      authors: '',
      blog: '',
      video: '',
      infographics: '',
      contact: ''
    },

    label: {
      publish_date: 'Will be published on',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      phone: 'Phone',
      fax: 'Fax',
      address: 'Address',
      filter: 'Filters',
      options: 'Options',
      editor: 'Issue Editor',
      editors: 'Issue Editors',
      editor_female: 'Issue Editor',
      editors_female: 'Issue Editors',
      theme: 'Theme',
      key: 'Article',
      video: 'Video',
      blog: 'Blog',
      infographic: 'Infographic',
      search: 'Search'
    },

    title: {
      site: 'MONS',
      landing: 'Platform for Monitoring of the social situation in Serbia',
      contact_form: 'Send a message',
      contact: 'Contact',
      timeline: 'Timeline',
      newsletter: 'Like what you see?',
      built: 'Initiators',
      supported: 'Supported by',
      key_articles: 'Articles',
      infographics: 'Infographics'
    },

    placeholder: {
      email: 'jane.doe@email.com',
      subject: 'The subject of the message'
    },

    button: {
      read_all: 'Read all',
      send: 'Send',
      previous_article: 'Previous Article',
      next_article: 'Next Article'
    },

    pages: {
      aboutAuthors: {
        title: 'First Editorial Team',
        content: [{
          name: 'Prof. Jelena Zarkovic Rakic, PhD',
          bio: 'Jelena Zarkovic Rakic is an associate professor at the Faculty of Economics, University of Belgrade and director of the Foundation for the Advancement of Economics (FREN). Her research covers subjects in public and labour economics, with a particular interest in income inequality and poverty, labor supply and the efficiency-equity analyses of tax-benefit systems. She has been involved in a number of national and international research projects. She publishes papers in reputable academic journals in country and abroad, some of which have a very high citation.'
        }, {
          name: 'Prof. Marija Babovic, PhD',
          bio: 'Marija Babovic is a full professor at the Faculty of Philosophy, University of Belgrade and Director of Programmes at SeConS Development Initiative Group.  The main field of her academic interest is economic sociology, and her research and policy analysis focus on issues of socio-economic development, gender equality and social integration of various social groups.  Apart from extensive experience in scientific research and applied research, she has experience in journalism. She was the editor of the scientific journal Sociologija (Sociology) from 2013 to 2015.'
        }, {
          name: 'Prof. Mihail Arandarenko, PhD',
          bio: 'Mihail Arandarenko is a full professor of Labour Economics at the Faculty of Economics, University of Belgrade and Chairman of the Board of the Foundation for the Advancement of Economics (FREN). He obtained his PhD from the University of Belgrade and was a post-doctoral fellow at Collegium Budapest – Institute for Advanced Study in 1999-2000.  He was a Visiting Senior Fellow at  the London School of Economics in 2014-2015. He has published extensively, including two monographs. His research areas include labour markets, employment programs, industrial relations and social policy. He has received various national and international grants for labour market research.'
        }, {
          name: 'Prof. Slobodan Cvejic, PhD',
          bio: 'Prof Slobodan Cvejić is a full professor at the Faculty of Philosophy, University of Belgrade and director of research at SeConS Development Initiative Group.  The main fields of his academic interest and expertise are economic sociology and social research methodology. Most of the research and activities focused on policy analysis he has conducted in fields of social inequality, economic and social development, and social inclusion. Prof Cvejic has participated in numerous research and projects in policy-making in the country and abroad. He is the editor in chief of the scientific journal Sociologija (Sociology).'
        }, {
          name: 'Prof. Gorana Krstic, PhD',
          bio: 'Gorana Krstic is an associate professor at the Faculty of Economics, University of Belgrade and a member of the Board of Directors of the Foundation for the Advancement of Economics (FREN). Her main fields of research are labour markets, particularly the role of informal economy, poverty and inequality in transition countries, and effects of social policy on reducing poverty and inequality. She has mainly participated in regional projects implemented for international organizations. She has published a large number of papers in the country and abroad in renowned scientific journals and some of them are highly cited. She was awarded grants for individual and institutional research which she managed.'
        }, {
          name: 'Danilo Vukovic, PhD',
          bio: 'Danilo Vukovic is an assistant professor at the Faculty of Law, University of Belgrade and a Supervisory board member of SeConS Development Initiative Group. The main fields of his academic interest are empirical sociology of law, social policy in the post-socialist context and civil society.  He conducted research on social accountability and rule of law in Cambodia as LSE (London School of Economics and Political Sciences) fellow. He has extensive experience in cooperating with public institutions, private and consulting sector in the region, particularly in the fields of social protection, youth and civil society.'
        }, {
          name: 'Lara Lebedinski, PhD',
          bio: 'Lara Lebedinski is a Senior Researcher at the Foundation for the Advancement of Economics and an External Associate at the Institute of Economic Sciences. She received her PhD from Bocconi University, Italy. Her main fields of academic interest and activities related to policy analysis are education economics and labor economics. During her career, she has worked as a consultant for UNICEF and the Ministry of Education, Science and Technological Development.'
        }]
      },

      about: {
        title: 'About MONS',
        content: '<p><b>Monitoring social situation in Serbia (MONS)</b> is an online platform, launched jointly by the Foundation for the Advancement of Economics FREN and SeConS Development Initiative Group, in order to better present results of socioeconomic research and increase its significance an impact on processes of adopting public policies.</p>' + '<p>The platform was launched to establish a dialogue between representatives of the academic community, the civil sector, policy creators and decision makers on important social and economic issues in Serbia. <b>MONS highlights important topics which are not included in the “public agenda”, and approaches issues which are already in the public focus in a novel and different way.</b></p>' + '<p>MONS will present one socioeconomic topic on a quarterly basis, to be analyzed comprehensively by experts on the issue, using relevant and reliable sources of information. <b>The platform</b> where knowledge is shared with visitors is interactive, <b>enabling all interested actors to get involved on the blog and provide better insight into issues.</b></p>' + '<p>The platform is also intended for media representatives who strive to inform the public and interpret social reality on the basis of scientifically proven facts.</p>' + '<p>Project MONS was started and supported up until the 9th issue by PERFORM, a project of Swiss Agency for Development and Cooperation (SDC) implemented by HELVETAS Swiss Intercooperation and University of Fribourg. <a href="http://www.perform.network" target="_blank">PERFORM</a> focuses on strengthening the social science research community, facilitating better systemic linkages between social science research and policy makers, and on creating favourable framework conditions for social science research.</p>' + '<p>The views expressed within project MONS do not necessarily represent opinions of the institutions who provide their support to the Project.'
      },

      initiators: {
        title: 'Initiators of MONS platform',
        content: '<p><b>SeConS Development Initiative Group</b> is an independent think-tank organization of experts, established with the aim of contributing to long-term socio-economic development and improvement of living conditions of individuals and social groups in Serbia and the region. It was founded in 2005, as an initiative of a group of sociologists who worked on issues of social development at universities and in other civil society organizations in the country and abroad. Today, SeConS brings together interdisciplinary experts to conduct empirical research, analyse policies and processes, challenges and specific social and economic environments to build a reliable base for further development of methodologies, recommendations and measures to advance the development and implementation of national, regional and local policies. SeConS educates, empowers and trains other organizations and institution representatives, and its quality of work and expertise has been recognized outside country borders as well.</p>' + "<p><b>Foundation for the Advancement of Economics FREN</b> was founded in 2005 by the Faculty of Economics of the University of Belgrade with the aim to promote national and regional policy relevant research based on valid data and sound methodology. FREN conducts independent evidence-based policy analysis in order to inform the public and policy makers about available policy options and their ramifications. Thanks to the quality and relevance of its research, FREN has established itself as one of the leading think – tank organizations in Serbia and the Western Balkans region. FREN's goals are to promote research in the area of economic and social policy in Serbia and the region, provide access to high-quality statistical and analytical data for decision makers, and expand the modern way of thinking about the economy and social policy in professional circles and the general public. FREN's team includes more than 40 researchers and experts.</p>"
      },

      management: {
        title: 'MONS team',
        sections: [{
          title: 'Editorial Board',
          people: [{
            name: 'Prof. Jelena Zarkovic Rakic, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/jelena.jpg'
          }, {
            name: 'Prof. Marija Babovic, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/marija.jpg'
          }, {
            name: 'Prof. Mihail Arandarenko, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/arandarenko.jpg'
          }, {
            name: 'Prof. Slobodan Cvejic, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/cvejic.jpg'
          }, {
            name: 'Prof. Gorana Krstic, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/krstic.jpg'
          }, {
            name: 'Danilo Vukovic, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/danilo.jpg'
          }, {
            name: 'Lara Lebedinski, PhD',
            title: '',
            img: 'https://api.mons.rs/img/team/lara.jpg'
          }]
        }, {
          title: 'Organizational Team',
          people: [{
            name: 'Snezana Bajceta',
            title: 'communications coordinator',
            img: 'https://api.mons.rs/img/team/snezana.jpg'
          }, {
            name: 'Danijela Sever Radovanovic',
            title: 'communications associate',
            img: 'https://api.mons.rs/img/team/danijela.jpg'
          }, {
            name: 'Aleksandar Radivojevic',
            title: 'technical editor',
            img: 'https://api.mons.rs/img/team/aleksandar.jpg'
          }]
        }, {
          title: 'Research Assistants',
          people: [{
            name: 'Nemanja Vuksanovic',
            title: 'researcher',
            img: 'https://api.mons.rs/img/team/nemanja.jpg'
          }, {
            name: 'Dragan Aleksic',
            title: 'researcher',
            img: 'https://api.mons.rs/img/team/dragan.jpg'
          }, {
            name: 'Jovana Obradovic',
            title: 'researcher',
            img: 'https://api.mons.rs/img/team/jovana.jpg'
          }, {
            name: 'Stefan Stefanovic',
            title: 'researcher',
            img: 'https://api.mons.rs/img/team/stefan.jpg'
          }, {
            name: 'Dragana Savic',
            title: 'researcher',
            img: 'https://api.mons.rs/img/team/dragana.jpg'
          }]
        }, {
          title: 'Interns',
          people: [{
            name: 'Katarina Velickovic',
            title: 'intern',
            img: 'https://api.mons.rs/img/team/katarina.jpg'
          }]
        }]
      }
    },

    text: {
      newsletter: 'Subscribe to our newsletter and get notified whenever new content is published!',
      address_fren: 'Kamenicka 6/III 11000 Belgrade, Serbia',
      address_secons: 'Alekse Nenadovica 29a, 11000 Belgrade, Serbia'
    },

    chapters: {
      15: 'This publication was produced within the “Public Finance Reform – 2030 Agenda” project, supported by the Governments of Switzerland and Germany and implemented by the Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH.  The publication does not necessarily represent the official standpoints of the Swiss and German Governments or GIZ.',
      16: 'This edition of MONS has been created as a part of the &quot;Strengthening the immunity of the elderly and persons with disabilities during COVID-19 and future catastrophes&quot; project, coordinated by the Red Cross of Serbia, and supported by the EU, Austrian Development Agency and Red Cross of Austria. This publication has been developed with the support of the European Union. Content of this publication is exclusively its author&#39;s responsibility, and can in no way be considered a stance of the European Union.',
      17: 'This edition of MONS has been developed in cooperation with UNICEF. The content of this edition does not necessarily represent the official views of UNICEF.'
    }
  }
});

/***/ })

},[524]);


// WEBPACK FOOTER //
// static/js/app.4e36fae1cd6717e4bfcc.js